/* eslint-disable */
import { fabric } from 'fabric';

export const BODY_TEMPLATE = `

<div class="hdr">
  <div class="tabs">
    <button class="tab on" id="tab-px" onclick="switchTab('px')">
      <svg viewBox="0 0 20 20" fill="currentColor"><rect x="1" y="1" width="5" height="5" rx=".5"/><rect x="8" y="1" width="5" height="5" rx=".5" opacity=".35"/><rect x="15" y="1" width="5" height="5" rx=".5"/><rect x="1" y="8" width="5" height="5" rx=".5" opacity=".35"/><rect x="8" y="8" width="5" height="5" rx=".5"/><rect x="1" y="15" width="5" height="5" rx=".5"/><rect x="15" y="8" width="5" height="5" rx=".5" opacity=".35"/><rect x="8" y="15" width="5" height="5" rx=".5" opacity=".35"/><rect x="15" y="15" width="5" height="5" rx=".5"/></svg>
      Pixel Art
    </button>
    <button class="tab" id="tab-vc" onclick="switchTab('vc')">
      <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="2" width="7" height="7" rx="1"/><rect x="11" y="2" width="7" height="7" rx="1"/><rect x="2" y="11" width="7" height="7" rx="1"/><rect x="11" y="11" width="7" height="7" rx="1"/></svg>
      Vectoriel
    </button>
  </div>
  <div class="sp"></div>
  <button class="hbtn" onclick="doUndo()" title="Annuler">
    <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor"><path d="M7 4l-5 5 5 5V9h6a4 4 0 010 8H7v2h6A6 6 0 0013 7H7V4z"/></svg>
    Annuler
  </button>
  <button class="hbtn" onclick="openBgModal()">
    <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor"><path d="M2 3a1 1 0 011-1h14a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm2 1v9l3-3 3 3 3-4 3 4V4H4zm8 3a1 1 0 100-2 1 1 0 000 2z"/></svg>
    Image de fond
  </button>
  <button class="hbtn dark" onclick="syncPxToVc()">
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M9.13995 4.56997H11.5799C11.8999 4.01997 12.5899 3.83997 13.1399 4.14997C13.6899 4.46997 13.8699 5.15997 13.5599 5.70997C13.2399 6.25997 12.5499 6.43997 11.9999 6.12997C11.8299 6.02997 11.6799 5.88997 11.5799 5.70997H10.3599C11.9299 6.51997 12.9799 8.08997 13.1299 9.84997C13.6799 10.15 13.8799 10.85 13.5799 11.4C13.2799 11.95 12.5799 12.15 12.0299 11.85C11.4799 11.55 11.2799 10.85 11.5799 10.3C11.6799 10.12 11.8199 9.97997 11.9899 9.86997C11.8299 8.25997 10.6999 6.89997 9.14995 6.43997V6.84997H6.85995V6.43997C5.30995 6.89997 4.18995 8.25997 4.02995 9.86997C4.56995 10.2 4.73995 10.9 4.41995 11.44C4.08995 11.98 3.38995 12.15 2.84995 11.83C2.30995 11.5 2.13995 10.8 2.45995 10.26C2.55995 10.09 2.70995 9.94997 2.88995 9.84997C3.02995 8.08997 4.06995 6.51997 5.63995 5.70997H4.41995C4.09995 6.25997 3.40995 6.43997 2.85995 6.12997C2.30995 5.80997 2.12995 5.11997 2.43995 4.56997C2.75995 4.01997 3.44995 3.83997 3.99995 4.14997C4.16995 4.24997 4.31995 4.38997 4.41995 4.56997H6.85995V3.99997H9.14995V4.56997H9.13995Z" fill="currentColor"/></svg>
    Pixel → Vec
  </button>
  <button class="hbtn dark" onclick="syncVcToPx()">
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 6.03998V2.03998H6" stroke="currentColor" stroke-miterlimit="10"/><path d="M14 6.03998V2.03998H10" stroke="currentColor" stroke-miterlimit="10"/><path d="M14 10.04V14.04H10" stroke="currentColor" stroke-miterlimit="10"/><path d="M2 10.04V14.04H6" stroke="currentColor" stroke-miterlimit="10"/><path d="M11 5H5V11H11V5Z" stroke="currentColor" stroke-miterlimit="10"/></svg>
    Vec → Pixel
  </button>
  <button class="hbtn" onclick="openRtypesAdmin()">
    <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/></svg>
    Paramètres
  </button>
  <div style="position:relative;display:inline-block" id="exp-wrap">
    <button class="hbtn exp-btn" onclick="toggleExportMenu()">
      Export
      <svg width="10" height="10" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>
    </button>
    <div id="exp-menu" style="display:none;position:absolute;right:0;top:calc(100% + 4px);background:var(--white);border:1px solid var(--bd);border-radius:6px;overflow:hidden;min-width:150px;z-index:500;box-shadow:var(--shadow-md)">
      <div style="padding:6px 12px 3px;font-size:9px;color:var(--mu2);letter-spacing:1.2px;text-transform:uppercase;font-weight:700;font-family:'Marianne',sans-serif">Pixel Art</div>
      <div onmousedown="doExport('px','png')" class="exp-item">🖼 PNG</div>
      <div style="height:1px;background:var(--bd);margin:2px 0"></div>
      <div style="padding:6px 12px 3px;font-size:9px;color:var(--mu2);letter-spacing:1.2px;text-transform:uppercase;font-weight:700;font-family:'Marianne',sans-serif">Vectoriel</div>
      <div onmousedown="doExport('vc','png')" class="exp-item">🖼 PNG</div>
      <div onmousedown="doExport('vc','svg')" class="exp-item">✦ SVG</div>
      <div onmousedown="doExport('vc','pdf')" class="exp-item">📄 PDF</div>
    </div>
  </div>
  <input type="file" id="bg-file-in" accept="image/png,image/jpeg,image/webp,application/pdf" style="display:none" onchange="bgFileChosen(this)">
</div>

<div id="mod-bar" class="mod-bar"></div>

<div class="main">

<!-- ═══════════ PIXEL PANE ═══════════ -->
<div id="pane-px" style="display:flex;flex:1;overflow:hidden">
  <div class="side">
    <div class="sec">
      <div class="ttl ttl-row"><span>Hall</span><span class="ttl-meta" id="h-info">Surface : <b>6 000 m²</b></span></div>
      <div class="hbox">
        <div class="hrow">
          <svg class="haxis" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1.5 8H14.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.9199 5.41998L14.4999 7.99998L11.9199 10.58" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.08 10.58L1.5 7.99998L4.08 5.41998" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <input class="hinp" id="hw" type="number" value="100" min="10" max="2000" step="5" onkeydown="if(event.key==='Enter'){hallChanged();this.blur();}"> <span class="hunit">m</span>
          <svg class="haxis" style="margin-left:8px" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1.5V14.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.5799 11.92L7.99992 14.5L5.41992 11.92" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.41992 4.08L7.99992 1.5L10.5799 4.08" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <input class="hinp" id="hh" type="number" value="60" min="10" max="2000" step="5" onkeydown="if(event.key==='Enter'){hallChanged();this.blur();}"> <span class="hunit">m</span>
        </div>
        <div class="hrow">
          <span class="hlabel">1 cellule =</span>
          <select class="hsel" id="hcm" onchange="setCellM(+this.value)">
            <option value="2">2</option>
            <option value="1" selected>1</option>
            <option value="0.5">0,5</option>
            <option value="0.25">0,25</option>
          </select>
          <span class="hunit">m</span>
        </div>
      </div>
    </div>
    <div class="sec">
      <div class="ptgrid">
        <div class="ptbtn on" id="pt-hand"   onclick="setPxTool('hand')"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.53 2.09C7.3 2.18 7.1 2.39 6.7 2.79C6.3 3.19 6.09 3.4 6 3.62C5.88 3.92 5.88 4.26 6 4.56C6.09 4.79 6.29 4.99 6.7 5.39C7.1 5.79 7.31 6 7.53 6.09C7.83 6.21 8.17 6.21 8.47 6.09C8.7 6 8.9 5.8 9.3 5.39C9.7 4.98 9.91 4.78 10 4.56C10.12 4.26 10.12 3.92 10 3.62C9.91 3.39 9.71 3.19 9.3 2.79C8.89 2.39 8.69 2.18 8.47 2.09C8.17 1.97 7.83 1.97 7.53 2.09ZM3.63 6C3.4 6.09 3.2 6.3 2.8 6.7C2.4 7.1 2.19 7.31 2.1 7.53C1.98 7.83 1.98 8.17 2.1 8.47C2.19 8.7 2.4 8.9 2.8 9.3C3.2 9.7 3.41 9.91 3.63 10C3.93 10.12 4.27 10.12 4.57 10C4.8 9.91 5 9.7 5.4 9.3C5.8 8.9 6.01 8.69 6.1 8.47C6.22 8.17 6.22 7.83 6.1 7.53C6.01 7.3 5.81 7.1 5.4 6.7C4.99 6.3 4.79 6.09 4.57 6C4.27 5.88 3.93 5.88 3.63 6ZM10.6 6.7C10.2 7.1 9.99 7.31 9.9 7.53C9.78 7.83 9.78 8.17 9.9 8.47C9.99 8.7 10.2 8.9 10.6 9.3C11 9.7 11.21 9.91 11.43 10C11.73 10.12 12.07 10.12 12.37 10C12.6 9.91 12.8 9.7 13.2 9.3C13.6 8.9 13.81 8.69 13.9 8.47C14.02 8.17 14.02 7.83 13.9 7.53C13.81 7.3 13.6 7.1 13.2 6.7C12.8 6.3 12.59 6.09 12.37 6C12.07 5.88 11.73 5.88 11.43 6C11.2 6.09 11 6.3 10.6 6.7ZM7.53 9.9C7.3 9.99 7.1 10.2 6.7 10.6C6.3 11 6.09 11.21 6 11.43C5.88 11.73 5.88 12.07 6 12.37C6.09 12.6 6.29 12.8 6.7 13.2C7.1 13.6 7.31 13.81 7.53 13.9C7.83 14.02 8.17 14.02 8.47 13.9C8.7 13.81 8.9 13.61 9.3 13.2C9.7 12.79 9.91 12.59 10 12.37C10.12 12.07 10.12 11.73 10 11.43C9.91 11.2 9.71 11 9.3 10.6C8.9 10.2 8.69 9.99 8.47 9.9C8.17 9.78 7.83 9.78 7.53 9.9Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>Main</div>
        <div class="ptbtn"    id="pt-select" onclick="setPxTool('select')"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.5 15.99C8.33 15.99 8.17 15.88 8.12 15.73L6.7 12.24L4.23 15.03C4.08 15.2 3.82 15.21 3.64 15.07C3.55 15 3.5 14.88 3.5 14.76V2.41C3.5 2.18 3.69 2 3.91 2C4.02 2 4.12 2.04 4.2 2.11L13.36 10.34C13.53 10.49 13.55 10.75 13.39 10.92C13.32 11.01 13.2 11.06 13.08 11.06H9.53L10.96 14.61C11.05 14.83 10.94 15.06 10.73 15.15L8.65 15.97C8.65 15.97 8.56 16 8.5 16V15.99ZM6.83 11.05C7.01 11.05 7.16 11.16 7.22 11.31L8.73 15.04L10.04 14.53L8.52 10.79C8.44 10.58 8.54 10.34 8.75 10.25C8.81 10.23 8.85 10.22 8.9 10.22H11.99L4.34 3.35V13.66L6.53 11.2C6.61 11.11 6.73 11.06 6.84 11.06L6.83 11.05Z" fill="currentColor"/></svg>Sélect.</div>
        <div class="ptbtn"    id="pt-pencil"  onclick="setPxTool('pencil')"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.53 2.44C11.11 1.86 12.06 1.86 12.64 2.44L13.57 3.37C14.15 3.95 14.15 4.9 13.57 5.48L6.24 12.81C6.06 12.99 5.84 13.12 5.6 13.19L2.83 13.98C2.49 14.08 2.14 13.88 2.04 13.54C2.01 13.43 2.01 13.3 2.04 13.19L2.83 10.42C2.9 10.18 3.03 9.95 3.21 9.77L10.54 2.44H10.53ZM11.74 3.34C11.66 3.26 11.52 3.26 11.44 3.34L10.36 4.42L11.59 5.65L12.67 4.57C12.75 4.49 12.75 4.35 12.67 4.27L11.74 3.34ZM10.68 6.54L9.45 5.31L4.09 10.67C4.09 10.67 4.05 10.73 4.04 10.76L3.56 12.42L5.22 11.94C5.22 11.94 5.29 11.91 5.31 11.89L10.67 6.53L10.68 6.54Z" fill="currentColor"/></svg>Crayon</div>
        <div class="ptbtn"    id="pt-bucket"  onclick="setPxTool('bucket')"><svg width="16" height="16" viewBox="0 0 13 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.12 0.87C3.97 0.87 2.22 2.61 2.22 4.77H1.36C1.36 2.13 3.49 0 6.12 0C8.76 0 10.89 2.13 10.89 4.77H10.02C10.02 2.61 8.28 0.87 6.12 0.87Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.59 4.5C0.67 4.4 0.79 4.33 0.92 4.33H11.32C11.56 4.33 11.76 4.53 11.76 4.77C11.76 4.8 11.76 4.83 11.76 4.86L10.18 11.98C10.05 12.58 9.51 13 8.91 13H3.36C2.75 13 2.22 12.58 2.09 11.98L0.51 4.86C0.48 4.73 0.51 4.6 0.6 4.5H0.59Z" stroke="currentColor" stroke-miterlimit="10" stroke-linejoin="round"/></svg>Remplir</div>
        <div class="ptbtn"    id="pt-eraser"  onclick="setPxTool('eraser')"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13.6 14.47H4.54L1.24 11.17C0.92 10.85 0.92 10.33 1.24 10.01L9.48 1.77C9.8 1.45 10.32 1.45 10.64 1.77L14.76 5.89C15.08 6.21 15.08 6.73 14.76 7.05L7.34 14.47M12.77 8.95L7.58 3.76" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>Gomme</div>
        <div class="ptbtn"    id="pt-eyedrop" onclick="setPxTool('eyedrop')"><svg width="16" height="16" viewBox="0 0 14 14" fill="none"><path d="M7.21 5.38L1.19 11.39C0.8 11.78 0.5 13.49 0.5 13.49C0.5 13.49 2.2 13.21 2.6 12.8L8.62 6.78" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.92 3.26L10.75 6.09C11.14 6.48 11.14 7.11 10.75 7.51C10.36 7.9 9.73 7.9 9.33 7.51L6.5 4.68C6.11 4.29 6.11 3.66 6.5 3.26C6.89 2.87 7.52 2.87 7.92 3.26Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.07 3.41C8.07 3.41 8.71 3.68 9.23 3.16L10.94 0.95C11.52 0.34 12.48 0.37 13.06 0.95C13.64 1.53 13.66 2.48 13.06 3.07L10.85 4.78C10.36 5.27 10.6 5.94 10.6 5.94M2.61 12.81C2.61 12.81 1.78 13.35 1.22 12.79C0.66 12.23 1.2 11.4 1.2 11.4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>Pipette</div>
        <div class="ptbtn"    id="pt-rect"    onclick="setPxTool('rect')"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="2" y="2" width="12" height="12" rx="1.5" stroke="currentColor"/></svg>Vide</div>
        <div class="ptbtn"    id="pt-frect"   onclick="setPxTool('frect')"><svg width="16" height="16" viewBox="0 0 14 12" fill="none"><rect x="0.5" y="0.5" width="13" height="11" rx="1.5" fill="#CCCCCC" stroke="currentColor"/></svg>Plein</div>
        <div class="ptbtn"    id="pt-sep"     onclick="setPxTool('sep')"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 8.59L6.21 10.38C7 11.71 6.55 13.43 5.22 14.21C3.89 15 2.17 14.55 1.39 13.22C0.6 11.89 1.05 10.17 2.38 9.39C3.26 8.87 4.35 8.87 5.22 9.39L7.01 7.6L2.8 3.38C2.25 2.83 2.25 1.95 2.8 1.4L8 6.61L13.2 1.4C13.75 1.95 13.75 2.83 13.2 3.38L8.99 7.59L10.78 9.38C12.11 8.59 13.83 9.04 14.61 10.37C15.4 11.7 14.95 13.42 13.62 14.2C12.29 14.99 10.57 14.54 9.79 13.21C9.27 12.33 9.27 11.24 9.79 10.37L8 8.58V8.59ZM3.8 13.2C4.57 13.2 5.2 12.57 5.2 11.8C5.2 11.03 4.57 10.4 3.8 10.4C3.03 10.4 2.4 11.03 2.4 11.8C2.4 12.57 3.03 13.2 3.8 13.2ZM12.2 13.2C12.97 13.2 13.6 12.57 13.6 11.8C13.6 11.03 12.97 10.4 12.2 10.4C11.43 10.4 10.8 11.03 10.8 11.8C10.8 12.57 11.43 13.2 12.2 13.2Z" fill="currentColor"/></svg>Séparateur</div>
      </div>
      <div style="margin-top:7px">
        <div style="font-size:10px;color:var(--mu);margin-bottom:4px">Pinceau : <span id="bs-lbl">1</span> cellule(s)</div>
        <input type="range" id="bs" min="1" max="8" value="1" style="width:100%;accent-color:var(--ac)" oninput="document.getElementById('bs-lbl').textContent=this.value">
      </div>
    </div>
    <div class="sec">
      <div class="ttl">Types de zones</div>
      <div id="rtypes"></div>

    </div>
    <div id="pal" style="display:none"></div>

    <div class="sec" id="px-sel-sec" style="display:none">
      <div class="ttl">Sélection</div>
      <div id="px-sel-detail"></div>
    </div>

    <div class="sec">
      <button onclick="clearPx()" style="width:100%;padding:5px;border-radius:4px;background:rgba(248,113,113,.07);border:1px solid rgba(248,113,113,.15);color:#f87171;cursor:pointer;font-size:10px;font-family:'Marianne',system-ui,sans-serif">Effacer tout</button>
    </div>
  </div>

  <div class="px-outer" id="px-outer">
    <div class="rc"></div>
    <canvas class="rh" id="px-rh" height="20"></canvas>
    <canvas class="rv" id="px-rv" width="20"></canvas>
    <div class="carea" id="px-area">
      <div class="px-wrap" id="px-wrap">
        <canvas id="px-bg-c"></canvas>
        <canvas id="px-c"></canvas>
        <canvas id="px-g"></canvas>
      </div>
    </div>
    <div class="tip" id="px-tip" style="pointer-events:none;z-index:200"></div>
  </div>

  <!-- Right panel pixel -->
  <div class="side r">
    <div class="sec">
      <div class="ttl">Zoom</div>
      <div style="display:flex;align-items:center;gap:4px;flex-wrap:nowrap">
        <button class="zbtn" onclick="pxZoomOut()">−</button>
        <button class="zbtn" onclick="pxZoomIn()">+</button>
        <input type="range" id="px-zslider" min="20" max="400" value="100" style="flex:1;min-width:40px;accent-color:var(--ac)" data-zoom="px">
        <span class="zpct" id="px-zpct">—</span>
        <button class="zbtn" onclick="fitPx()" style="font-size:9px;padding:2px 5px">Fit</button>
      </div>
    </div>
    <div class="sec">
      <div class="ttl">Aperçu</div>
      <canvas id="px-prev" width="160" height="100" style="width:100%;border:1px solid var(--bd);border-radius:4px;background:var(--bg3)"></canvas>
    </div>
    <div id="px-leg" style="display:none"></div>
    <div id="px-stats" style="display:none"></div>

    <!-- Section Groupes (partagée px+vc) -->
    <div class="sec" id="groups-sec">
      <div class="ttl">Groupes</div>
      <div id="groups-list" style="display:flex;flex-direction:column;gap:3px;margin-bottom:6px"></div>
      <button onclick="grpAskCreate()" id="grp-create-btn" style="width:100%;padding:6px;border-radius:5px;background:var(--white);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:10px;font-family:inherit">⊞ Grouper la sélection</button>
    </div>

    <!-- Section Versions Moderateurs -->
    <div class="sec" id="mod-sec">
      <div class="ttl">Versions moderateurs</div>

      <!-- Un tab par version : Principal + forks -->
      <div id="px-mod-tabs" style="display:flex;flex-direction:column;gap:2px;margin-bottom:7px"></div>

      <!-- Bouton fork (toujours visible) -->
      <button onclick="modLayerFork()"
        style="width:100%;padding:6px;border-radius:5px;background:var(--white);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:10px;font-family:inherit">
        Forker pour un moderateur...
      </button>

      <!-- Actions sur le calque moderateur actif -->
      <div id="px-mod-actions" style="display:none;flex-direction:column;gap:3px;margin-top:6px">
        <div id="px-mod-active-name" style="font-size:9px;color:var(--mu2);text-align:center;margin-bottom:2px"></div>
        <button onclick="modLayerRenameUI()"
          style="width:100%;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">
          Renommer
        </button>
        <button onclick="modLayerForkFrom()"
          style="width:100%;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">
          Dupliquer ce calque
        </button>
        <button onclick="modLayerAskDelete()"
          style="width:100%;padding:4px;border-radius:4px;background:rgba(248,113,113,.07);border:1px solid rgba(248,113,113,.15);color:#f87171;cursor:pointer;font-size:9px;font-family:inherit">
          Supprimer
        </button>
        <!-- Confirmation inline (evite confirm() bloque dans iframe) -->
        <div id="px-mod-del-confirm" style="display:none;background:rgba(248,113,113,.06);border:1px solid rgba(248,113,113,.2);border-radius:5px;padding:7px">
          <div style="font-size:9px;color:#f87171;margin-bottom:5px">Supprimer cette version ? Action irreversible.</div>
          <div style="display:flex;gap:4px">
            <button onclick="modHideForms()"
              style="flex:1;padding:3px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">
              Annuler
            </button>
            <button onclick="modLayerDeleteConfirmed()"
              style="flex:1;padding:3px;border-radius:4px;background:rgba(248,113,113,.2);border:1px solid rgba(248,113,113,.4);color:#f87171;cursor:pointer;font-size:9px;font-family:inherit;font-weight:600">
              Supprimer
            </button>
          </div>
        </div>
      </div>

      <!-- Formulaire inline nom (fork / renommage) — evite prompt() bloque dans iframe -->
      <div id="px-mod-name-form" style="display:none;margin-top:7px;background:var(--bg3);border:1px solid var(--bd);border-radius:6px;padding:8px">
        <div id="px-mod-name-form-title" style="font-size:10px;color:var(--mu);margin-bottom:5px">Nom</div>
        <input id="px-mod-name-inp" class="minp" placeholder="Ex : Marie, Equipe A..." style="margin-bottom:6px">
        <div style="display:flex;gap:4px">
          <button onclick="modNameFormCancel()"
            style="flex:1;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">
            Annuler
          </button>
          <button onclick="modNameFormConfirm()"
            style="flex:1;padding:4px;border-radius:4px;background:var(--ac);border:none;color:#fff;cursor:pointer;font-size:9px;font-family:inherit;font-weight:600">
            Confirmer
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════ VECTOR PANE ═══════════ -->
<div id="pane-vc" style="display:none;flex:1;overflow:hidden">
  <div class="side">
    <div class="sec">
      <div class="ttl ttl-row"><span>Hall</span><span class="ttl-meta" id="vc-h-info">Surface : <b>6 000 m²</b></span></div>
      <div class="hbox">
        <div class="hrow">
          <svg class="haxis" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1.5 8H14.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.9199 5.41998L14.4999 7.99998L11.9199 10.58" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.08 10.58L1.5 7.99998L4.08 5.41998" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span class="hinp hinp-ro" id="vc-hw">100</span> <span class="hunit">m</span>
          <svg class="haxis" style="margin-left:8px" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1.5V14.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.5799 11.92L7.99992 14.5L5.41992 11.92" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.41992 4.08L7.99992 1.5L10.5799 4.08" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span class="hinp hinp-ro" id="vc-hh">60</span> <span class="hunit">m</span>
        </div>
        <div class="hinfo">1m = <b id="vc-mpx">?</b>px</div>
      </div>
    </div>
    <div class="sec">
      <div class="tgrid">
        <div class="tbtn on" id="vt-select" onclick="setVcTool('select')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 3l14 9-7 1-4 7z"/></svg>Sélection</div>
        <div class="tbtn"    id="vt-hand"   onclick="setVcTool('hand')"><svg viewBox="0 0 16 16" fill="none"><path d="M7.53 2.09C7.3 2.18 7.1 2.39 6.7 2.79C6.3 3.19 6.09 3.4 6 3.62C5.88 3.92 5.88 4.26 6 4.56C6.09 4.79 6.29 4.99 6.7 5.39C7.1 5.79 7.31 6 7.53 6.09C7.83 6.21 8.17 6.21 8.47 6.09C8.7 6 8.9 5.8 9.3 5.39C9.7 4.98 9.91 4.78 10 4.56C10.12 4.26 10.12 3.92 10 3.62C9.91 3.39 9.71 3.19 9.3 2.79C8.89 2.39 8.69 2.18 8.47 2.09C8.17 1.97 7.83 1.97 7.53 2.09ZM3.63 6C3.4 6.09 3.2 6.3 2.8 6.7C2.4 7.1 2.19 7.31 2.1 7.53C1.98 7.83 1.98 8.17 2.1 8.47C2.19 8.7 2.4 8.9 2.8 9.3C3.2 9.7 3.41 9.91 3.63 10C3.93 10.12 4.27 10.12 4.57 10C4.8 9.91 5 9.7 5.4 9.3C5.8 8.9 6.01 8.69 6.1 8.47C6.22 8.17 6.22 7.83 6.1 7.53C6.01 7.3 5.81 7.1 5.4 6.7C4.99 6.3 4.79 6.09 4.57 6C4.27 5.88 3.93 5.88 3.63 6ZM10.6 6.7C10.2 7.1 9.99 7.31 9.9 7.53C9.78 7.83 9.78 8.17 9.9 8.47C9.99 8.7 10.2 8.9 10.6 9.3C11 9.7 11.21 9.91 11.43 10C11.73 10.12 12.07 10.12 12.37 10C12.6 9.91 12.8 9.7 13.2 9.3C13.6 8.9 13.81 8.69 13.9 8.47C14.02 8.17 14.02 7.83 13.9 7.53C13.81 7.3 13.6 7.1 13.2 6.7C12.8 6.3 12.59 6.09 12.37 6C12.07 5.88 11.73 5.88 11.43 6C11.2 6.09 11 6.3 10.6 6.7ZM7.53 9.9C7.3 9.99 7.1 10.2 6.7 10.6C6.3 11 6.09 11.21 6 11.43C5.88 11.73 5.88 12.07 6 12.37C6.09 12.6 6.29 12.8 6.7 13.2C7.1 13.6 7.31 13.81 7.53 13.9C7.83 14.02 8.17 14.02 8.47 13.9C8.7 13.81 8.9 13.61 9.3 13.2C9.7 12.79 9.91 12.59 10 12.37C10.12 12.07 10.12 11.73 10 11.43C9.91 11.2 9.71 11 9.3 10.6C8.9 10.2 8.69 9.99 8.47 9.9C8.17 9.78 7.83 9.78 7.53 9.9Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>Main</div>
        <div class="tbtn"    id="vt-stand"  onclick="setVcTool('stand')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>Stand</div>
        <div class="tbtn"    id="vt-text"   onclick="setVcTool('text')"><svg viewBox="0 0 16 16" fill="none"><path d="M12.71 3H3.29C2.97 3 2.7 3.26 2.7 3.59V5.35C2.7 5.67 2.96 5.94 3.29 5.94C3.62 5.94 3.88 5.68 3.88 5.35V4.17H7.41V11.82H6.23C5.91 11.82 5.64 12.08 5.64 12.41C5.64 12.74 5.9 13 6.23 13H9.76C10.08 13 10.35 12.74 10.35 12.41C10.35 12.08 10.09 11.82 9.76 11.82H8.58V4.17H12.11V5.35C12.11 5.67 12.37 5.94 12.7 5.94C13.03 5.94 13.29 5.68 13.29 5.35V3.59C13.29 3.27 13.03 3 12.7 3" fill="currentColor"/></svg>Texte</div>
        <div class="tbtn"    id="vt-aisle"  onclick="setVcTool('aisle')"><svg viewBox="0 0 16 16" fill="none"><path d="M3 13H15" stroke="currentColor" stroke-linecap="round"/><path d="M3 8H15" stroke="currentColor" stroke-linecap="round" stroke-dasharray="2 2"/><path d="M3 3L15 3" stroke="currentColor" stroke-linecap="round"/></svg>Allée</div>
        <div class="tbtn"    id="vt-wall"   onclick="setVcTool('wall')"><svg viewBox="0 0 16 16" fill="none"><path d="M14.15 3H1.85C1.64 3 1.47 3.17 1.47 3.38V12.61C1.47 12.82 1.64 12.99 1.85 12.99H14.16C14.37 12.99 14.54 12.82 14.54 12.61V3.38C14.54 3.17 14.37 3 14.16 3H14.15ZM5.31 9.15V6.84H10.69V9.15H5.31ZM2.23 9.15V6.84H4.54V9.15H2.23ZM11.46 6.85H13.77V9.16H11.46V6.85ZM13.77 6.08H8.39V3.77H13.77V6.08ZM7.62 3.77V6.08H2.23V3.77H7.61H7.62ZM2.23 9.92H7.61V12.23H2.23V9.92ZM8.38 12.23V9.92H13.76V12.23H8.38Z" fill="currentColor"/></svg>Mur</div>
        <div class="tbtn"    id="vt-meas"   onclick="setVcTool('meas')"><svg viewBox="0 0 16 16" fill="none"><path d="M2.35 10.98C1.71 10.98 1.2 10.5 1.2 9.91V6.09C1.2 5.5 1.72 5.02 2.35 5.02H13.64C14.28 5.02 14.79 5.5 14.79 6.09V9.91C14.79 10.5 14.27 10.98 13.64 10.98H2.35ZM2.35 10.11H13.76L13.9 9.98L13.93 9.93V6.09L13.53 6.06L13.72 5.89H12.25V8.43H11.38V5.88H9.71V7.79H8.84V5.88H7.17V8.43H6.3V5.88H4.63V7.79H3.76V5.88H2.27L2.12 5.98L2.07 6.04V9.9L2.47 9.96L2.29 10.09H2.26H2.36L2.35 10.11Z" fill="currentColor"/></svg>Mesure</div>
      </div>
    </div>
    <div class="sec">
      <div class="ttl">Types de zones</div>
      <div id="vc-rtypes"></div>
    </div>
    <!-- vc-layers-list kept hidden for internal use -->
    <div id="vc-layers-list" style="display:none"></div>
  </div>



  <div id="vc-outer">
    <div class="rc"></div>
    <canvas class="rh" id="vc-rh" height="20"></canvas>
    <canvas class="rv" id="vc-rv" width="20"></canvas>
    <div id="vc-area">
      <div class="vc-wrap" id="vc-wrap"><canvas id="vc-c"></canvas></div>
      <div class="tip" id="vc-tip" style="pointer-events:none;z-index:200"></div>
      <div class="sbar"><div class="sline"></div><span id="vc-sbar">?m</span></div>
    </div>
  </div>

  <div class="side r">
    <div class="sec">
      <div class="ttl">Zoom</div>
      <div style="display:flex;align-items:center;gap:4px;flex-wrap:nowrap">
        <button class="zbtn" onclick="vcZoomOut()">−</button>
        <button class="zbtn" onclick="vcZoomIn()">+</button>
        <input type="range" id="vc-zslider-r" min="5" max="400" value="100" style="flex:1;min-width:40px;accent-color:var(--ac)" data-zoom="vc">
        <span class="zpct" id="vc-zpct">—</span>
        <button class="zbtn" onclick="fitVc()" style="font-size:9px;padding:2px 5px">Fit</button>
      </div>
    </div>
    <div class="sec">
      <div class="ttl">Stand sélectionné</div>
      <div id="vc-detail"><div class="hint">✓ Cliquez un stand pour ses détails</div></div>
    </div>
    <div class="sec" id="vc-exp-sec">
      <div class="ttl" id="vc-exp-title">Exposants</div>
      <input class="sinp" id="vc-search" placeholder="Rechercher&#8230;" oninput="renderExp()">
      <div id="vc-explist" style="max-height:220px;overflow-y:auto;padding-right:2px"></div>
    </div>

    <!-- Versions moderateurs (meme panel que cote Pixel, colonne droite) -->
    <div class="sec">
      <div class="ttl">Versions moderateurs</div>
      <div id="vc-mod-tabs" style="display:flex;flex-direction:column;gap:2px;margin-bottom:7px"></div>
      <button onclick="modLayerFork()"
        style="width:100%;padding:6px;border-radius:5px;background:var(--white);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:10px;font-family:inherit">
        Forker pour un moderateur...
      </button>
      <div id="vc-mod-actions" style="display:none;flex-direction:column;gap:3px;margin-top:6px">
        <div id="vc-mod-active-name" style="font-size:9px;color:var(--mu2);text-align:center;margin-bottom:2px"></div>
        <button onclick="modLayerRenameUI()"
          style="width:100%;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">
          Renommer
        </button>
        <button onclick="modLayerForkFrom()"
          style="width:100%;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">
          Dupliquer ce calque
        </button>
        <button onclick="modLayerAskDelete()"
          style="width:100%;padding:4px;border-radius:4px;background:rgba(248,113,113,.07);border:1px solid rgba(248,113,113,.15);color:#f87171;cursor:pointer;font-size:9px;font-family:inherit">
          Supprimer
        </button>
        <div id="vc-mod-del-confirm" style="display:none;background:rgba(248,113,113,.06);border:1px solid rgba(248,113,113,.2);border-radius:5px;padding:7px">
          <div style="font-size:9px;color:#f87171;margin-bottom:5px">Supprimer cette version ? Action irreversible.</div>
          <div style="display:flex;gap:4px">
            <button onclick="modHideForms()"
              style="flex:1;padding:3px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">
              Annuler
            </button>
            <button onclick="modLayerDeleteConfirmed()"
              style="flex:1;padding:3px;border-radius:4px;background:rgba(248,113,113,.2);border:1px solid rgba(248,113,113,.4);color:#f87171;cursor:pointer;font-size:9px;font-family:inherit;font-weight:600">
              Supprimer
            </button>
          </div>
        </div>
      </div>
      <div id="vc-mod-name-form" style="display:none;margin-top:7px;background:var(--bg3);border:1px solid var(--bd);border-radius:6px;padding:8px">
        <div id="vc-mod-name-form-title" style="font-size:10px;color:var(--mu);margin-bottom:5px">Nom</div>
        <input id="vc-mod-name-inp" class="minp" placeholder="Ex : Marie, Equipe A..." style="margin-bottom:6px">
        <div style="display:flex;gap:4px">
          <button onclick="modNameFormCancel()"
            style="flex:1;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">
            Annuler
          </button>
          <button onclick="modNameFormConfirm()"
            style="flex:1;padding:4px;border-radius:4px;background:var(--ac);border:none;color:#fff;cursor:pointer;font-size:9px;font-family:inherit;font-weight:600">
            Confirmer
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

</div><!-- /main -->

<div class="stbar">
  <span class="sti">Mode : <b id="st-mode">Pixel Art</b></span>
  <span class="sti">Outil : <b id="st-tool">Main</b></span>
  <span class="sti" id="st-px-stats"></span>
  <span class="sti" id="st-vc-info" style="display:none">Stands : <b id="st-stands">0</b></span>
  <span class="sti" id="st-vc-asgn" style="display:none">Assignés : <b id="st-asgn">0</b></span>
  <span class="sti">Curseur : <b id="st-cur">—</b></span>
</div>

<!-- ═══════════ MODALS ═══════════ -->

<!-- Modal Admin Types de Zones -->
<div class="mover" id="m-rtypes">
  <div class="modal" style="width:520px;max-height:80vh;overflow-y:auto">
    <h3>⚙ Administration des types de zones</h3>
    <p style="margin-bottom:12px">Gérez les types et associez un modérateur SaaS à chaque zone.</p>

    <!-- Liste des types existants -->
    <div id="rtypes-list" style="display:flex;flex-direction:column;gap:6px;margin-bottom:12px"></div>

    <!-- Formulaire ajout/édition -->
    <div id="rtype-form" style="background:var(--bg);border:1px solid var(--bd);border-radius:8px;padding:12px;margin-bottom:10px">
      <div style="font-size:11px;color:var(--mu);margin-bottom:8px" id="rtype-form-title">Nouveau type</div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:8px">
        <div>
          <div style="font-size:10px;color:var(--mu);margin-bottom:3px">Nom du type</div>
          <input class="minp" id="rt-name" placeholder="ex: VIP, Sponsor…" style="margin:0">
          <div style="font-size:10px;color:var(--mu);margin:8px 0 3px">Custom Name</div>
          <input class="minp" id="rt-custom-name" placeholder="Custom Name" style="margin:0">
        </div>
        <div>
          <div style="font-size:10px;color:var(--mu);margin-bottom:3px">Couleur</div>
          <div style="display:flex;gap:6px;align-items:center">
            <input type="color" id="rt-color" value="#5b6cf9" style="width:38px;height:32px;border:none;border-radius:6px;cursor:pointer;background:none;padding:0" oninput="document.getElementById('rt-color-hex').value=this.value">
            <input class="minp" id="rt-color-hex" placeholder="#5b6cf9" style="margin:0;flex:1" oninput="syncColorHex()">
          </div>
        </div>
      </div>
      <div style="margin-bottom:8px">
        <div style="font-size:10px;color:var(--mu);margin-bottom:3px">Modérateur assigné</div>
        <input class="minp" id="rt-mod-name" placeholder="Nom du modérateur" style="margin:0 0 6px 0">
        <input class="minp" id="rt-mod-email" placeholder="Email du modérateur" style="margin:0 0 6px 0" type="email">
        <input class="minp" id="rt-mod-id" placeholder="ID utilisateur SaaS (optionnel)" style="margin:0">
      </div>
      <div style="display:flex;gap:6px;justify-content:flex-end">
        <button class="mbtn sec" onclick="rtypeCancelEdit()" id="rt-cancel-btn" style="display:none">Annuler</button>
        <button class="mbtn pri" onclick="rtypeSave()" id="rt-save-btn">+ Ajouter</button>
      </div>
    </div>

    <div class="mact">
      <button class="mbtn sec" onclick="closeM('m-rtypes')">Fermer</button>
    </div>
  </div>
</div>
<div class="mover" id="m-stand">
  <div class="modal">
    <h3>Nouveau stand</h3><p>Numéro et type du stand</p>
    <input class="minp" id="m-num" placeholder="Numéro (ex: A-01)">
    <select class="minp" id="m-type" style="cursor:pointer"></select>
    <div style="background:var(--bg);border:1px solid var(--bd);border-radius:4px;padding:6px;font-size:10px;color:var(--mu)" id="m-dims"></div>
    <div class="mact">
      <button class="mbtn sec" onclick="closeM('m-stand')">Annuler</button>
      <button class="mbtn pri" onclick="confirmStand()">Créer</button>
    </div>
  </div>
</div>

<!-- Modal Édition stand vectoriel -->
<div class="mover" id="m-stand-edit">
  <div class="modal" style="width:320px">
    <h3>&#9999; Modifier le stand</h3>
    <p>Informations du stand</p>
    <div style="font-size:10px;color:var(--mu);margin-bottom:3px">Numéro de stand</div>
    <input class="minp" id="se-num" placeholder="Ex: A-01">
    <div style="font-size:10px;color:var(--mu);margin-bottom:3px">Hall</div>
    <input class="minp" id="se-hall" placeholder="Ex: Hall 11, Pavillon B…">
    <div style="font-size:10px;color:var(--mu);margin-bottom:3px">Type de zone</div>
    <select class="minp" id="se-type" style="cursor:pointer"></select>
    <div class="mact">
      <button class="mbtn sec" onclick="closeM('m-stand-edit')">Annuler</button>
      <button class="mbtn pri" onclick="confirmStandEdit()">Enregistrer</button>
    </div>
  </div>
</div>

<!-- Modal Création groupe -->
<div class="mover" id="m-grp">
  <div class="modal">
    <h3>Nouveau groupe</h3><p>Nom et type de zone</p>
    <input class="minp" id="mg-name" placeholder="Ex: Pavillon A...">
    <select class="minp" id="mg-type" style="cursor:pointer"></select>
    <div style="background:var(--bg);border:1px solid var(--bd);border-radius:4px;padding:6px;font-size:10px;color:var(--mu)" id="mg-dims"></div>
    <div class="mact">
      <button class="mbtn sec" onclick="closeM('m-grp')">Annuler</button>
      <button class="mbtn pri" onclick="confirmGroupCreate()">Créer</button>
    </div>
  </div>
</div>

<!-- Modal Édition groupe -->
<div class="mover" id="m-grp-edit">
  <div class="modal" style="width:320px">
    <h3>&#9999; Modifier le groupe</h3>
    <p>Informations du groupe</p>
    <div style="font-size:10px;color:var(--mu);margin-bottom:3px">Nom du groupe</div>
    <input class="minp" id="ge-name" placeholder="Ex: Pavillon A...">
    <div style="font-size:10px;color:var(--mu);margin-bottom:3px">Type de zone</div>
    <select class="minp" id="ge-type" style="cursor:pointer"></select>
    <div class="mact">
      <button class="mbtn sec" onclick="closeM('m-grp-edit')">Annuler</button>
      <button class="mbtn pri" onclick="confirmGroupEdit()">Enregistrer</button>
    </div>
  </div>
</div>

<div class="mover" id="m-text">
  <div class="modal">
    <h3>Texte</h3><p>Calque Annotations</p>
    <input class="minp" id="m-txt" placeholder="Votre texte…">
    <select class="minp" id="m-tsz" style="cursor:pointer">
      <option value="10">Petit</option><option value="14" selected>Normal</option>
      <option value="22">Grand</option><option value="32">Titre</option>
    </select>
    <div class="mact">
      <button class="mbtn sec" onclick="closeM('m-text')">Annuler</button>
      <button class="mbtn pri" onclick="confirmText()">Ajouter</button>
    </div>
  </div>
</div>

<!-- Modal Image de Fond -->
<div class="mover" id="m-bg">
  <div class="modal" style="width:340px">
    <h3>🖼 Image de fond</h3>

    <!-- ── Vue IMPORT (aucune image chargée ou changement) ── -->
    <div id="bg-import-view">
      <p>Chargez un plan existant comme calque de référence, affiché sous tous les calques.</p>
      <div class="bg-drop" id="bg-drop"
        onclick="document.getElementById('bg-file-in').click()"
        ondragover="event.preventDefault();this.classList.add('over')"
        ondragleave="this.classList.remove('over')"
        ondrop="event.preventDefault();this.classList.remove('over');bgHandleDrop(event.dataTransfer.files[0])">
        <em>🗺</em>
        <p id="bg-drop-txt">Cliquer ou déposer une image ici<br><span style="color:var(--mu2)">PNG · JPG · WebP</span></p>
      </div>
      <img id="bg-thumb" class="bg-preview" alt="aperçu">
      <div class="bg-fields" id="bg-fields">
        <div class="bg-row">
          Largeur réelle
          <input class="bginp" id="bg-rw" type="number" value="100" min="1" max="5000" step="0.5"> m
        </div>
        <div class="bg-row">
          Hauteur réelle
          <input class="bginp" id="bg-rh" type="number" value="60" min="1" max="5000" step="0.5"> m
        </div>
        <div class="bg-row" style="margin-top:3px">
          Opacité
          <input type="range" id="bg-init-op" min="5" max="100" value="70"
            style="flex:1;accent-color:var(--pur);margin:0 7px"
            oninput="document.getElementById('bg-init-op-lbl').textContent=this.value+'%'">
          <span id="bg-init-op-lbl" style="font-size:10px;color:var(--tx);min-width:28px">70%</span>
        </div>
        <label style="display:flex;align-items:center;gap:7px;font-size:10px;color:var(--mu);cursor:pointer;margin-top:5px">
          <input type="checkbox" id="bg-sync" checked style="accent-color:var(--ac)">
          Synchroniser les dimensions du hall
        </label>
      </div>
      <div class="mact">
        <button class="mbtn sec" onclick="bgModalClose()">Annuler</button>
        <button class="mbtn pur" id="bg-apply-btn" onclick="bgApply()" style="display:none">Appliquer</button>
      </div>
    </div>

    <!-- ── Vue ÉDITION (image déjà chargée) ── -->
    <div id="bg-edit-view" style="display:none">
      <img id="bg-edit-thumb" style="width:100%;height:80px;object-fit:contain;border-radius:5px;border:1px solid var(--bd);background:var(--bg3);margin-bottom:10px">
      <div class="bg-fields show" style="margin-bottom:8px">
        <div class="bg-row">
          Largeur réelle
          <input class="bginp" id="bg-edit-rw" type="number" min="1" max="5000" step="0.5"
            oninput="bgPreviewResize()"> m
        </div>
        <div class="bg-row">
          Hauteur réelle
          <input class="bginp" id="bg-edit-rh" type="number" min="1" max="5000" step="0.5"
            oninput="bgPreviewResize()"> m
        </div>
        <div class="bg-row" style="margin-top:2px">
          <label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:10px">
            <input type="checkbox" id="bg-edit-lock-ratio" checked style="accent-color:var(--pur)">
            Garder les proportions
          </label>
        </div>
      </div>
      <div style="border-top:1px solid var(--bd);padding-top:8px;margin-bottom:8px">
        <div style="font-size:10px;font-weight:600;color:var(--mu);margin-bottom:6px">Opacité des calques</div>
        <div class="bg-row" style="margin-bottom:4px">
          <span style="font-size:10px;min-width:50px;color:var(--pur)">● Fond</span>
          <input type="range" id="mbg-op-fond" min="5" max="100" value="70"
            style="flex:1;accent-color:var(--pur);margin:0 7px"
            oninput="bgSetOp(+this.value)">
          <span id="mbg-op-fond-lbl" style="font-size:10px;color:var(--tx);min-width:32px;text-align:right">70%</span>
        </div>
        <div class="bg-row">
          <span style="font-size:10px;min-width:50px;color:var(--ac)">● Dessin</span>
          <input type="range" id="mbg-op-dessin" min="5" max="100" value="100"
            style="flex:1;accent-color:var(--ac);margin:0 7px"
            oninput="pxSetOp(+this.value)">
          <span id="mbg-op-dessin-lbl" style="font-size:10px;color:var(--tx);min-width:32px;text-align:right">100%</span>
        </div>
      </div>
      <div class="mact">
        <button class="mbtn sec" onclick="bgModalClose()">Annuler</button>
        <button class="mbtn red" onclick="bgRemove()">🗑 Supprimer</button>
        <button class="mbtn sec" onclick="bgShowImport()" style="font-size:10px">Changer…</button>
        <button class="mbtn pur" onclick="bgApplyResize()">Appliquer</button>
      </div>
    </div>
  </div>
</div>

<!-- Context Menu -->
<div id="ctx-menu" style="display:none;position:fixed;z-index:2000;min-width:160px;background:#fff;border:1px solid #d0d0d0;border-radius:6px;box-shadow:0 4px 16px rgba(0,0,0,.15);padding:4px 0;font-family:'Marianne',system-ui,sans-serif;font-size:11px"></div>
`;

export function createFloorMapEngine(containerEl, expos) {

  // Patch getElementById to scope lookups to the container first
  const _origGetById = document.getElementById.bind(document);
  document.getElementById = function(id) { return containerEl.querySelector('#' + id) || _origGetById(id); };

// ═══════════════════════════════════════
// ÉTAT GLOBAL
// ═══════════════════════════════════════
var hallW=100, hallH=60, cellM=1;
var pxPerM=8;

// ── Calques Modérateurs ─────────────────────────────────────────
// Chaque calque représente un agencement indépendant travaillé
// par un modérateur. Inspiré des onglets Excel.
var MOD_LAYERS=[]; // [{id, name, grid, sepH, sepV}]
var activeModLayer=0; // index du calque actif

function numCols(){ return Math.round(hallW/cellM); }
function numRows(){ return Math.round(hallH/cellM); }
function mToPx(m){ return m*pxPerM; }
function pxToM(p){ return p/pxPerM; }
// Formate une valeur en metres avec le bon nombre de decimales selon cellM
function fmtM(v){
  if(cellM >= 1)   return (+v).toFixed(1);
  if(cellM >= 0.5) return (+v).toFixed(1);  // 0.5 -> .0 ou .5, 1 decimale suffit
  if(cellM >= 0.25) return (+v).toFixed(2); // 0.25 -> besoin de 2 decimales
  return (+v).toFixed(2);
}

var DEFAULT_RTYPES=[
  {key:'aisle', color:'#9ca3af', name:'Allée'},
  {key:'wall',  color:'#4b5563', name:'Mur'}
];
var RTYPES=DEFAULT_RTYPES.map(function(r){return {key:r.key,color:r.color,name:r.name};});
var _rtypeEditKey=null; // clé en cours d'édition
function typeToColor(t){ var r=RTYPES.find(function(r){return r.key===t;}); return r?r.color:'#5b6cf9'; }
function colorToType(c){ var r=RTYPES.find(function(r){return r.color===c;}); return r?r.key:(RTYPES.length>0?RTYPES[0].key:'standard'); }

function openRtypesAdmin(){
  _rtypeEditKey=null;
  document.getElementById('rt-save-btn').textContent='+ Ajouter';
  document.getElementById('rt-cancel-btn').style.display='none';
  document.getElementById('rtype-form-title').textContent='Nouveau type';
  rtypeClearForm(); renderRtypesList(); openM('m-rtypes');
}

function renderRtypesList(){
  var locked=['aisle','wall'];
  document.getElementById('rtypes-list').innerHTML=RTYPES.map(function(r){
    var isLocked=locked.indexOf(r.key)>=0;
    var modInfo=r.mod&&r.mod.name
      ? '<span style="color:var(--ac);font-size:10px">'+String.fromCodePoint(0x1F464)+' '+r.mod.name+(r.mod.email?' ('+r.mod.email+')':'')+'</span>'
      : '<span style="color:var(--mu2);font-size:10px;font-style:italic">Aucun modérateur</span>';
    return '<div id="rtype-row-'+r.key+'" style="border-radius:7px;overflow:hidden;border:1px solid var(--bd)">'
      // Ligne principale
      +'<div style="display:flex;align-items:center;gap:8px;padding:8px 10px;background:var(--bg)">'
        +'<div style="width:14px;height:14px;border-radius:3px;background:'+r.color+';flex-shrink:0"></div>'
        +'<div style="flex:1;min-width:0">'
          +'<div style="font-size:11px;font-weight:600;color:var(--tx)">'+r.name+'</div>'
          +'<div>'+modInfo+'</div>'
        +'</div>'
        +'<button data-edit="'+r.key+'" style="background:var(--white);border:1px solid var(--bd);border-radius:5px;color:var(--mu);padding:3px 8px;cursor:pointer;font-size:10px;font-family:inherit">Éditer</button>'
        +(!isLocked?'<button data-del="'+r.key+'" style="background:rgba(239,68,68,.1);border:1px solid rgba(239,68,68,.2);border-radius:5px;color:#ef4444;padding:3px 8px;cursor:pointer;font-size:10px;font-family:inherit">✕</button>':'')
      +'</div>'
      // Zone de confirmation inline (cachée par défaut)
      +(!isLocked?'<div id="rtype-confirm-'+r.key+'" style="display:none;padding:8px 10px;background:rgba(239,68,68,.06);border-top:1px solid rgba(239,68,68,.2)">'
        +'<div id="rtype-confirm-msg-'+r.key+'" style="font-size:10px;color:#f87171;margin-bottom:6px"></div>'
        +'<div id="rtype-move-row-'+r.key+'" style="display:none;margin-bottom:6px">'
          +'<label style="font-size:9px;color:var(--mu);margin-bottom:3px;display:block">Transférer les pixels vers :</label>'
          +'<select id="rtype-move-target-'+r.key+'" style="width:100%;padding:3px 4px;border-radius:4px;background:var(--bg2);border:1px solid var(--bd);color:var(--fg);font-size:10px;font-family:inherit"></select>'
        +'</div>'
        +'<div style="display:flex;gap:6px">'
          +'<button data-confirm-cancel="'+r.key+'" style="flex:1;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:10px;font-family:inherit">Annuler</button>'
          +'<button data-move-ok="'+r.key+'" style="flex:1;padding:4px;border-radius:4px;background:rgba(59,130,246,.15);border:1px solid rgba(59,130,246,.4);color:#3b82f6;cursor:pointer;font-size:10px;font-family:inherit;font-weight:600;display:none">Transférer</button>'
          +'<button data-confirm-ok="'+r.key+'" style="flex:1;padding:4px;border-radius:4px;background:rgba(239,68,68,.2);border:1px solid rgba(239,68,68,.4);color:#ef4444;cursor:pointer;font-size:10px;font-family:inherit;font-weight:600">Supprimer</button>'
        +'</div>'
      +'</div>':'')
    +'</div>';
  }).join('');

  // Listeners — Éditer
  document.querySelectorAll('#rtypes-list [data-edit]').forEach(function(btn){
    btn.addEventListener('click',function(){ rtypeEdit(btn.dataset.edit); });
  });
  // Listeners — Afficher la confirmation inline
  document.querySelectorAll('#rtypes-list [data-del]').forEach(function(btn){
    btn.addEventListener('click',function(){ rtypeAskDelete(btn.dataset.del); });
  });
  // Listeners — Annuler la confirmation
  document.querySelectorAll('#rtypes-list [data-confirm-cancel]').forEach(function(btn){
    btn.addEventListener('click',function(){ rtypeHideConfirm(btn.dataset.confirmCancel); });
  });
  // Listeners — Confirmer la suppression
  document.querySelectorAll('#rtypes-list [data-confirm-ok]').forEach(function(btn){
    btn.addEventListener('click',function(){ rtypeDelete(btn.dataset.confirmOk); });
  });
  // Listeners — Transférer les pixels vers un autre type puis supprimer
  document.querySelectorAll('#rtypes-list [data-move-ok]').forEach(function(btn){
    btn.addEventListener('click',function(){ rtypeMoveAndDelete(btn.dataset.moveOk); });
  });
}

// Affiche la zone de confirmation inline pour un type donné
function rtypeAskDelete(key){
  var r=RTYPES.find(function(r){return r.key===key;}); if(!r) return;
  // Compter les pixels de cette couleur
  var count=0;
  for(var row=0;row<numRows();row++) for(var col=0;col<numCols();col++)
    if(grid[row]&&grid[row][col]===r.color) count++;
  var msg='Supprimer "'+r.name+'" ?';
  if(count>0) msg+=' '+count+' pixel'+(count>1?'s':'')+' concerné'+(count>1?'s':'')+'.';
  else msg+=' Aucun pixel affecté.';
  var msgEl=document.getElementById('rtype-confirm-msg-'+key);
  var confirmEl=document.getElementById('rtype-confirm-'+key);
  if(msgEl) msgEl.textContent=msg;
  if(confirmEl) confirmEl.style.display='block';
  // Show move-to dropdown if there are affected pixels and other types exist
  var moveRow=document.getElementById('rtype-move-row-'+key);
  var moveBtn=confirmEl&&confirmEl.querySelector('[data-move-ok]');
  if(count>0){
    var others=RTYPES.filter(function(t){return t.key!==key&&t.key!=='aisle'&&t.key!=='wall';});
    if(others.length>0&&moveRow){
      var sel=document.getElementById('rtype-move-target-'+key);
      sel.innerHTML=others.map(function(t){
        return '<option value="'+t.key+'">'+t.name+'</option>';
      }).join('');
      moveRow.style.display='block';
      if(moveBtn) moveBtn.style.display='';
    }
  } else {
    if(moveRow) moveRow.style.display='none';
    if(moveBtn) moveBtn.style.display='none';
  }
}

// Cache la zone de confirmation
function rtypeHideConfirm(key){
  var el=document.getElementById('rtype-confirm-'+key);
  if(el) el.style.display='none';
}

// Supprime effectivement le type (appelé après confirmation inline)
function rtypeDelete(key){
  var r=RTYPES.find(function(r){return r.key===key;}); if(!r) return;
  var delColor=r.color;
  // Effacer les pixels de cette couleur
  var count=0;
  for(var row=0;row<numRows();row++) for(var col=0;col<numCols();col++)
    if(grid[row]&&grid[row][col]===delColor) count++;
  if(count>0){
    savePxH();
    for(var row=0;row<numRows();row++) for(var col=0;col<numCols();col++)
      if(grid[row]&&grid[row][col]===delColor) grid[row][col]=null;
    drawPx(); drawPxPreview(); updateRtypeCounts();
  }
  RTYPES=RTYPES.filter(function(r){return r.key!==key;});
  delete STAND_C[key];
  // ── Propager la suppression dans tous les forks ──
  modLayerSaveCurrent();
  MOD_LAYERS.forEach(function(lay, idx){
    if(idx===activeModLayer) return;
    if(lay.grid){
      for(var rr=0;rr<lay.grid.length;rr++){
        if(!lay.grid[rr]) continue;
        for(var cc=0;cc<lay.grid[rr].length;cc++){
          if(lay.grid[rr][cc]===delColor) lay.grid[rr][cc]=null;
        }
      }
    }
  });
  renderRtypesList(); renderRtypes(); renderPxLegend(); updatePxStats(); updateStandTypeSelect();
  if(_dirtyNotify) _dirtyNotify(true);
}

// Transfère les pixels d'un type vers un autre, puis supprime le type source
function rtypeMoveAndDelete(key){
  var r=RTYPES.find(function(r){return r.key===key;}); if(!r) return;
  var sel=document.getElementById('rtype-move-target-'+key);
  var targetKey=sel?sel.value:null;
  var target=targetKey?RTYPES.find(function(t){return t.key===targetKey;}):null;
  if(!target){ rtypeDelete(key); return; }
  var srcColor=r.color, dstColor=target.color;
  // Replace pixels of deleted type with target type color
  savePxH();
  for(var row=0;row<numRows();row++) for(var col=0;col<numCols();col++)
    if(grid[row]&&grid[row][col]===srcColor) grid[row][col]=dstColor;
  drawPx(); drawPxPreview(); updateRtypeCounts();
  // Update vector stands on current canvas
  if(typeof vc!=='undefined'&&vc&&vcLayers&&vcLayers.stands){
    var _tFill=hexToRgba(dstColor,0.12);
    vcLayers.stands.forEach(function(grp){
      if(grp.sData&&grp.sData.type===key){
        grp.sData.type=targetKey;
        var objs=grp.getObjects();
        if(objs[0]) objs[0].set({fill:_tFill,stroke:dstColor});
        if(objs[1]) objs[1].set({fill:dstColor});
        if(objs[2]) objs[2].set({fill:dstColor+'aa'});
        grp.dirty=true;
      }
    });
    vc.requestRenderAll();
  }
  RTYPES=RTYPES.filter(function(r){return r.key!==key;});
  delete STAND_C[key];
  // ── Propager le transfert dans tous les forks ──
  modLayerSaveCurrent();
  MOD_LAYERS.forEach(function(lay, idx){
    if(idx===activeModLayer) return;
    // Pixel grids: replace color
    if(lay.grid){
      for(var rr=0;rr<lay.grid.length;rr++){
        if(!lay.grid[rr]) continue;
        for(var cc=0;cc<lay.grid[rr].length;cc++){
          if(lay.grid[rr][cc]===srcColor) lay.grid[rr][cc]=dstColor;
        }
      }
    }
    // Vector JSON: update stand types and colors
    if(lay.vcJSON && lay.vcJSON.objects){
      var _tF=hexToRgba(dstColor,0.12);
      lay.vcJSON.objects.forEach(function(obj){
        if(obj.sData && obj.sData.type===key && obj.objects){
          obj.sData.type=targetKey;
          if(obj.objects[0]){ obj.objects[0].fill=_tF; obj.objects[0].stroke=dstColor; }
          if(obj.objects[1]){ obj.objects[1].fill=dstColor; }
          if(obj.objects[2]){ obj.objects[2].fill=dstColor+'aa'; }
        }
      });
    }
  });
  renderRtypesList(); renderRtypes(); renderPxLegend(); updatePxStats(); updateStandTypeSelect();
  if(_dirtyNotify) _dirtyNotify(true);
}

// ── Pré-remplit le formulaire pour l'édition d'un type existant
function rtypeEdit(key){
  var r=RTYPES.find(function(r){return r.key===key;}); if(!r) return;
  _rtypeEditKey=key;
  document.getElementById('rt-name').value=r.name;
  document.getElementById('rt-custom-name').value=r.customName||'';
  document.getElementById('rt-color').value=r.color;
  document.getElementById('rt-color-hex').value=r.color;
  document.getElementById('rt-mod-name').value=(r.mod&&r.mod.name)||'';
  document.getElementById('rt-mod-email').value=(r.mod&&r.mod.email)||'';
  document.getElementById('rt-mod-id').value=(r.mod&&r.mod.id)||'';
  document.getElementById('rtype-form-title').textContent='Modifier : '+r.name;
  document.getElementById('rt-save-btn').textContent='Enregistrer';
  document.getElementById('rt-cancel-btn').style.display='';
}

// ── Sauvegarde le formulaire (création ou modification)
function rtypeSave(){
  var name=document.getElementById('rt-name').value.trim();
  var customName=document.getElementById('rt-custom-name').value.trim();
  var color=document.getElementById('rt-color').value;
  var modName=document.getElementById('rt-mod-name').value.trim();
  var modEmail=document.getElementById('rt-mod-email').value.trim();
  var modId=document.getElementById('rt-mod-id').value.trim();
  if(!name){ alert('Le nom est obligatoire.'); return; }
  var mod={name:modName,email:modEmail,id:modId};
  if(_rtypeEditKey){
    // Mise à jour d'un type existant
    var r=RTYPES.find(function(r){return r.key===_rtypeEditKey;});
    if(r){
      var oldColor=r.color;
      r.name=name; r.customName=customName; r.color=color; r.mod=mod;
      // Mettre à jour STAND_C avec la nouvelle couleur
      STAND_C[r.key]={fill:hexToRgba(color,0.12),stroke:color};
      // Si la couleur a changé, mettre à jour les pixels existants
      if(oldColor!==color){
        for(var row=0;row<numRows();row++) for(var col=0;col<numCols();col++)
          if(grid[row]&&grid[row][col]===oldColor) grid[row][col]=color;
        drawPx(); drawPxPreview(); updateRtypeCounts();
      }
      // Mettre à jour les stands vectoriels existants avec la nouvelle couleur
      var _nFill=hexToRgba(color,0.12);
      if(typeof vc!=='undefined'&&vc&&vcLayers&&vcLayers.stands){
        vcLayers.stands.forEach(function(grp){
          if(grp.sData&&grp.sData.type===_rtypeEditKey){
            var objs=grp.getObjects();
            if(objs[0]) objs[0].set({fill:_nFill,stroke:color});
            if(objs[1]) objs[1].set({fill:color});
            if(objs[2]) objs[2].set({fill:color+'cc'});
            if(objs[3]) objs[3].set({fill:color+'aa'});
            grp.dirty=true;
          }
        });
        // Mettre à jour la couleur des groupes dont la couleur correspond à l'ancienne
        if(oldColor!==color){
          vcGroups.forEach(function(g){
            if(g.color===oldColor) g.color=color;
            vcApplyGroupColor(g);
          });
          // Mettre à jour aussi les pxCells des groupes pixel
          vcGroups.forEach(function(g){
            if(g.isPxGroup && g.pxCells){
              g.pxCells.forEach(function(px){
                if(px.color===oldColor) px.color=color;
                if(px.originalColor===oldColor) px.originalColor=color;
              });
            }
          });
          rebuildGroupOverlays();
          renderGroupsList();
        }
        vc.requestRenderAll();
      }
      // ── Propager le changement de couleur dans TOUS les forks ──
      // Sauvegarder d'abord le calque actif pour que ses données soient à jour
      modLayerSaveCurrent();
      var _editKey=_rtypeEditKey;
      MOD_LAYERS.forEach(function(lay, idx){
        if(idx===activeModLayer) return; // déjà mis à jour ci-dessus
        // 1) Pixel grid : remplacer l'ancienne couleur
        if(lay.grid && oldColor!==color){
          for(var rr=0;rr<lay.grid.length;rr++){
            if(!lay.grid[rr]) continue;
            for(var cc=0;cc<lay.grid[rr].length;cc++){
              if(lay.grid[rr][cc]===oldColor) lay.grid[rr][cc]=color;
            }
          }
        }
        // 2) Vector JSON : mettre à jour fill/stroke des stands du même type
        if(lay.vcJSON && lay.vcJSON.objects){
          lay.vcJSON.objects.forEach(function(obj){
            if(obj.sData && obj.sData.type===_editKey && obj.objects){
              if(obj.objects[0]){ obj.objects[0].fill=_nFill; obj.objects[0].stroke=color; }
              if(obj.objects[1]){ obj.objects[1].fill=color; }
              if(obj.objects[2]){ obj.objects[2].fill=color+'cc'; }
              if(obj.objects[3]){ obj.objects[3].fill=color+'aa'; }
            }
          });
        }
        // 3) Groupes : mettre à jour la couleur des groupes dans les forks
        if(lay.vcGroups && oldColor!==color){
          lay.vcGroups.forEach(function(g){
            if(g.color===oldColor) g.color=color;
            if(g.pxCells){
              g.pxCells.forEach(function(px){
                if(px.color===oldColor) px.color=color;
                if(px.originalColor===oldColor) px.originalColor=color;
              });
            }
          });
        }
      });
    }
  } else {
    // Création d'un nouveau type
    var key='ztype_'+Date.now();
    RTYPES.push({key:key,color:color,name:name,customName:customName,mod:mod});
    STAND_C[key]={fill:hexToRgba(color,0.12),stroke:color};
  }
  rtypeCancelEdit(); // reset form
  renderRtypesList(); renderRtypes(); renderPxLegend(); updateStandTypeSelect();
  if(_dirtyNotify) _dirtyNotify(true);
}

function rtypeCancelEdit(){
  _rtypeEditKey=null; rtypeClearForm();
  document.getElementById('rt-save-btn').textContent='+ Ajouter';
  document.getElementById('rt-cancel-btn').style.display='none';
  document.getElementById('rtype-form-title').textContent='Nouveau type';
}

function rtypeClearForm(){
  document.getElementById('rt-name').value='';
  document.getElementById('rt-custom-name').value='';
  document.getElementById('rt-color').value='#5b6cf9';
  document.getElementById('rt-color-hex').value='#5b6cf9';
  document.getElementById('rt-mod-name').value='';
  document.getElementById('rt-mod-email').value='';
  document.getElementById('rt-mod-id').value='';
}

function syncColorHex(){
  var v=document.getElementById('rt-color-hex').value;
  if(/^#[0-9a-fA-F]{6}$/.test(v)) document.getElementById('rt-color').value=v;
}

function hexToRgba(hex,alpha){
  var r=parseInt(hex.slice(1,3),16),g=parseInt(hex.slice(3,5),16),b=parseInt(hex.slice(5,7),16);
  return 'rgba('+r+','+g+','+b+','+alpha+')';
}

function updateStandTypeSelect(){
  var sel=document.getElementById('m-type'); if(!sel) return;
  var cur=sel.value;
  sel.innerHTML=RTYPES.filter(function(r){return r.key!=='aisle'&&r.key!=='wall';})
    .map(function(r){return '<option value="'+r.key+'"'+(r.key===cur?' selected':'')+'>'+r.name+'</option>';}).join('');
  // Ensure first option is selected when previous value no longer exists
  if(sel.selectedIndex < 0 && sel.options.length > 0) sel.selectedIndex = 0;
}

var EXPOS = expos && expos.length ? expos : [];

// ── Update EXPOS at runtime (when exhibitor data changes externally) ──
function updateExpos(newExpos){
  EXPOS = newExpos && newExpos.length ? newExpos : [];
  // Re-sync any existing assignments: update stand labels with fresh expo data
  if(typeof vc!=='undefined'&&vc&&vcLayers&&vcLayers.stands){
    Object.keys(vcAssigns).forEach(function(sid){
      var a=vcAssigns[sid]; if(!a||!a.expo) return;
      var freshExpo=EXPOS.find(function(ex){return ex.id===a.expo.id;});
      if(!freshExpo) return;
      // Update the cached expo reference with fresh data
      a.expo=freshExpo;
      // Find the stand object on canvas
      var obj=vcLayers.stands.find(function(o){return o.sData&&o.sData.id===sid;});
      if(!obj) return;
      var s=obj.sData;
      // Update stand number and hall from fresh exhibitor data
      if(freshExpo.stand) s.num=freshExpo.stand;
      if(freshExpo.hall) s.hall=freshExpo.hall;
      // Rebuild canvas label
      var canvasLabel=s.num;
      if(s.hall) canvasLabel=s.hall+(canvasLabel||'');
      vcUpdateStandLabel(obj, canvasLabel, freshExpo.name);
    });
    vc.requestRenderAll();
  }
  // Re-render the exhibitor list in the sidebar
  if(typeof renderExp==='function') renderExp();
}

// ── Auto-populate RTYPES from exhibitor region names ──────────────
(function(){
  var _regPalette = [
    '#5b6cf9', '#f59e0b', '#34d399', '#f472b6', '#8b5cf6',
    '#06b6d4', '#ef4444', '#84cc16', '#a855f7', '#14b8a6',
    '#e11d48', '#0ea5e9', '#d946ef', '#22c55e', '#eab308'
  ];
  var _palIdx = 0;
  var seen = {};
  RTYPES.forEach(function(r){ seen[r.name.toLowerCase()] = true; });

  EXPOS.forEach(function(ex){
    if(!ex.tagL) return;
    var name = ex.tagL;
    var lname = name.toLowerCase();
    if(seen[lname]) return;
    seen[lname] = true;

    // Generate key from name (slugify)
    var key = lname.replace(/\s+/g, '-').replace(/[^a-z0-9\u00C0-\u017F\-]/g, '');
    if(!key) key = 'region-' + _palIdx;
    // Avoid collision with existing keys
    var baseKey = key;
    var suffix = 0;
    while(RTYPES.find(function(r){ return r.key === key; })){
      suffix++;
      key = baseKey + '-' + suffix;
    }

    var color = _regPalette[_palIdx % _regPalette.length];
    _palIdx++;

    RTYPES.push({key: key, color: color, name: name});
  });

  // Update each expo's tag to match its RTYPE key
  EXPOS.forEach(function(ex){
    if(!ex.tagL) return;
    var lname = ex.tagL.toLowerCase();
    var rt = RTYPES.find(function(r){ return r.name.toLowerCase() === lname && r.key !== 'aisle' && r.key !== 'wall'; });
    if(rt) ex.tag = rt.key;
  });
})();

// Helper: render exhibitor type badge with RTYPE-based colour
function getExpoTagHtml(expo){
  var parts = '';
  // Participation (collectif)
  if(expo.participation){
    var rt = RTYPES.find(function(r){ return r.key === expo.tag; });
    if(rt && rt.color){
      var c = rt.color;
      parts += '<span class="etag" style="background:'+hexToRgba(c,0.1)+';color:'+c+';border:1px solid '+hexToRgba(c,0.25)+'">'+expo.participation+'</span>';
    } else {
      parts += '<span class="etag tb">'+expo.participation+'</span>';
    }
  }
  // Type de produit (Vin, Spirit, Beer, etc.)
  if(expo.typeProduit){
    parts += '<span class="etag" style="background:rgba(139,92,246,.1);color:#7c3aed;border:1px solid rgba(139,92,246,.25)">'+expo.typeProduit+'</span>';
  }
  // Catégorie (Food-and-beverage, etc.)
  if(expo.categorie){
    parts += '<span class="etag" style="background:rgba(60,181,74,.1);color:#2d9e3a;border:1px solid rgba(60,181,74,.25)">'+expo.categorie+'</span>';
  }
  // Statut
  if(expo.statut){
    parts += '<span class="etag" style="background:rgba(59,130,246,.1);color:#3b82f6;border:1px solid rgba(59,130,246,.25)">'+expo.statut+'</span>';
  }
  return parts || '';
}

function getDemoStands(){
  return [
    {x:2, y:4,          w:10,h:7, n:'A-01',t:'premium'},
    {x:14,y:4,          w:8, h:7, n:'A-02',t:'standard'},
    {x:24,y:4,          w:8, h:7, n:'A-03',t:'standard'},
    {x:34,y:4,          w:11,h:7, n:'A-04',t:'island'},
    {x:47,y:4,          w:8, h:7, n:'A-05',t:'standard'},
    {x:57,y:4,          w:8, h:7, n:'A-06',t:'corner'},
    {x:2, y:13,         w:8, h:6, n:'A-07',t:'standard'},
    {x:12,y:13,         w:8, h:6, n:'A-08',t:'standard'},
    {x:22,y:13,         w:16,h:6, n:'A-09',t:'premium'},
    {x:40,y:13,         w:8, h:6, n:'A-10',t:'standard'},
    {x:2, y:hallH*.57,  w:9, h:7, n:'B-01',t:'standard'},
    {x:13,y:hallH*.57,  w:8, h:7, n:'B-02',t:'premium'},
    {x:23,y:hallH*.57,  w:8, h:7, n:'B-03',t:'standard'},
    {x:33,y:hallH*.57,  w:12,h:7, n:'B-04',t:'island'},
    {x:2, y:hallH*.72,  w:9, h:6, n:'B-05',t:'corner'},
    {x:13,y:hallH*.72,  w:8, h:6, n:'B-06',t:'standard'},
    {x:23,y:hallH*.72,  w:8, h:6, n:'B-07',t:'standard'},
    {x:33,y:hallH*.72,  w:13,h:6, n:'B-08',t:'premium'},
  ];
}

function hallChanged(){
  var prevCellM = cellM;
  var prevCols  = numCols();
  var prevRows  = numRows();
  hallW=parseFloat(document.getElementById('hw').value)||100;
  hallH=parseFloat(document.getElementById('hh').value)||60;
  var newCellM=parseFloat(document.getElementById('hcm').value)||1;
  // Clamper entre 0.25 et 20
  newCellM = Math.max(0.25, Math.min(20, newCellM));
  document.getElementById('hcm').value = newCellM;

  // Si la resolution change, convertir le plan existant
  if(newCellM !== prevCellM){
    cellM = newCellM;
    convertGridToNewResolution(prevCellM, newCellM, prevCols, prevRows);
  } else {
    cellM = newCellM;
    rebuildPxGrid();
  }

  document.getElementById('h-info').innerHTML='Surface : <b>'+(hallW*hallH).toLocaleString('fr')+'m\u00b2</b>';
  document.getElementById('vc-hw').textContent=hallW;
  document.getElementById('vc-hh').textContent=hallH;
  bgRedrawPx();
  if(vc){ recalcPxPerM(); rebuildHallBorder(); bgRedrawVc(); fitVc(); }
  modLayerSaveCurrent(); // sync calque actif
  if(_dirtyNotify) _dirtyNotify(true);
}

// Convertit grid + separateurs vers une nouvelle resolution (cellM change)
// Principe : chaque cellule represente une surface en metres.
// On reechantillonne en trouvant pour chaque nouvelle cellule la cellule source correspondante.
function convertGridToNewResolution(oldCellM, newCellM, oldCols, oldRows){
  savePxH(); // sauvegarder pour undo

  var newCols = numCols(); // utilise le nouveau cellM deja applique
  var newRows = numRows();

  // Convertir le grid : pour chaque nouvelle cellule (nr, nc),
  // sa position en metres est (nr*newCellM, nc*newCellM).
  // La cellule source est floor(metres / oldCellM), clamped to valid range.
  var newGrid = [];
  for(var nr=0; nr<newRows; nr++){
    newGrid.push([]);
    for(var nc=0; nc<newCols; nc++){
      var mR = nr * newCellM; // position en metres
      var mC = nc * newCellM;
      var srcR = Math.min(oldRows-1, Math.max(0, Math.floor(mR / oldCellM)));
      var srcC = Math.min(oldCols-1, Math.max(0, Math.floor(mC / oldCellM)));
      var color = (grid[srcR] && grid[srcR][srcC]) ? grid[srcR][srcC] : null;
      newGrid[nr].push(color);
    }
  }
  grid = newGrid;

  // Convertir les separateurs — old→new mapping (each old edge → exactly 1 new row/col)
  // sepH[r][c] = edge at Y = r*cellM (above row r), segment spanning column c
  // sepV[r][c] = edge at X = c*cellM (left of col c), segment spanning row r
  var s = makeEmptySep();
  var newSepH = s.h, newSepV = s.v;

  // sepH : pour chaque ancien bord horizontal, trouver le bord le plus proche dans la nouvelle grille
  for(var r=1; r<oldRows; r++){
    if(!sepH[r]) continue;
    var newR = Math.round(r * oldCellM / newCellM); // closest new edge row
    if(newR <= 0 || newR >= newRows || !newSepH[newR]) continue;
    for(var c=0; c<oldCols; c++){
      if(!sepH[r][c]) continue;
      // Old column c spans [c*oldCellM, (c+1)*oldCellM) → expand to all new columns in that range
      var ncStart = Math.max(0, Math.floor(c * oldCellM / newCellM));
      var ncEnd = Math.min(newCols-1, Math.ceil((c+1) * oldCellM / newCellM) - 1);
      for(var nc=ncStart; nc<=ncEnd; nc++) newSepH[newR][nc] = true;
    }
  }
  // sepV : pour chaque ancien bord vertical, trouver le bord le plus proche dans la nouvelle grille
  for(var r=0; r<oldRows; r++){
    if(!sepV[r]) continue;
    for(var c=1; c<oldCols; c++){
      if(!sepV[r][c]) continue;
      var newC = Math.round(c * oldCellM / newCellM); // closest new edge col
      if(newC <= 0 || newC >= newCols) continue;
      // Old row r spans [r*oldCellM, (r+1)*oldCellM) → expand to all new rows in that range
      var nrStart = Math.max(0, Math.floor(r * oldCellM / newCellM));
      var nrEnd = Math.min(newRows-1, Math.ceil((r+1) * oldCellM / newCellM) - 1);
      for(var nr=nrStart; nr<=nrEnd; nr++){
        if(newSepV[nr]) newSepV[nr][newC] = true;
      }
    }
  }
  sepH = newSepH; sepV = newSepV;

  renderPxCanvas();
  updatePxStats(); renderPxLegend(); drawPxPreview();
}

// Highlight active cell-size preset button
function syncCellMButtons(){
  ['hcm-2','hcm-1','hcm-05','hcm-025'].forEach(function(id){
    var el=document.getElementById(id); if(!el) return;
    el.style.background = '';
    el.style.color = '';
    el.style.borderColor = '';
  });
  var map = {2:'hcm-2', 1:'hcm-1', 0.5:'hcm-05', 0.25:'hcm-025'};
  var activeId = map[cellM];
  if(activeId){
    var el=document.getElementById(activeId);
    if(el){
      el.style.background='rgba(91,108,249,.2)';
      el.style.color='#8b9fff';
      el.style.borderColor='rgba(91,108,249,.5)';
    }
  }
}

// Raccourci preset resolution
function setCellM(v){
  document.getElementById('hcm').value = v;
  hallChanged();
  syncCellMButtons();
}

// ═══════════════════════════════════════
// IMAGE DE FOND — état partagé px + vc
// ═══════════════════════════════════════
var bgImg     = null;    // HTMLImageElement chargé
var bgDataUrl = null;    // data:// url
var bgRealW   = 100;     // largeur réelle en mètres
var bgRealH   = 60;      // hauteur réelle en mètres
var bgOpacity = 0.70;    // 0..1
var bgVisible = true;
var bgLocked  = true;    // verrouillé = non sélectionnable
var vcBgObj   = null;    // fabric.Image dans le canvas vectoriel

// ── Pendine modal : image sélectionnée mais pas encore appliquée
var bgPendingImg = null;
var bgPendingUrl = null;

function openBgModal(){
  if(bgImg){
    // Image déjà chargée → vue édition
    document.getElementById('bg-import-view').style.display='none';
    document.getElementById('bg-edit-view').style.display='block';
    document.getElementById('bg-edit-thumb').src=bgDataUrl;
    document.getElementById('bg-edit-rw').value=bgRealW;
    document.getElementById('bg-edit-rh').value=bgRealH;
    document.getElementById('bg-edit-lock-ratio').checked=true;
    // Sync opacity sliders with current values
    var fondVal=Math.round(bgOpacity*100);
    var dessinEl=document.getElementById('px-c');
    var dessinVal=dessinEl?Math.round((parseFloat(dessinEl.style.opacity)||1)*100):100;
    var mf=document.getElementById('mbg-op-fond'); if(mf) mf.value=fondVal;
    var mfl=document.getElementById('mbg-op-fond-lbl'); if(mfl) mfl.textContent=fondVal+'%';
    var md=document.getElementById('mbg-op-dessin'); if(md) md.value=dessinVal;
    var mdl=document.getElementById('mbg-op-dessin-lbl'); if(mdl) mdl.textContent=dessinVal+'%';
  } else {
    bgShowImport();
  }
  openM('m-bg');
}

function bgShowImport(){
  bgPendingImg=null; bgPendingUrl=null;
  document.getElementById('bg-import-view').style.display='block';
  document.getElementById('bg-edit-view').style.display='none';
  document.getElementById('bg-thumb').style.display='none';
  document.getElementById('bg-fields').classList.remove('show');
  document.getElementById('bg-apply-btn').style.display='none';
  document.getElementById('bg-drop-txt').innerHTML='Cliquer ou déposer une image ici<br><span style="color:var(--mu2)">PNG · JPG · WebP</span>';
}

// Prévisualisation du redimensionnement avec ratio bloqué
function bgPreviewResize(){
  if(!document.getElementById('bg-edit-lock-ratio').checked) return;
  var ratio=bgImg.width/bgImg.height;
  var fw=parseFloat(document.getElementById('bg-edit-rw').value);
  var fh=parseFloat(document.getElementById('bg-edit-rh').value);
  // Détecter quel champ vient d'être modifié via le focus
  var active=document.activeElement;
  if(active&&active.id==='bg-edit-rw'&&fw>0){
    document.getElementById('bg-edit-rh').value=Math.round(fw/ratio*10)/10;
  } else if(active&&active.id==='bg-edit-rh'&&fh>0){
    document.getElementById('bg-edit-rw').value=Math.round(fh*ratio*10)/10;
  }
}

function bgApplyResize(){
  var newW=parseFloat(document.getElementById('bg-edit-rw').value)||bgRealW;
  var newH=parseFloat(document.getElementById('bg-edit-rh').value)||bgRealH;
  bgRealW=newW; bgRealH=newH;

  // Mettre à jour les dimensions du hall
  hallW=bgRealW; hallH=bgRealH;
  document.getElementById('hw').value=hallW;
  document.getElementById('hh').value=hallH;
  document.getElementById('h-info').innerHTML='Surface : <b>'+(hallW*hallH).toLocaleString('fr')+'m²</b>';
  document.getElementById('vc-hw').textContent=hallW;
  document.getElementById('vc-hh').textContent=hallH;
  rebuildPxGrid();
  if(vc){ recalcPxPerM(); rebuildHallBorder(); }

  bgSyncUI();
  bgRedrawPx();
  bgRedrawVc();
  bgModalClose();
}

function bgFileChosen(inp){
  if(inp.files&&inp.files[0]) bgHandleDrop(inp.files[0]);
  inp.value='';
}

function bgHandleDrop(file){
  if(!file) return;
  var isPDF=file.type==='application/pdf';
  var isImg=file.type.startsWith('image/');
  if(!isPDF&&!isImg){ alert('Format non supporté. Utilisez PNG, JPG, WebP ou PDF.'); return; }

  document.getElementById('bg-drop-txt').innerHTML='⏳ Chargement…';

  if(isPDF){
    // Rendu PDF → canvas via FileReader + img tag (sans lib externe)
    // On utilise un <iframe> invisible pour récupérer l'image via la visionneuse du navigateur
    // Méthode simple : afficher une info et demander de convertir en image
    // Alternative robuste : canvas + blob URL
    var fr=new FileReader();
    fr.onload=function(e){
      var blobUrl=URL.createObjectURL(file);
      // Créer un iframe caché pour rendre le PDF, puis screenshotter
      // → Non faisable sans lib. On informe l'utilisateur.
      // On convertit la première page via une image HTML5 canvas trick :
      // Le plus simple : ouvrir dans un canvas via un <img> avec object-url
      var img=new Image();
      img.onload=function(){
        bgSetPending(img, e.target.result);
        URL.revokeObjectURL(blobUrl);
      };
      img.onerror=function(){
        // PDF ne peut pas être rendu directement — afficher message
        document.getElementById('bg-drop-txt').innerHTML='⚠️ PDF : convertissez en PNG/JPG d\'abord<br><span style="color:var(--mu2)">Le navigateur ne peut pas rendre le PDF directement</span>';
        document.getElementById('bg-file-in').value='';
      };
      // Essayer quand même (certains navigateurs acceptent)
      img.src=blobUrl;
    };
    fr.readAsDataURL(file);
  } else {
    var fr2=new FileReader();
    fr2.onload=function(e){
      var img=new Image();
      img.onload=function(){ bgSetPending(img, e.target.result); };
      img.src=e.target.result;
    };
    fr2.readAsDataURL(file);
  }
}

function bgSetPending(img, url){
  bgPendingImg=img; bgPendingUrl=url;
  // Pré-remplir dimensions avec ratio conservé
  var ratio=img.width/img.height;
  document.getElementById('bg-rw').value=hallW;
  document.getElementById('bg-rh').value=Math.round(hallW/ratio*10)/10;
  // Aperçu
  var thumb=document.getElementById('bg-thumb');
  thumb.src=url; thumb.style.display='block';
  document.getElementById('bg-fields').classList.add('show');
  document.getElementById('bg-apply-btn').style.display='block';
  document.getElementById('bg-drop-txt').innerHTML='<b style="color:var(--pur)">'+img.width+'×'+img.height+' px</b><br><span style="color:var(--mu2)">Cliquer pour changer</span>';
}

function bgApply(){
  if(!bgPendingImg) return;
  bgImg=bgPendingImg; bgDataUrl=bgPendingUrl;
  bgRealW=parseFloat(document.getElementById('bg-rw').value)||hallW;
  bgRealH=parseFloat(document.getElementById('bg-rh').value)||hallH;
  bgOpacity=parseInt(document.getElementById('bg-init-op').value)/100;
  bgVisible=true; bgLocked=true;

  if(document.getElementById('bg-sync').checked){
    hallW=bgRealW; hallH=bgRealH;
    document.getElementById('hw').value=hallW;
    document.getElementById('hh').value=hallH;
    document.getElementById('h-info').innerHTML='Surface : <b>'+(hallW*hallH).toLocaleString('fr')+'m²</b>';
    document.getElementById('vc-hw').textContent=hallW;
    document.getElementById('vc-hh').textContent=hallH;
    rebuildPxGrid();
    if(vc){ recalcPxPerM(); rebuildHallBorder(); }
  }

  bgSyncUI();
  bgRedrawPx();
  bgRedrawVc();
  bgModalClose();
}

function bgRemove(){
  bgImg=null; bgDataUrl=null; bgRealW=hallW; bgRealH=hallH;
  bgVisible=true; bgLocked=true;
  if(vcBgObj){ vc.remove(vcBgObj); vcBgObj=null; }
  // Also remove any _bg objects loaded from JSON that vcBgObj didn't track
  if(vc){
    var bgObjs=vc.getObjects().filter(function(o){return o._bg;});
    bgObjs.forEach(function(o){ vc.remove(o); });
    vc.requestRenderAll();
  }
  bgRedrawPx();
  bgSyncUI();
  bgModalClose();
}

function bgModalClose(){
  closeM('m-bg');
}

// Synchronise tous les contrôles UI de fond (px + vc panels)
function bgSyncUI(){
  var pct=Math.round(bgOpacity*100);
  var label=bgImg ? bgRealW+'×'+bgRealH+'m' : '—';
  var lockIcn=bgLocked?'🔒':'🔓';
  var visIcn=bgVisible?'👁':'🙈';

  // Les 4 contrôles (px et vc ont chacun leur propre ligne)
  ['lbg','vlbg'].forEach(function(pfx){
    var nameEl=document.getElementById(pfx+'-name');
    if(nameEl) nameEl.textContent='Fond  '+label;
    var opEl=document.getElementById(pfx+'-op');
    if(opEl){ opEl.value=pct; document.getElementById(pfx+'-op-lbl').textContent=pct+'%'; }
    var lockEl=document.getElementById(pfx+'-lock');
    if(lockEl){ lockEl.textContent=lockIcn; lockEl.classList.toggle('off',!bgLocked); }
    var visEl=document.getElementById(pfx+'-vis');
    if(visEl){ visEl.textContent=visIcn; visEl.classList.toggle('off',!bgVisible); }
  });
}

function bgToggleVis(){
  bgVisible=!bgVisible;
  bgSyncUI();
  bgRedrawPx();
  if(vcBgObj){ vcBgObj.set('visible',bgVisible); vc.requestRenderAll(); }
}

function bgToggleLock(){
  bgLocked=!bgLocked;
  bgSyncUI();
  if(vcBgObj){
    vcBgObj.set({selectable:!bgLocked,evented:!bgLocked,hasControls:!bgLocked});
    if(bgLocked&&vc) vc.discardActiveObject();
    vc.requestRenderAll();
  }
}

function bgSetOp(val){
  bgOpacity=val/100;
  // Synchroniser tous les sliders (sidebar px, sidebar vc, modal)
  ['lbg-op','vlbg-op','mbg-op-fond'].forEach(function(id){
    var el=document.getElementById(id); if(el) el.value=val;
  });
  ['lbg-op-lbl','vlbg-op-lbl','mbg-op-fond-lbl'].forEach(function(id){
    var el=document.getElementById(id); if(el) el.textContent=val+'%';
  });
  bgRedrawPx();
  if(vcBgObj){ vcBgObj.set('opacity',bgOpacity); vc.requestRenderAll(); }
}

// ── Rendu fond sur le canvas pixel ──────────────────────
function bgRedrawPx(){
  var c=document.getElementById('px-bg-c');
  var cp=cellPx(), W=numCols()*cp, H=numRows()*cp;
  // Ne pas réassigner width/height ici — ça effacerait le canvas.
  // renderPxCanvas s'en charge quand nécessaire.
  var ctx=c.getContext('2d');
  ctx.clearRect(0,0,c.width,c.height);
  if(!bgImg||!bgVisible) return;
  ctx.globalAlpha=bgOpacity;
  var iw=Math.round((bgRealW/hallW)*W);
  var ih=Math.round((bgRealH/hallH)*H);
  ctx.drawImage(bgImg, 0, 0, iw, ih);
  ctx.globalAlpha=1;
}

// ── Rendu fond dans le canvas vectoriel ─────────────────
function bgRedrawVc(){
  if(!vc) return;
  if(vcBgObj){ vc.remove(vcBgObj); vcBgObj=null; }
  if(!bgImg||!bgVisible){ vc.requestRenderAll(); return; }
  fabric.Image.fromURL(bgDataUrl, function(fimg){
    var wPx=mToPx(bgRealW), hPx=mToPx(bgRealH);
    fimg.set({
      left:0, top:0,
      scaleX: wPx/fimg.width,
      scaleY: hPx/fimg.height,
      opacity: bgOpacity,
      selectable: !bgLocked,
      evented: !bgLocked,
      hasControls: !bgLocked,
      _bg: true
    });
    vcBgObj=fimg;
    vc.add(fimg);
    vc.sendToBack(fimg);
    var hb=vc.getObjects().find(function(o){return o._hall;});
    if(hb) vc.sendToBack(hb);
    vc.requestRenderAll();
  });
}

// ═══════════════════════════════════════
// CALQUES VECTORIELS — définition + rendu
// ═══════════════════════════════════════
var VC_LAYERS=[
  {key:'stands', label:'Stands',      color:'var(--ac)'},
  {key:'aisles', label:'Allées',       color:'var(--gold)'},
  {key:'struct', label:'Structure',    color:'var(--mu)'},
  {key:'annot',  label:'Annotations', color:'var(--grn)'},
  {key:'meas',   label:'Mesures',     color:'var(--pink)'},
];
var vcLayerVis={stands:true,aisles:true,struct:true,annot:true,meas:true};
var vcLayerLock={stands:false,aisles:false,struct:false,annot:false,meas:false};

function buildVcLayersList(){
  var el=document.getElementById('vc-layers-list');
  el.innerHTML=VC_LAYERS.map(function(l){
    return '<div class="litem" id="vl-'+l.key+'" onclick="setVcLayer(\''+l.key+'\')">'+
      '<div class="ldot" style="background:'+l.color+'"></div>'+
      '<span class="lname">'+l.label+'</span>'+
      '<span class="licons">'+
        '<span class="licn" id="vlk-'+l.key+'" onclick="vcLayerToggleLock(event,\''+l.key+'\')" title="Verrouiller">🔓</span>'+
        '<span class="licn" id="vlv-'+l.key+'" onclick="vcLayerToggleVis(event,\''+l.key+'\')" title="Visibilité">👁</span>'+
      '</span></div>'+
      '<div class="lop">'+
        '<input type="range" id="vlop-'+l.key+'" min="5" max="100" value="100" oninput="vcLayerSetOp(\''+l.key+'\',+this.value)">'+
        '<span id="vlop-'+l.key+'-lbl">100%</span>'+
      '</div>';
  }).join('');
  // Activer stands par défaut
  document.getElementById('vl-stands').classList.add('on');
}

function vcLayerToggleVis(e,key){
  e.stopPropagation();
  vcLayerVis[key]=!vcLayerVis[key];
  var vis=vcLayerVis[key];
  var icn=document.getElementById('vlv-'+key);
  icn.classList.toggle('off',!vis);
  icn.textContent=vis?'👁':'🙈';
  (vcLayers[key]||[]).forEach(function(o){ o.set('visible',vis); });
  vc.requestRenderAll();
}

function vcLayerToggleLock(e,key){
  e.stopPropagation();
  vcLayerLock[key]=!vcLayerLock[key];
  var locked=vcLayerLock[key];
  var icn=document.getElementById('vlk-'+key);
  icn.textContent=locked?'🔒':'🔓';
  icn.classList.toggle('off',locked);
  (vcLayers[key]||[]).forEach(function(o){
    if(!o._hall) o.set({selectable:!locked,evented:!locked});
  });
  if(locked&&vc) vc.discardActiveObject();
  vc.requestRenderAll();
}

function vcLayerSetOp(key,val){
  document.getElementById('vlop-'+key+'-lbl').textContent=val+'%';
  var op=val/100;
  (vcLayers[key]||[]).forEach(function(o){ o.set('opacity',op); });
  vc.requestRenderAll();
}

// ── Per-zone-type visibility/lock/opacity (vector side) ──
var vcTypeVis={}, vcTypeLock={}, vcTypeOp={};
function vcInitTypeState(){
  RTYPES.forEach(function(r){
    if(vcTypeVis[r.key]===undefined) vcTypeVis[r.key]=true;
    if(vcTypeLock[r.key]===undefined) vcTypeLock[r.key]=false;
    if(vcTypeOp[r.key]===undefined) vcTypeOp[r.key]=100;
  });
  // Special: Mesures
  if(vcTypeVis._meas===undefined) vcTypeVis._meas=true;
  if(vcTypeLock._meas===undefined) vcTypeLock._meas=false;
  if(vcTypeOp._meas===undefined) vcTypeOp._meas=100;
}
// Per-fork (MOD_LAYER) persistence of lock / visibility / opacity per zone type
function modTypeStateSave(lay){
  if(!lay) return;
  lay.typeState={
    vis:JSON.parse(JSON.stringify(vcTypeVis)),
    lock:JSON.parse(JSON.stringify(vcTypeLock)),
    op:JSON.parse(JSON.stringify(vcTypeOp))
  };
}
function modTypeStateLoad(lay){
  var ts=(lay&&lay.typeState)||{};
  vcTypeVis=JSON.parse(JSON.stringify(ts.vis||{}));
  vcTypeLock=JSON.parse(JSON.stringify(ts.lock||{}));
  vcTypeOp=JSON.parse(JSON.stringify(ts.op||{}));
  vcInitTypeState();
}
function vcApplyTypeState(){
  if(!vc) return;
  vcInitTypeState();
  var keys=RTYPES.map(function(r){return r.key;}); keys.push('_meas');
  keys.forEach(function(k){
    var vis=vcTypeVis[k]!==false, locked=vcTypeLock[k]===true, op=(vcTypeOp[k]||100)/100;
    vcGetObjectsForType(k).forEach(function(o){
      o.set('visible',vis);
      o.set('opacity',op);
      if(!o._hall) o.set({selectable:!locked,evented:!locked});
    });
  });
  vc.requestRenderAll();
}
function vcGetObjectsForType(key){
  if(!vc) return [];
  if(key==='_meas') return vcLayers.meas||[];
  // For aisle/wall: include BOTH infrastructure objects AND stands with that type
  if(key==='aisle'){
    var a=(vcLayers.aisles||[]).slice();
    (vcLayers.stands||[]).forEach(function(o){ if(o.sData && o.sData.type==='aisle') a.push(o); });
    return a;
  }
  if(key==='wall'){
    var w=(vcLayers.struct||[]).slice();
    (vcLayers.stands||[]).forEach(function(o){ if(o.sData && o.sData.type==='wall') w.push(o); });
    return w;
  }
  // Stand types: filter vcLayers.stands by sData.type
  return (vcLayers.stands||[]).filter(function(o){ return o.sData && o.sData.type===key; });
}
function vcTypeToggleVis(e,key){
  e.stopPropagation();
  vcTypeVis[key]=!vcTypeVis[key];
  var vis=vcTypeVis[key];
  var icn=document.getElementById('vzt-v-'+key);
  if(icn){ icn.classList.toggle('off',!vis); icn.textContent=vis?'👁':'🙈'; }
  vcGetObjectsForType(key).forEach(function(o){ o.set('visible',vis); });
  vc.requestRenderAll();
}
function vcTypeToggleLock(e,key){
  e.stopPropagation();
  vcTypeLock[key]=!vcTypeLock[key];
  var locked=vcTypeLock[key];
  var icn=document.getElementById('vzt-k-'+key);
  if(icn){ icn.textContent=locked?'🔒':'🔓'; icn.classList.toggle('off',locked); }
  vcGetObjectsForType(key).forEach(function(o){
    if(!o._hall) o.set({selectable:!locked,evented:!locked});
  });
  if(locked&&vc) vc.discardActiveObject();
  vc.requestRenderAll();
}
function vcTypeSetOp(key,val){
  var lbl=document.getElementById('vzt-op-'+key+'-lbl');
  if(lbl) lbl.textContent=val+'%';
  vcTypeOp[key]=+val;
  var op=val/100;
  vcGetObjectsForType(key).forEach(function(o){ o.set('opacity',op); });
  vc.requestRenderAll();
}

// ═══════════════════════════════════════
// PIXEL ENGINE
// ═══════════════════════════════════════
var grid=[], pxTool='hand', pxCol='#5b6cf9', pxZ=1;
var pxPadX=0, pxPadY=0; // padding autour du canvas pixel pour centrer comme en vectoriel
var sepH=[], sepV=[];   // arêtes séparateur : sepH[r][c]=true = arête AU-DESSUS de la ligne r (Y=r*cellM) ; sepV[r][c]=true = arête À GAUCHE de la col c (X=c*cellM)
var sepColor='#ffffff'; // couleur d'affichage des séparateurs
var pxDrawing=false, rectStart=null;
// Couleurs verrouillées : les stands de ces couleurs se déplacent en bloc
var sepDir=null; // direction verrouillée du séparateur: null|'H'|'V'
// Sélection pixel
var pxSel=null;       // {r1,r2,c1,c2} cellules sélectionnées, null si aucune
var pxSelCells=null;  // Set de clés "r,c" pour sélection irrégulière (groupe multi-stand)
var pxSelDrag=false;  // en train de déplacer la sélection
var pxSelDragStart=null; // {row,col} cellule de départ du drag
var pxSelBuf=null;    // buffer de cellules coupées [{r,c,color}]
var pxStandRects=[];  // [{id, r1, c1, r2, c2, color}] full rects from Vec→Pixel sync
var _pxDropRect=null; // matched full rect during pickup, used at drop for overlap restoration
var pxSelAngle=0;     // animation marching ants
var hist=[], histIdx=-1;
// PALETTE et GROUP_COLORS dérivent de RTYPES pour cohérence totale
// (recalculés après chaque modification de RTYPES via refreshColorSources)
var PALETTE=['#5b6cf9','#8b5cf6','#f59e0b','#34d399','#f472b6','#60a5fa','#fb923c','#f87171','#64748b','#1e2438'];
var GROUP_COLORS=PALETTE; // même source — sera mis à jour par refreshColorSources
function refreshColorSources(){
  // GROUP_COLORS = exactly the RTYPES colors (excluding aisle/wall infrastructure)
  var standColors=RTYPES.filter(function(r){return r.key!=='aisle'&&r.key!=='wall';}).map(function(r){return r.color;});
  PALETTE.length=0; standColors.forEach(function(c){ PALETTE.push(c); });
  GROUP_COLORS.length=0; standColors.forEach(function(c){ GROUP_COLORS.push(c); });
}

function cellPx(){ return Math.max(2, Math.round(16*pxZ)); }

function initPx(){
  grid=makeEmptyGrid();
  var s=makeEmptySep(); sepH=s.h; sepV=s.v;
  renderPxCanvas();
  // Centrer le scroll sur l'origine du canvas (comme fitVc en vectoriel)
  var _pxA=document.getElementById('px-area');
  if(_pxA){ _pxA.scrollLeft=pxPadX; _pxA.scrollTop=pxPadY; }
  renderRtypes(); updateStandTypeSelect(); syncCellMButtons(); modInitPrincipal();
  // Set initial zoom display (aligned with vector side percentage)
  var _pzEl=document.getElementById('px-zpct'); if(_pzEl) _pzEl.textContent=pxZoomPct()+'%';
  // Auto-select first zone type color
  if(RTYPES.length>0) setPxCol(RTYPES[0].color);
  var c=document.getElementById('px-c');
  c.addEventListener('contextmenu',function(e){ e.preventDefault(); });
  c.addEventListener('mousedown',pxDown);
  c.addEventListener('mousemove',pxMove);
  c.addEventListener('mouseup',pxUp);
  c.addEventListener('mouseleave',function(){ pxDrawing=false; });
  // Double-click: select individual stand within a group (bypass group selection)
  c.addEventListener('dblclick',function(e){
    if(pxTool!=='select') return;
    var cell=getCell(e);
    var cellColor=grid[cell.row]&&grid[cell.row][cell.col];
    if(!cellColor) return;
    var cellGrp=pxGetCellGroup(cell.row,cell.col);
    if(!cellGrp) return; // not in a group — normal click handled it
    // Flood-select just this individual stand (bypass group)
    var flood=floodSelect(cell.row,cell.col);
    if(flood && flood.cells.length>0){
      pxSel={r1:flood.r1,r2:flood.r2,c1:flood.c1,c2:flood.c2};
      pxSelBuf=[];
      flood.cells.forEach(function(px){
        pxSelBuf.push({dr:px.r-pxSel.r1,dc:px.c-pxSel.c1,color:px.color});
      });
      pxSelCells=null;
      pxSelDrag=false; pxSelDragStart=null;
      drawPx(); drawSelOverlay();
      var sec=document.getElementById('px-sel-sec');
      if(sec) sec.style.display='none';
    }
  });
  // Pan main : mousemove et mouseup sur window pour ne pas perdre le drag hors canvas
  window.addEventListener('mousemove',_pxHandMove);
  window.addEventListener('mouseup',function(e){ if(e.button===0) _pxHandUp(e); });
  // Activer pan depuis le canvas avec clic gauche (outil hand)
  c.addEventListener('mousedown',function(e){
    if(e.button===0 && pxTool==='hand'){ _pxHandDown(e); }
  });
  document.getElementById('px-area').addEventListener('wheel',function(e){
    e.preventDefault();
    var area=document.getElementById('px-area');
    // Position de la souris dans les coordonnées monde (relatif à l'origine du canvas)
    var mouseWX=e.clientX - area.getBoundingClientRect().left + area.scrollLeft - pxPadX;
    var mouseWY=e.clientY - area.getBoundingClientRect().top  + area.scrollTop  - pxPadY;
    var factor=e.deltaY>0?1/1.15:1.15;
    var oldZ=pxZ;
    setPxZoom(pxZ*factor);
    // Après zoom, ajuster le scroll pour que le point sous la souris reste fixe
    var ratio=pxZ/oldZ;
    area.scrollLeft=mouseWX*ratio + pxPadX - (e.clientX - area.getBoundingClientRect().left);
    area.scrollTop =mouseWY*ratio + pxPadY - (e.clientY - area.getBoundingClientRect().top);
  },{passive:false});

  // Clic molette (button===1) → outil Main temporaire
  // Listener sur le canvas directement pour capter avant pxDown
  var _pxPrevTool=null;
  c.addEventListener('mousedown',function(e){
    if(e.button===1){
      e.preventDefault();
      _pxPrevTool=pxTool;
      setPxTool('hand');
      _pxHandDown(e); // démarrer le pan immédiatement
    }
  });
  window.addEventListener('mouseup',function(e){
    if(e.button===1 && _pxPrevTool!==null){
      _pxHandUp(e);
      setPxTool(_pxPrevTool);
      _pxPrevTool=null;
    }
  });

  savePxH();
}

function makeEmptySep(){
  var h=[], v=[];
  for(var r=0;r<numRows()+1;r++){ h.push([]); v.push([]); for(var c=0;c<numCols()+1;c++){h[r].push(false);v[r].push(false);} }
  return {h:h,v:v};
}
function makeEmptyGrid(){
  var g=[];
  for(var r=0;r<numRows();r++){g.push([]); for(var c=0;c<numCols();c++) g[r].push(null);}
  return g;
}

function rebuildPxGrid(){
  var old=grid, oldSepH=sepH, oldSepV=sepV;
  grid=[];
  for(var r=0;r<numRows();r++){
    grid.push([]);
    for(var c=0;c<numCols();c++) grid[r].push((old[r]&&old[r][c]!==undefined)?old[r][c]:null);
  }
  // Preserve existing separators within new bounds instead of resetting
  var s=makeEmptySep(); sepH=s.h; sepV=s.v;
  for(var r=0;r<sepH.length;r++) for(var c=0;c<sepH[r].length;c++)
    if(oldSepH[r]&&oldSepH[r][c]) sepH[r][c]=true;
  for(var r=0;r<sepV.length;r++) for(var c=0;c<sepV[r].length;c++)
    if(oldSepV[r]&&oldSepV[r][c]) sepV[r][c]=true;
  renderPxCanvas();
}

function renderPxCanvas(){
  var cp=cellPx(), W=numCols()*cp, H=numRows()*cp;
  var area=document.getElementById('px-area');
  var wrap=document.getElementById('px-wrap');
  // Padding pour centrer le canvas (comme en vectoriel)
  var viewW=area.clientWidth||600, viewH=area.clientHeight||400;
  pxPadX=Math.round(viewW/2); pxPadY=Math.round(viewH/2);
  wrap.style.left=pxPadX+'px'; wrap.style.top=pxPadY+'px';
  wrap.style.width=W+'px'; wrap.style.height=H+'px';
  // Spacer invisible pour étendre la zone scrollable
  var spacer=document.getElementById('px-spacer');
  if(!spacer){ spacer=document.createElement('div'); spacer.id='px-spacer'; spacer.style.cssText='position:absolute;top:0;left:0;pointer-events:none'; area.appendChild(spacer); }
  spacer.style.width=(W+pxPadX*2)+'px'; spacer.style.height=(H+pxPadY*2)+'px';
  ['px-bg-c','px-c','px-g'].forEach(function(id){
    var el=document.getElementById(id); el.width=W; el.height=H;
  });
  bgRedrawPx();
  drawPx(); drawPxGrid(); drawPxRulers();
  drawPxPreview(); updatePxStats(); renderPxLegend();
}

function drawPx(){
  var cp=cellPx(), C=numCols(), R=numRows();
  var canv=document.getElementById('px-c'), ctx=canv.getContext('2d');
  ctx.clearRect(0,0,canv.width,canv.height); // transparent — le fond vient de px-bg-c + CSS

  // 1. Remplir les cellules
  for(var r=0;r<R;r++) for(var c=0;c<C;c++){
    if(grid[r]&&grid[r][c]){ ctx.fillStyle=grid[r][c]; ctx.fillRect(c*cp,r*cp,cp,cp); }
  }

  // 2. Lignes de séparation entre zones de couleurs différentes.
  // On ne trace chaque arête qu'une seule fois (côté droit et côté bas),
  // ce qui évite tout doublon ou artefact aux coins.
  var lw=Math.max(1, cp<=4 ? 1 : cp<=12 ? 1.5 : 2);
  ctx.strokeStyle='rgba(0,0,0,0.18)';
  ctx.lineWidth=lw;
  ctx.beginPath();
  for(var r=0;r<R;r++) for(var c=0;c<C;c++){
    var col=(grid[r]&&grid[r][c])||null; if(!col) continue;
    var x=c*cp, y=r*cp;
    // Arête droite : entre (r,c) et (r,c+1)
    var colR=(grid[r]&&grid[r][c+1])||null;
    if(colR!==col){
      ctx.moveTo(x+cp, y);
      ctx.lineTo(x+cp, y+cp);
    }
    // Arête basse : entre (r,c) et (r+1,c)
    var colD=(grid[r+1]&&grid[r+1][c])||null;
    if(colD!==col){
      ctx.moveTo(x,    y+cp);
      ctx.lineTo(x+cp, y+cp);
    }
  }
  ctx.stroke();

  // 3. Séparateurs (arêtes manuelles) — tracés en blanc par-dessus tout
  var hasSep=false;
  for(var r=0;r<=numRows()&&!hasSep;r++) for(var c=0;c<=numCols()&&!hasSep;c++) if((sepH[r]&&sepH[r][c])||(sepV[r]&&sepV[r][c])) hasSep=true;
  if(hasSep){
    var sw=Math.max(1.5, cp<=6?1.5:cp<=16?2:3);
    ctx.strokeStyle='rgba(255,255,255,0.92)'; ctx.lineWidth=sw; ctx.lineCap='round';
    ctx.beginPath();
    for(var r=0;r<=numRows();r++) for(var c=0;c<=numCols();c++){
      if(sepH[r]&&sepH[r][c]){  // arête horizontale SOUS la ligne r-1 / AU-DESSUS de r
        ctx.moveTo(c*cp, r*cp); ctx.lineTo((c+1)*cp, r*cp);
      }
      if(sepV[r]&&sepV[r][c]){  // arête verticale À DROITE de c / À GAUCHE de c+1
        ctx.moveTo(c*cp, r*cp); ctx.lineTo(c*cp, (r+1)*cp);
      }
    }
    ctx.stroke();
  }
}

function drawPxGrid(){
  var cp=cellPx(), C=numCols(), R=numRows();
  var g=document.getElementById('px-g'), ctx=g.getContext('2d');
  ctx.clearRect(0,0,g.width,g.height);
  if(cp>=4){
    ctx.strokeStyle='rgba(0,0,0,0.1)'; ctx.lineWidth=0.5;
    for(var c=0;c<=C;c++){ctx.beginPath();ctx.moveTo(c*cp,0);ctx.lineTo(c*cp,g.height);ctx.stroke();}
    for(var r=0;r<=R;r++){ctx.beginPath();ctx.moveTo(0,r*cp);ctx.lineTo(g.width,r*cp);ctx.stroke();}
  }
  // Règles gérées par drawPxRulers() sur les canvas px-rh/px-rv — pas de doublon ici
}

function drawPxRulers(){
  var outer=document.getElementById('px-outer');
  var area=document.getElementById('px-area');
  var W=outer.clientWidth-20, H=outer.clientHeight-20;
  var cp=cellPx();
  var ppm=cp/cellM;
  var step=niceStep(40/ppm);
  // Scroll relatif à l'origine du canvas (comme viewportTransform en vectoriel)
  var scrollX=area.scrollLeft - pxPadX;
  var scrollY=area.scrollTop  - pxPadY;

  // ── Règle horizontale ──────────────────────────────
  var hc=document.getElementById('px-rh');
  hc.width=W; hc.style.width=W+'px'; hc.style.height='20px';
  var hx=hc.getContext('2d');
  hx.fillStyle='#ffffff'; hx.fillRect(0,0,W,20);
  hx.strokeStyle='#e0e0e0'; hx.lineWidth=1;
  hx.beginPath(); hx.moveTo(0,19.5); hx.lineTo(W,19.5); hx.stroke();
  hx.fillStyle='#666'; hx.font='8px system-ui,sans-serif'; hx.textBaseline='top';
  var firstM=Math.floor(scrollX/ppm/step)*step;
  for(var m=firstM; ; m+=step){
    var x=Math.round(m*ppm - scrollX);
    if(x>W) break;
    if(x<-1) continue;
    hx.strokeStyle='#bbb'; hx.lineWidth=1;
    hx.beginPath(); hx.moveTo(x+0.5,13); hx.lineTo(x+0.5,20); hx.stroke();
    var lbl=Math.round(m*100)/100;
    hx.fillText(lbl+'m', x+2, 3);
  }

  // ── Règle verticale ────────────────────────────────
  var rc=document.getElementById('px-rv');
  rc.height=H; rc.style.height=H+'px'; rc.style.width='20px';
  var vx=rc.getContext('2d');
  vx.fillStyle='#ffffff'; vx.fillRect(0,0,20,H);
  vx.strokeStyle='#e0e0e0'; vx.lineWidth=1;
  vx.beginPath(); vx.moveTo(19.5,0); vx.lineTo(19.5,H); vx.stroke();
  vx.fillStyle='#666'; vx.font='8px system-ui,sans-serif';
  var firstMy=Math.floor(scrollY/ppm/step)*step;
  for(var m=firstMy; ; m+=step){
    var y=Math.round(m*ppm - scrollY);
    if(y>H) break;
    if(y<-1) continue;
    vx.strokeStyle='#bbb'; vx.lineWidth=1;
    vx.beginPath(); vx.moveTo(13,y+0.5); vx.lineTo(20,y+0.5); vx.stroke();
    var lbl2=Math.round(m*100)/100;
    vx.save();
    vx.translate(9, y+2);
    vx.rotate(-Math.PI/2);
    vx.textBaseline='top';
    vx.fillText(lbl2+'m', 0, 0);
    vx.restore();
  }
}

function niceStep(raw){
  var s=[0.25,0.5,1,2,5,10,20,25,50,100,200,500];
  for(var i=0;i<s.length;i++) if(s[i]>=raw) return s[i]; return 500;
}

function getCell(e){
  var cp=cellPx(), c=document.getElementById('px-c'), r=c.getBoundingClientRect();
  var col=Math.floor((e.clientX-r.left)/cp), row=Math.floor((e.clientY-r.top)/cp);
  return {row:Math.max(0,Math.min(numRows()-1,row)),col:Math.max(0,Math.min(numCols()-1,col))};
}

// Etat du pan pixel (outil Main) — listeners natifs sur window
var _pxPanActive=false, _pxPanX=0, _pxPanY=0, _pxPanSL=0, _pxPanST=0;

function _pxHandDown(e){
  _pxPanActive=true;
  _pxPanX=e.clientX; _pxPanY=e.clientY;
  var area=document.getElementById('px-area');
  _pxPanSL=area.scrollLeft; _pxPanST=area.scrollTop;
  var c=document.getElementById('px-c'); if(c) c.style.cursor='grabbing';
}
function _pxHandMove(e){
  if(!_pxPanActive) return;
  var area=document.getElementById('px-area');
  area.scrollLeft=_pxPanSL+(_pxPanX-e.clientX);
  area.scrollTop =_pxPanST+(_pxPanY-e.clientY);
}
function _pxHandUp(e){
  if(!_pxPanActive) return; // Only handle if panning was active
  _pxPanActive=false;
  var c=document.getElementById('px-c');
  if(c){
    // Restore the cursor for the current tool, not always 'grab'
    var cur=TOOL_CURSORS[pxTool]||'crosshair';
    c.style.cursor=cur;
  }
}

function pxDown(e){
  if(e.button===1){ e.preventDefault(); return; }
  pxDrawing=true; rectStart=getCell(e);
  if(pxTool==='hand'){
    _pxHandDown(e);
    e.preventDefault(); return;
  }
  if(pxTool==='sep'){ sepDir=null; sepStart={x:e.clientX, y:e.clientY}; return; }
  if(pxTool==='select'){
    var cell=getCell(e);

    // ── Cas 0 : clic sur une cellule colorée hors sélection active → flood-select le stand
    var cellColor = grid[cell.row] && grid[cell.row][cell.col];
    var inSel = pxSel && cell.row>=pxSel.r1 && cell.row<=pxSel.r2 && cell.col>=pxSel.c1 && cell.col<=pxSel.c2;

    // Vérifier si la cellule appartient à un groupe → sélectionner tout le groupe
    if(cellColor && !inSel){
      var cellGrp = pxGetCellGroup(cell.row, cell.col);
      if(cellGrp){
        renderPxGroupPanel(cellGrp);
        // Sélectionner toutes les cellules du groupe
        var r1=Infinity,r2=-Infinity,c1=Infinity,c2=-Infinity;
        var cellSet={};
        cellGrp.pxCells.forEach(function(px){
          if(px.r<r1)r1=px.r; if(px.r>r2)r2=px.r;
          if(px.c<c1)c1=px.c; if(px.c>c2)c2=px.c;
          cellSet[px.r+','+px.c]=true;
        });
        pxSel={r1:r1,r2:r2,c1:c1,c2:c2};
        pxSelCells=cellSet;
        // Capturer toutes les cellules + seps pour le déplacement
        pxSelBuf=[];
        var sepBuf=[];
        cellGrp.pxCells.forEach(function(px){
          pxSelBuf.push({dr:px.r-r1, dc:px.c-c1, color:px.color});
          setCell(px.r, px.c, null);
          [[sepH,px.r,px.c,'H'],[sepH,px.r+1,px.c,'H'],
           [sepV,px.r,px.c,'V'],[sepV,px.r,px.c+1,'V']].forEach(function(s){
            var arr=s[0],sr=s[1],sc=s[2],t=s[3];
            if(arr[sr]&&arr[sr][sc]){sepBuf.push({type:t,r:sr,c:sc});arr[sr][sc]=false;}
          });
        });
        var seen={};
        pxSelBuf._seps=sepBuf.filter(function(s){var k=s.type+s.r+','+s.c;if(seen[k])return false;seen[k]=true;return true;});
        pxSelDrag=true; pxSelDragStart=cell;
        drawPx(); drawSelOverlay();
        return;
      } else { var sec=document.getElementById('px-sel-sec'); if(sec) sec.style.display='none'; }
    }

    if(cellColor && !inSel){
      var flood = floodSelect(cell.row, cell.col);
      if(flood && flood.cells.length > 0){
        pxSel = {r1:flood.r1, r2:flood.r2, c1:flood.c1, c2:flood.c2};
        pxSelBuf = [];
        var sepBuf = [];
        flood.cells.forEach(function(px){
          pxSelBuf.push({dr:px.r-pxSel.r1, dc:px.c-pxSel.c1, color:px.color});
          setCell(px.r, px.c, null);
          // Capturer et retirer les séparateurs internes + bords du stand
          [[sepH, px.r, px.c,'H'],[sepH, px.r+1, px.c,'H'],
           [sepV, px.r, px.c,'V'],[sepV, px.r, px.c+1,'V']].forEach(function(s){
            var arr=s[0], r=s[1], c=s[2], t=s[3];
            if(arr[r]&&arr[r][c]){ sepBuf.push({type:t,r:r,c:c}); arr[r][c]=false; }
          });
        });
        var seen={};
        pxSelBuf._seps=sepBuf.filter(function(s){
          var k=s.type+s.r+','+s.c; if(seen[k])return false; seen[k]=true; return true;
        });
        // Nettoyer les seps orphelins de pxStandRects autour des cellules vides
        // qui sont en dehors de la zone flood-sélectionnée
        if(pxStandRects.length>0){
          pxStandRects.forEach(function(sr){
            // Vérifier si ce rect chevauche la zone sélectionnée
            if(sr.r1>flood.r2+1||sr.r2<flood.r1-1||sr.c1>flood.c2+1||sr.c2<flood.c1-1) return;
            for(var _yr=sr.r1;_yr<=sr.r2;_yr++) for(var _xc=sr.c1;_xc<=sr.c2;_xc++){
              if(!grid[_yr]||!grid[_yr][_xc]){
                if(sepH[_yr]) sepH[_yr][_xc]=false;
                if(sepH[_yr+1]) sepH[_yr+1][_xc]=false;
                if(sepV[_yr]){ sepV[_yr][_xc]=false; sepV[_yr][_xc+1]=false; }
              }
            }
          });
        }
        // Si la forme n'est pas rectangulaire, stocker les cellules réelles
        var _bboxArea=(flood.r2-flood.r1+1)*(flood.c2-flood.c1+1);
        if(flood.cells.length < _bboxArea){
          pxSelCells={};
          flood.cells.forEach(function(px){ pxSelCells[px.r+','+px.c]=true; });
        } else {
          pxSelCells=null; // forme rectangulaire
        }
        // ── Overlap-aware : si L-shape correspond à un rect complet stocké, le mémoriser
        _pxDropRect=null;
        if(pxSelCells && pxStandRects.length>0){
          var _floodKeys=pxSelCells;
          var _floodCount=Object.keys(_floodKeys).length;
          var _bestRect=null, _bestArea=Infinity;
          pxStandRects.forEach(function(sr){
            var area=(sr.r2-sr.r1+1)*(sr.c2-sr.c1+1);
            // Toutes les cellules flood doivent être dans ce rect
            var allInside=true;
            for(var k in _floodKeys){
              var parts=k.split(','), rr=+parts[0], cc=+parts[1];
              if(rr<sr.r1||rr>sr.r2||cc<sr.c1||cc>sr.c2){allInside=false;break;}
            }
            if(allInside && _floodCount<area && area<_bestArea){
              _bestRect=sr; _bestArea=area;
            }
          });
          if(_bestRect){
            _pxDropRect={r1:_bestRect.r1, c1:_bestRect.c1, r2:_bestRect.r2, c2:_bestRect.c2, color:_bestRect.color};
          }
        }
      pxSelDrag=true; pxSelDragStart=cell;
        drawPx(); drawSelOverlay();
        return;
      }
    }

    // ── Cas 2 : clic dans une sélection existante → déplacement
    if(pxSel && cell.row>=pxSel.r1 && cell.row<=pxSel.r2 && cell.col>=pxSel.c1 && cell.col<=pxSel.c2){
      pxSelBuf=[];
      var _sepBuf2=[];
      function _captureSeps2(r,c){
        [[sepH,r,c,'H'],[sepH,r+1,c,'H'],[sepV,r,c,'V'],[sepV,r,c+1,'V']].forEach(function(s){
          var arr=s[0],sr=s[1],sc=s[2],t=s[3];
          if(arr[sr]&&arr[sr][sc]){_sepBuf2.push({type:t,r:sr,c:sc});arr[sr][sc]=false;}
        });
      }
      if(pxSelCells){
        // Sélection irrégulière : utiliser uniquement les cellules du set
        Object.keys(pxSelCells).forEach(function(k){
          var parts=k.split(','), r=+parts[0], c=+parts[1];
          var col=(grid[r]&&grid[r][c])||null;
          if(col) pxSelBuf.push({dr:r-pxSel.r1, dc:c-pxSel.c1, color:col});
          setCell(r, c, null);
          _captureSeps2(r,c);
        });
      } else {
        for(var r=pxSel.r1;r<=pxSel.r2;r++) for(var c=pxSel.c1;c<=pxSel.c2;c++){
          var col=(grid[r]&&grid[r][c])||null;
          if(col) pxSelBuf.push({dr:r-pxSel.r1, dc:c-pxSel.c1, color:col});
        }
        pxSelBuf.forEach(function(px){
          var r=pxSel.r1+px.dr, c=pxSel.c1+px.dc;
          setCell(r, c, null);
          _captureSeps2(r,c);
        });
      }
      var _seen2={};
      pxSelBuf._seps=_sepBuf2.filter(function(s){var k=s.type+s.r+','+s.c;if(_seen2[k])return false;_seen2[k]=true;return true;});
      pxSelDrag=true; pxSelDragStart=cell;
      drawPx();
    } else {
      // ── Cas 3 : clic ailleurs → nouvelle sélection rectangulaire
      pxSel=null; pxSelBuf=null; pxSelCells=null; pxSelDrag=false; pxSelDragStart=null;
      drawPx();
    }
    return;
  }
  applyPxTool(e,true);
}
var sepStart=null;
function pxMove(e){
  var cell=getCell(e);
  document.getElementById('st-cur').textContent=fmtM(cell.col*cellM)+'m, '+fmtM(cell.row*cellM)+'m';
  if(pxTool==='hand') return; // géré par _pxHandMove sur window
  if(pxTool==='rect'||pxTool==='frect'){previewRect(e);return;}
  if(pxTool==='sep'){if(pxDrawing) applySep(e); return;}
  if(pxTool==='select'){
    if(!pxDrawing) return;
    var cp=cellPx();
    var ctx=document.getElementById('px-c').getContext('2d');
    if(pxSelDrag && pxSelBuf && pxSelDragStart){
      // Déplacement : redessiner le fond + fantôme à la position courante
      var dr=cell.row-pxSelDragStart.row, dc=cell.col-pxSelDragStart.col;
      drawPx();
      if(_pxDropRect){
        // Overlap-aware : preview du rectangle complet
        var _drW=_pxDropRect.c2-_pxDropRect.c1+1, _drH=_pxDropRect.r2-_pxDropRect.r1+1;
        var _drR1=_pxDropRect.r1+dr, _drC1=_pxDropRect.c1+dc;
        ctx.fillStyle=_pxDropRect.color;
        for(var _rr=0;_rr<_drH;_rr++){
          for(var _cc=0;_cc<_drW;_cc++){
            var _nr=_drR1+_rr, _nc=_drC1+_cc;
            if(_nr>=0&&_nr<numRows()&&_nc>=0&&_nc<numCols()){
              ctx.fillRect(_nc*cp, _nr*cp, cp, cp);
            }
          }
        }
        drawMarchingAnts(ctx, _drC1*cp, _drR1*cp, _drW*cp, _drH*cp);
      } else {
        pxSelBuf.forEach(function(px){
          var nr=pxSel.r1+px.dr+dr, nc=pxSel.c1+px.dc+dc;
          if(nr>=0&&nr<numRows()&&nc>=0&&nc<numCols()){
            ctx.fillStyle=px.color;
            ctx.fillRect(nc*cp, nr*cp, cp, cp);
          }
        });
        var nr1=pxSel.r1+dr, nc1=pxSel.c1+dc, nr2=pxSel.r2+dr, nc2=pxSel.c2+dc;
        drawMarchingAnts(ctx, nc1*cp, nr1*cp, (nc2-nc1+1)*cp, (nr2-nr1+1)*cp);
      }
    } else {
      // Tracé du rectangle de sélection
      if(!rectStart) return;
      var r1=Math.min(rectStart.row,cell.row), r2=Math.max(rectStart.row,cell.row);
      var c1=Math.min(rectStart.col,cell.col), c2=Math.max(rectStart.col,cell.col);
      drawPx();
      ctx.fillStyle='rgba(60,181,74,0.12)';
      ctx.fillRect(c1*cp, r1*cp, (c2-c1+1)*cp, (r2-r1+1)*cp);
      drawMarchingAnts(ctx, c1*cp, r1*cp, (c2-c1+1)*cp, (r2-r1+1)*cp);
    }
    return;
  }
  if(pxDrawing) applyPxTool(e,false);
}
function pxUp(e){
  if(pxTool==='rect'||pxTool==='frect') finalizeRect(e);
  if(pxTool==='sep'){ pxDrawing=false; rectStart=null; sepDir=null; sepStart=null; savePxH(); return; }
  if(pxTool==='select'){
    var cell=getCell(e);
    if(pxSelDrag && pxSelBuf && pxSelDragStart){
      var dr=cell.row-pxSelDragStart.row, dc=cell.col-pxSelDragStart.col;
      var sr1=pxSel.r1, sr2=pxSel.r2, sc1=pxSel.c1, sc2=pxSel.c2;
      var nr1=sr1+dr, nr2=sr2+dr, nc1=sc1+dc, nc2=sc2+dc;

      // ── 1. Effacer les seps dans la zone source ET destination ──
      // Pour les sélections non-rectangulaires, ne toucher que les cellules réelles
      // afin de préserver les seps des formes voisines dans le "notch"
      function clearSepsInRect(rr1,rr2,cc1,cc2){
        for(var r=rr1; r<=rr2+1; r++) for(var c=cc1; c<=cc2; c++) if(sepH[r]) sepH[r][c]=false;
        for(var r=rr1; r<=rr2; r++) for(var c=cc1; c<=cc2+1; c++) if(sepV[r]) sepV[r][c]=false;
      }
      function clearSepsAroundCell(r,c){
        if(sepH[r])   sepH[r][c]=false;
        if(sepH[r+1]) sepH[r+1][c]=false;
        if(sepV[r])   sepV[r][c]=false;
        if(sepV[r])   sepV[r][c+1]=false;
      }
      if(_pxDropRect){
        // Overlap-aware : effacer les seps dans le rectangle complet source ET destination
        // Source : retire toutes les seps du stand déplacé (y compris celles dans la zone de chevauchement)
        clearSepsInRect(_pxDropRect.r1, _pxDropRect.r2, _pxDropRect.c1, _pxDropRect.c2);
        // Destination : effacer les seps dans tout le rectangle complet
        clearSepsInRect(_pxDropRect.r1+dr, _pxDropRect.r2+dr, _pxDropRect.c1+dc, _pxDropRect.c2+dc);
      } else if(pxSelCells){
        // Non-rectangulaire (pas overlap) : effacer les seps uniquement autour des cellules réelles
        pxSelBuf.forEach(function(px){ clearSepsAroundCell(sr1+px.dr, sc1+px.dc); });
        pxSelBuf.forEach(function(px){ clearSepsAroundCell(nr1+px.dr, nc1+px.dc); });
      } else {
        clearSepsInRect(sr1, sr2, sc1, sc2);
        clearSepsInRect(nr1, nr2, nc1, nc2);
      }

      // ── 2. Déposer les cellules ──
      if(_pxDropRect){
        // Overlap-aware : peindre le rectangle complet à la destination
        var dR1=_pxDropRect.r1+dr, dC1=_pxDropRect.c1+dc;
        var dR2=_pxDropRect.r2+dr, dC2=_pxDropRect.c2+dc;
        for(var _pr=dR1;_pr<=dR2;_pr++){
          for(var _pc=dC1;_pc<=dC2;_pc++){
            if(_pr>=0&&_pr<numRows()&&_pc>=0&&_pc<numCols()){
              setCell(_pr, _pc, _pxDropRect.color);
            }
          }
        }
      } else {
        pxSelBuf.forEach(function(px){
          setCell(nr1+px.dr, nc1+px.dc, px.color);
        });
      }

      // ── 3. Recalculer les seps cellule par cellule (supporte formes non-rectangulaires) ──
      // Pour chaque cellule du stand déposé, vérifier ses 4 voisins :
      // si le voisin est coloré ET n'appartient pas au stand → poser un séparateur
      var movedSet = {};
      if(_pxDropRect){
        // Use full rectangle for sep computation
        var _dR1=_pxDropRect.r1+dr, _dC1=_pxDropRect.c1+dc;
        var _dR2=_pxDropRect.r2+dr, _dC2=_pxDropRect.c2+dc;
        for(var _mr=_dR1;_mr<=_dR2;_mr++){
          for(var _mc=_dC1;_mc<=_dC2;_mc++){
            movedSet[_mr+','+_mc]=true;
          }
        }
      } else {
        pxSelBuf.forEach(function(px){ movedSet[(nr1+px.dr)+','+(nc1+px.dc)]=true; });
      }

      // Poser les seps autour de chaque cellule déposée
      // Sep créé si le voisin est coloré ET n'appartient pas au stand déplacé (= stand différent)
      Object.keys(movedSet).forEach(function(k){
        var parts=k.split(','), r=+parts[0], c=+parts[1];
        // Voisin haut
        if(r>0 && grid[r-1] && grid[r-1][c] && !movedSet[(r-1)+','+c]){
          if(!sepH[r]) sepH[r]=[]; sepH[r][c]=true;
        }
        // Voisin bas
        if(r+1<numRows() && grid[r+1] && grid[r+1][c] && !movedSet[(r+1)+','+c]){
          if(!sepH[r+1]) sepH[r+1]=[]; sepH[r+1][c]=true;
        }
        // Voisin gauche
        if(c>0 && grid[r] && grid[r][c-1] && !movedSet[r+','+(c-1)]){
          if(!sepV[r]) sepV[r]=[]; sepV[r][c]=true;
        }
        // Voisin droit
        if(c+1<numCols() && grid[r] && grid[r][c+1] && !movedSet[r+','+(c+1)]){
          if(!sepV[r]) sepV[r]=[]; sepV[r][c+1]=true;
        }
      });

      // ── 3b. Restore only INTERNAL separators at new position ──
      // Internal = sep where BOTH adjacent cells belong to the moved set
      if(pxSelBuf && pxSelBuf._seps){
        pxSelBuf._seps.forEach(function(s){
          var isInternal=false;
          if(s.type==='H'){
            // H sep at (r,c): border between row r-1 and row r at col c (use original coords)
            isInternal = movedSet[(s.r-1+dr)+','+(s.c+dc)] && movedSet[(s.r+dr)+','+(s.c+dc)];
          } else {
            // V sep at (r,c): border between col c-1 and col c at row r
            isInternal = movedSet[(s.r+dr)+','+(s.c-1+dc)] && movedSet[(s.r+dr)+','+(s.c+dc)];
          }
          if(!isInternal) return;
          var nr=s.r+dr, nc=s.c+dc;
          if(s.type==='H'){ if(nr>=0&&nr<=numRows()&&nc>=0&&nc<numCols()){ if(!sepH[nr])sepH[nr]=[]; sepH[nr][nc]=true; }}
          else { if(nr>=0&&nr<numRows()&&nc>=0&&nc<=numCols()){ if(!sepV[nr])sepV[nr]=[]; sepV[nr][nc]=true; }}
        });
      }

      // ── 4. Nettoyer les seps de la zone source : effacer les bords
      // des voisins qui pointaient vers les cellules maintenant vides.
      // Scanner la zone source élargie (+1 marge) pour attraper les seps
      // de périmètre pxStandRects au-delà du bounding box flood-sélectionné
      var _srcR1=_pxDropRect?_pxDropRect.r1:sr1, _srcR2=_pxDropRect?_pxDropRect.r2:sr2;
      var _srcC1=_pxDropRect?_pxDropRect.c1:sc1, _srcC2=_pxDropRect?_pxDropRect.c2:sc2;
      for(var _cr=Math.max(0,_srcR1-1);_cr<=Math.min(numRows()-1,_srcR2+1);_cr++){
        for(var _cc=Math.max(0,_srcC1-1);_cc<=Math.min(numCols()-1,_srcC2+1);_cc++){
          if(!grid[_cr] || !grid[_cr][_cc]){
            clearSepsAroundCell(_cr, _cc);
          }
        }
      }

      // ── 5. Reconstruire les seps pour les cellules restantes
      // dans la zone source, entre couleurs différentes ──
      for(var _sr5=_srcR1;_sr5<=_srcR2;_sr5++){
        for(var _sc5=_srcC1;_sc5<=_srcC2;_sc5++){
          var _sclr=(grid[_sr5]&&grid[_sr5][_sc5])||null;
          if(!_sclr) continue;
          // Voisin haut
          if(_sr5>0){var _up=(grid[_sr5-1]&&grid[_sr5-1][_sc5])||null;
            if(_up&&_up!==_sclr){if(!sepH[_sr5])sepH[_sr5]=[];sepH[_sr5][_sc5]=true;}}
          // Voisin bas
          if(_sr5+1<numRows()){var _dn=(grid[_sr5+1]&&grid[_sr5+1][_sc5])||null;
            if(_dn&&_dn!==_sclr){if(!sepH[_sr5+1])sepH[_sr5+1]=[];sepH[_sr5+1][_sc5]=true;}}
          // Voisin gauche
          if(_sc5>0){var _lt=(grid[_sr5]&&grid[_sr5][_sc5-1])||null;
            if(_lt&&_lt!==_sclr){if(!sepV[_sr5])sepV[_sr5]=[];sepV[_sr5][_sc5]=true;}}
          // Voisin droit
          if(_sc5+1<numCols()){var _rt=(grid[_sr5]&&grid[_sr5][_sc5+1])||null;
            if(_rt&&_rt!==_sclr){if(!sepV[_sr5])sepV[_sr5]=[];sepV[_sr5][_sc5+1]=true;}}
        }
      }

      // ── 6. Mettre à jour pxStandRects et reconstruire les seps de périmètre ──
      if(pxStandRects.length>0){
        // a. Mettre à jour la position du stand déplacé
        if(_pxDropRect){
          for(var _pi=0;_pi<pxStandRects.length;_pi++){
            var _spr=pxStandRects[_pi];
            if(_spr.r1===_pxDropRect.r1&&_spr.c1===_pxDropRect.c1&&_spr.r2===_pxDropRect.r2&&_spr.c2===_pxDropRect.c2){
              pxStandRects[_pi]={id:_spr.id, r1:_spr.r1+dr, c1:_spr.c1+dc, r2:_spr.r2+dr, c2:_spr.c2+dc, color:_spr.color};
              break;
            }
          }
        } else if(pxSelCells){
          // Group/irregular move: shift all pxStandRects fully inside the selection
          for(var _pi3=0;_pi3<pxStandRects.length;_pi3++){
            var _spr3=pxStandRects[_pi3];
            var _allIn=true;
            for(var _rr3=_spr3.r1;_rr3<=_spr3.r2&&_allIn;_rr3++){
              for(var _cc3=_spr3.c1;_cc3<=_spr3.c2&&_allIn;_cc3++){
                if(!pxSelCells[_rr3+','+_cc3]) _allIn=false;
              }
            }
            if(_allIn){
              pxStandRects[_pi3]={id:_spr3.id, r1:_spr3.r1+dr, c1:_spr3.c1+dc, r2:_spr3.r2+dr, c2:_spr3.c2+dc, color:_spr3.color};
            }
          }
        } else {
          // Déplacement normal d'un rectangle : mettre à jour si correspond à un rect stocké
          for(var _pi2=0;_pi2<pxStandRects.length;_pi2++){
            var _spr2=pxStandRects[_pi2];
            if(_spr2.r1===sr1&&_spr2.c1===sc1&&_spr2.r2===sr2&&_spr2.c2===sc2){
              pxStandRects[_pi2]={id:_spr2.id, r1:nr1, c1:nc1, r2:nr2, c2:nc2, color:_spr2.color};
              break;
            }
          }
        }
        // b. Reconstruire les seps de périmètre pour les rects proches de la destination
        // Seulement où le bord touche une cellule de couleur DIFFÉRENTE
        var _dstR1=_pxDropRect?_pxDropRect.r1+dr:nr1, _dstR2=_pxDropRect?_pxDropRect.r2+dr:nr2;
        var _dstC1=_pxDropRect?_pxDropRect.c1+dc:nc1, _dstC2=_pxDropRect?_pxDropRect.c2+dc:nc2;
        pxStandRects.forEach(function(sr){
          if(sr.r1>_dstR2+1||sr.r2<_dstR1-1||sr.c1>_dstC2+1||sr.c2<_dstC1-1) return;
          // Top/bottom edges: only add sep if the cell across the edge has a different color
          for(var c=sr.c1;c<=sr.c2;c++){
            var insideClr=(grid[sr.r1]&&grid[sr.r1][c])||null;
            // Top edge
            var aboveClr=(sr.r1>0&&grid[sr.r1-1]&&grid[sr.r1-1][c])||null;
            if(insideClr&&aboveClr&&aboveClr!==insideClr){if(!sepH[sr.r1])sepH[sr.r1]=[];sepH[sr.r1][c]=true;}
            // Bottom edge
            var br=sr.r2+1;
            var belowClr=(br<numRows()&&grid[br]&&grid[br][c])||null;
            var bottomClr=(grid[sr.r2]&&grid[sr.r2][c])||null;
            if(bottomClr&&belowClr&&belowClr!==bottomClr){if(br<=numRows()){if(!sepH[br])sepH[br]=[];sepH[br][c]=true;}}
          }
          // Left/right edges
          for(var r=sr.r1;r<=sr.r2;r++){
            var insideClrL=(grid[r]&&grid[r][sr.c1])||null;
            // Left edge
            var leftClr=(sr.c1>0&&grid[r]&&grid[r][sr.c1-1])||null;
            if(insideClrL&&leftClr&&leftClr!==insideClrL){if(!sepV[r])sepV[r]=[];sepV[r][sr.c1]=true;}
            // Right edge
            var bc=sr.c2+1;
            var rightClr=(bc<numCols()&&grid[r]&&grid[r][bc])||null;
            var insideClrR=(grid[r]&&grid[r][sr.c2])||null;
            if(insideClrR&&rightClr&&rightClr!==insideClrR){if(!sepV[r])sepV[r]=[];sepV[r][bc]=true;}
          }
        });
      }

      // ── Mettre à jour pxCells de tous les groupes affectés par ce déplacement ──
      // Pour les sélections non-rectangulaires, vérifier l'appartenance réelle
      // (pas juste le bounding box) pour ne pas déplacer des cellules voisines
      // NOTE: doit être fait AVANT la mise à jour de pxSelCells (qui passe aux nouvelles coords)
      vcGroups.forEach(function(grp){
        if(!grp.isPxGroup || !grp.pxCells) return;
        var changed = false;
        grp.pxCells = grp.pxCells.map(function(px){
          var inSel = pxSelCells
            ? !!pxSelCells[px.r+','+px.c]
            : (px.r>=sr1 && px.r<=sr2 && px.c>=sc1 && px.c<=sc2);
          if(inSel){
            changed = true;
            return {r: px.r+dr, c: px.c+dc, color: px.color, originalColor: px.originalColor || px.color};
          }
          return px;
        });
        if(changed) modLayerSaveCurrent();
      });

      // Mettre à jour pxSel et pxSelCells
      if(_pxDropRect){
        // Overlap-aware : sélection devient le rectangle complet
        var _dpR1=_pxDropRect.r1+dr, _dpC1=_pxDropRect.c1+dc;
        var _dpR2=_pxDropRect.r2+dr, _dpC2=_pxDropRect.c2+dc;
        pxSel={r1:_dpR1, r2:_dpR2, c1:_dpC1, c2:_dpC2};
        pxSelCells=null; // maintenant c'est un rectangle propre
      } else {
        pxSel={r1:nr1, r2:nr2, c1:nc1, c2:nc2};
        // Mettre à jour pxSelCells si sélection irrégulière
        if(pxSelCells){
          var newCells={};
          Object.keys(pxSelCells).forEach(function(k){
            var parts=k.split(','), r=+parts[0]+dr, c=+parts[1]+dc;
            newCells[r+','+c]=true;
          });
          pxSelCells=newCells;
        }
      }
      _pxDropRect=null;
      pxSelBuf=null; pxSelDrag=false; pxSelDragStart=null;

      savePxH(); drawPx(); drawSelOverlay(); updateRtypeCounts();
    } else if(rectStart){
      var rr1=Math.min(rectStart.row,cell.row), rr2=Math.max(rectStart.row,cell.row);
      var cc1=Math.min(rectStart.col,cell.col), cc2=Math.max(rectStart.col,cell.col);
      // Réduire aux cellules colorées dans le rectangle
      var br1=rr2,br2=rr1,bc1=cc2,bc2=cc1, found=false;
      for(var r=rr1;r<=rr2;r++) for(var c=cc1;c<=cc2;c++){
        if(grid[r]&&grid[r][c]){
          if(r<br1)br1=r; if(r>br2)br2=r;
          if(c<bc1)bc1=c; if(c>bc2)bc2=c;
          found=true;
        }
      }
      if(found) pxSel={r1:br1,r2:br2,c1:bc1,c2:bc2};
      else pxSel=null;
      drawPx(); drawSelOverlay();
    }
    pxDrawing=false; rectStart=null;
    return;
  }
  pxDrawing=false; rectStart=null;
  document.getElementById('px-tip').style.display='none';
  // Re-enforce cursor for current tool after mouseup
  var _cur=TOOL_CURSORS[pxTool]||'crosshair';
  var _cc=document.getElementById('px-c'); if(_cc) _cc.style.cursor=_cur;
}

function applyPxTool(e,isDown){
  var cell=getCell(e), r=cell.row, c=cell.col;
  var bs=parseInt(document.getElementById('bs').value)||1;
  if(pxTool==='pencil'){
    if(isDown) savePxH(); // save once at stroke start
    for(var dr=0;dr<bs;dr++) for(var dc=0;dc<bs;dc++) setCell(r+dr,c+dc,pxCol);
    drawPx();
  } else if(pxTool==='eraser'){
    if(isDown) savePxH(); // save once at stroke start
    for(var dr=0;dr<bs;dr++) for(var dc=0;dc<bs;dc++) setCell(r+dr,c+dc,null);
    drawPx();
  } else if(pxTool==='bucket'&&isDown){
    savePxH(); floodFill(c,r,pxCol); drawPx();
  } else if(pxTool==='eyedrop'&&isDown){
    var col=grid[r]&&grid[r][c]; if(col) setPxCol(col);
  }
  drawPxPreview(); updatePxStats(); renderPxLegend(); updateRtypeCounts();
}

function setCell(r,c,color){
  if(r>=0&&r<numRows()&&c>=0&&c<numCols()) grid[r][c]=color;
}

function drawMarchingAnts(ctx,x,y,w,h){
  var t=Date.now()/80;
  ctx.save();
  ctx.strokeStyle='rgba(0,0,0,0.8)'; ctx.lineWidth=1.5;
  ctx.setLineDash([6,4]); ctx.lineDashOffset=-t%10;
  ctx.strokeRect(x+0.5,y+0.5,w-1,h-1);
  ctx.strokeStyle='rgba(0,0,0,0.5)'; ctx.lineDashOffset=-(t%10)+5;
  ctx.strokeRect(x+0.5,y+0.5,w-1,h-1);
  ctx.setLineDash([]); ctx.restore();
}

function drawSelOverlay(){
  var cp=cellPx(), ctx=document.getElementById('px-c').getContext('2d');
  // Sélection irrégulière (groupe multi-stand) : dessiner chaque cellule
  if(pxSelCells && pxSel){
    ctx.fillStyle='rgba(60,181,74,0.18)';
    ctx.strokeStyle='rgba(0,0,0,0.6)';
    ctx.lineWidth=1.5;
    ctx.setLineDash([4,3]);
    var keys=pxSelCells;
    // Pour chaque cellule, remplir + tracer seulement les bords exposés
    Object.keys(keys).forEach(function(k){
      var parts=k.split(','), r=+parts[0], c=+parts[1];
      ctx.fillRect(c*cp, r*cp, cp, cp);
      // Bord haut
      if(!keys[(r-1)+','+c]){ ctx.beginPath(); ctx.moveTo(c*cp,r*cp); ctx.lineTo((c+1)*cp,r*cp); ctx.stroke(); }
      // Bord bas
      if(!keys[(r+1)+','+c]){ ctx.beginPath(); ctx.moveTo(c*cp,(r+1)*cp); ctx.lineTo((c+1)*cp,(r+1)*cp); ctx.stroke(); }
      // Bord gauche
      if(!keys[r+','+(c-1)]){ ctx.beginPath(); ctx.moveTo(c*cp,r*cp); ctx.lineTo(c*cp,(r+1)*cp); ctx.stroke(); }
      // Bord droit
      if(!keys[r+','+(c+1)]){ ctx.beginPath(); ctx.moveTo((c+1)*cp,r*cp); ctx.lineTo((c+1)*cp,(r+1)*cp); ctx.stroke(); }
    });
    ctx.setLineDash([]);
    return;
  }
  if(!pxSel) return;
  ctx.fillStyle='rgba(60,181,74,0.15)';
  ctx.fillRect(pxSel.c1*cp, pxSel.r1*cp, (pxSel.c2-pxSel.c1+1)*cp, (pxSel.r2-pxSel.r1+1)*cp);
  drawMarchingAnts(ctx, pxSel.c1*cp, pxSel.r1*cp, (pxSel.c2-pxSel.c1+1)*cp, (pxSel.r2-pxSel.r1+1)*cp);
}

// Déterminer l'arête la plus proche du curseur
// Si dir est fourni ('H' ou 'V'), seules les arêtes de ce type sont retournées
function getEdge(e, dir){
  var cp=cellPx(), canv=document.getElementById('px-c'), rect=canv.getBoundingClientRect();
  var px=(e.clientX-rect.left), py=(e.clientY-rect.top);
  var col=Math.floor(px/cp), row=Math.floor(py/cp);
  col=Math.max(0,Math.min(numCols()-1,col));
  row=Math.max(0,Math.min(numRows()-1,row));
  var fx=(px-col*cp)/cp, fy=(py-row*cp)/cp;

  if(dir==='V'){
    // Ligne verticale → arête gauche ou droite de la cellule
    return fx<0.5 ? {type:'V',r:row,c:col} : {type:'V',r:row,c:col+1};
  }
  if(dir==='H'){
    // Ligne horizontale → arête haut ou bas de la cellule
    return fy<0.5 ? {type:'H',r:row,c:col} : {type:'H',r:row+1,c:col};
  }
  // Sans direction forcée : arête la plus proche
  var dL=fx, dR=1-fx, dT=fy, dB=1-fy;
  var mn=Math.min(dL,dR,dT,dB);
  if(mn===dT) return {type:'H',r:row,  c:col};
  if(mn===dB) return {type:'H',r:row+1,c:col};
  if(mn===dL) return {type:'V',r:row,  c:col};
              return {type:'V',r:row,  c:col+1};
}

function applySep(e){
  // Verrouiller la direction après quelques pixels de mouvement
  if(!sepDir && sepStart){
    var dx=Math.abs(e.clientX-sepStart.x), dy=Math.abs(e.clientY-sepStart.y);
    if(dx>4||dy>4) sepDir=(dy>=dx)?'V':'H'; // mouvement vertical → ligne V, mouvement horizontal → ligne H
  }
  var edge=getEdge(e, sepDir);
  var erase=e.buttons===2||e.button===2;
  if(edge.type==='H' && sepH[edge.r] && edge.c<numCols()){
    sepH[edge.r][edge.c]=!erase;
  } else if(edge.type==='V' && sepV[edge.r] && edge.r<numRows()){
    sepV[edge.r][edge.c]=!erase;
  }
  drawPx();
}

function previewRect(e){
  if(!pxDrawing||!rectStart) return;
  var cell=getCell(e), cp=cellPx();
  var r1=Math.min(rectStart.row,cell.row), r2=Math.max(rectStart.row,cell.row);
  var c1=Math.min(rectStart.col,cell.col), c2=Math.max(rectStart.col,cell.col);
  drawPx();
  var ctx=document.getElementById('px-c').getContext('2d');
  ctx.strokeStyle=pxCol; ctx.lineWidth=1.5; ctx.setLineDash([3,2]);
  ctx.strokeRect(c1*cp,r1*cp,(c2-c1+1)*cp,(r2-r1+1)*cp);
  ctx.setLineDash([]);
  var tip=document.getElementById('px-tip');
  var _wM=fmtM((c2-c1+1)*cellM), _hM=fmtM((r2-r1+1)*cellM);
  var _sM=((c2-c1+1)*cellM*(r2-r1+1)*cellM).toFixed(1);
  tip.textContent=_wM+'m × '+_hM+'m = '+_sM+' m²';
  var _outerR=document.getElementById('px-outer').getBoundingClientRect();
  tip.style.cssText='display:block;left:'+(e.clientX-_outerR.left+12)+'px;top:'+(e.clientY-_outerR.top-28)+'px';
}

function finalizeRect(e){
  if(!rectStart) return;
  var cell=getCell(e);
  var r1=Math.min(rectStart.row,cell.row), r2=Math.max(rectStart.row,cell.row);
  var c1=Math.min(rectStart.col,cell.col), c2=Math.max(rectStart.col,cell.col);
  if(pxTool==='frect'){
    for(var r=r1;r<=r2;r++) for(var c=c1;c<=c2;c++) setCell(r,c,pxCol);
  } else {
    for(var c=c1;c<=c2;c++){setCell(r1,c,pxCol);setCell(r2,c,pxCol);}
    for(var r=r1+1;r<r2;r++){setCell(r,c1,pxCol);setCell(r,c2,pxCol);}
  }
  // Auto-séparateurs : poser une ligne sur chaque arête du rectangle
  // où le voisin extérieur est une couleur différente (non nulle).
  autoSepRect(r1,r2,c1,c2,pxCol);
  drawPx(); savePxH(); drawPxPreview(); updatePxStats(); renderPxLegend(); updateRtypeCounts();
}

function autoSepRect(r1,r2,c1,c2,col){
  // Pose des séparateurs sur chaque arête du rectangle
  // où le voisin extérieur est une cellule colorée (même couleur ou différente).
  // Cela garantit que deux stands adjacents de la même couleur
  // restent visuellement séparés.
  var r,c;
  for(c=c1;c<=c2;c++){
    var above=(grid[r1-1]&&grid[r1-1][c])||null;
    var below=(grid[r2+1]&&grid[r2+1][c])||null;
    if(above){ if(!sepH[r1]) sepH[r1]=[]; sepH[r1][c]=true; }
    if(below){ if(!sepH[r2+1]) sepH[r2+1]=[]; sepH[r2+1][c]=true; }
  }
  for(r=r1;r<=r2;r++){
    var left=(grid[r]&&grid[r][c1-1])||null;
    var right=(grid[r]&&grid[r][c2+1])||null;
    if(left){ if(!sepV[r]) sepV[r]=[]; sepV[r][c1]=true; }
    if(right){ if(!sepV[r]) sepV[r]=[]; sepV[r][c2+1]=true; }
  }
}

function floodFill(sc,sr,newC){
  var oldC=grid[sr]&&grid[sr][sc]; if(oldC===newC) return;
  var stack=[[sr,sc]], vis={};
  while(stack.length){
    var cur=stack.pop(), r=cur[0], c=cur[1], k=r+','+c;
    if(vis[k]||r<0||r>=numRows()||c<0||c>=numCols()) continue;
    if(grid[r][c]!==oldC) continue;
    vis[k]=true; grid[r][c]=newC;
    // Expansion bloquée par les séparateurs
    if(!sepV[r]||!sepV[r][c+1]) stack.push([r,c+1]); // droite
    if(!sepV[r]||!sepV[r][c])   stack.push([r,c-1]); // gauche
    if(!sepH[r+1]||!sepH[r+1][c]) stack.push([r+1,c]); // bas
    if(!sepH[r]||!sepH[r][c])    stack.push([r-1,c]); // haut
  }
}

// ── Sélectionner un stand entier par flood-fill bloqué par les seps
// Retourne {cells:[{r,c,color}], r1,r2,c1,c2} ou null si cellule vide
function floodSelect(sr, sc){
  var startCol = grid[sr] && grid[sr][sc];
  if(!startCol) return null;
  var cells = [], r1=sr, r2=sr, c1=sc, c2=sc;
  var stack = [[sr, sc]], vis = {};
  while(stack.length){
    var cur=stack.pop(), r=cur[0], c=cur[1], k=r+','+c;
    if(vis[k] || r<0 || r>=numRows() || c<0 || c>=numCols()) continue;
    if(!grid[r] || !grid[r][c]) continue;
    vis[k] = true;
    cells.push({r:r, c:c, color:grid[r][c]});
    if(r<r1)r1=r; if(r>r2)r2=r; if(c<c1)c1=c; if(c>c2)c2=c;
    // Expansion bloquée par les séparateurs (même logique que floodFill)
    if(!(sepV[r]&&sepV[r][c+1])) stack.push([r, c+1]);
    if(!(sepV[r]&&sepV[r][c]))   stack.push([r, c-1]);
    if(!(sepH[r+1]&&sepH[r+1][c])) stack.push([r+1, c]);
    if(!(sepH[r]&&sepH[r][c]))     stack.push([r-1, c]);
  }
  return {cells:cells, r1:r1, r2:r2, c1:c1, c2:c2};
}

function setPxTool(t){
  pxTool=t;
  document.querySelectorAll('.ptbtn').forEach(function(el){el.classList.remove('on');});
  var el=document.getElementById('pt-'+t); if(el) el.classList.add('on');
  var names={hand:'Main',pencil:'Crayon',bucket:'Remplir',eraser:'Gomme',eyedrop:'Pipette',rect:'Vide',frect:'Plein',sep:'Séparateur',select:'Sélection'};
  if(t!=='select'){ pxSel=null; pxSelBuf=null; drawPx(); }
  // Curseur selon outil
  var cur=TOOL_CURSORS[t]||'crosshair';
  var c=document.getElementById('px-c'); if(c) c.style.cursor=cur;
  var g=document.getElementById('px-g'); if(g) g.style.cursor=cur;
  document.getElementById('st-tool').textContent=names[t]||t;
}
function setPxCol(c){
  pxCol=c;
  // Highlight matching zone type
  document.querySelectorAll('.rtype').forEach(function(el){
    el.classList.toggle('on', el.dataset.color===c);
  });
}
function pxZoomPct(){ return Math.round(pxZ*16/(pxPerM*cellM)*100); }
function setPxZoomPct(pct){ setPxZoom(pct/100*pxPerM*cellM/16); }
function setPxZoom(z){
  pxZ=Math.max(0.05,Math.min(10,z));
  var pct=pxZoomPct();
  var _pzEl=document.getElementById('px-zpct'); if(_pzEl) _pzEl.textContent=pct+'%';
  var _sl=document.getElementById('px-zslider'); if(_sl) _sl.value=pct;
  renderPxCanvas();
}
function fitPx(){
  var area=document.getElementById('px-area');
  var viewW=area.clientWidth||600, viewH=area.clientHeight||400;
  var cols=numCols(), rows=numRows();
  if(!cols||!rows) return;
  var zW=viewW*0.92/(cols*16), zH=viewH*0.92/(rows*16);
  var z=Math.min(zW,zH);
  setPxZoom(z);
  var cp=cellPx(), W=cols*cp, H=rows*cp;
  var pX=Math.round(viewW/2), pY=Math.round(viewH/2);
  area.scrollLeft=pX+W/2-viewW/2;
  area.scrollTop=pY+H/2-viewH/2;
}
function fitPxContent(){
  // Fit entire hall (same as fitPx) — consistent with vector side behavior
  fitPx();
}
function renderPalette(){
  document.getElementById('pal').innerHTML=PALETTE.map(function(c){
    return '<div class="pc" style="background:'+c+'" data-c="'+c+'" onclick="setPxCol(\''+c+'\')"></div>';
  }).join('');
}
// ===================================================
// VERROUILLAGE DE FORME PIXEL
// Une couleur verrouillee = cliquer 1 pixel selectionne
// tout le bloc contigu + ses separateurs => deplacement bloc
// ===================================================

// Verrouillage de forme supprimé (remplacé par groupes)
function renderRtypes(){
  refreshColorSources(); // keep GROUP_COLORS in sync with RTYPES
  // Compute cell counts per color for inline display
  var counts={};
  for(var r=0;r<numRows();r++) for(var c=0;c<numCols();c++){
    var col=grid[r]&&grid[r][c]; if(col) counts[col.toLowerCase()]=(counts[col.toLowerCase()]||0)+1;
  }
  var el=document.getElementById('rtypes');
  var html=RTYPES.map(function(r,i){
    var cnt=counts[r.color.toLowerCase()]||0;
    return '<div class="rtype" data-key="'+r.key+'" data-idx="'+i+'" data-color="'+r.color+'" draggable="true" onclick="setPxCol(\''+r.color+'\')">'
      +'<span class="rdrag" title="Réordonner">⠿</span>'
      +'<div class="rdot" style="background:'+r.color+'"></div>'
      +'<span style="flex:1">'+r.name+'</span>'
      +(cnt>0?'<span data-cnt="1" style="font-size:9px;color:var(--ac);min-width:20px;text-align:right">'+cnt+'</span>':'')
      +'</div>';
  }).join('');
  el.innerHTML=html;
  // Mirror into vector pane with layer controls (visibility, lock, opacity)
  vcInitTypeState();
  var vcEl=document.getElementById('vc-rtypes');
  if(vcEl){
    var vcHtml=RTYPES.map(function(r){
      var vis=vcTypeVis[r.key]!==false;
      var locked=vcTypeLock[r.key]===true;
      var op=vcTypeOp[r.key]||100;
      return '<div class="vc-rtype litem" data-key="'+r.key+'" onclick="vcSetStandType(\''+r.key+'\')" style="cursor:pointer">'
        +'<div class="ldot" style="background:'+r.color+'"></div>'
        +'<span class="lname" style="flex:1;font-size:11px">'+r.name+'</span>'
        +'<span class="licons">'
          +'<span class="licn'+(locked?' off':'')+'" id="vzt-k-'+r.key+'" onclick="vcTypeToggleLock(event,\''+r.key+'\')" title="Verrouiller">'+(locked?'🔒':'🔓')+'</span>'
          +'<span class="licn'+(!vis?' off':'')+'" id="vzt-v-'+r.key+'" onclick="vcTypeToggleVis(event,\''+r.key+'\')" title="Visibilité">'+(vis?'👁':'🙈')+'</span>'
        +'</span></div>'
        +'<div class="lop">'
          +'<input type="range" id="vzt-op-'+r.key+'" min="5" max="100" value="'+op+'" oninput="vcTypeSetOp(\''+r.key+'\',+this.value)">'
          +'<span id="vzt-op-'+r.key+'-lbl">'+op+'%</span>'
        +'</div>';
    }).join('');
    // Separator + Mesures
    var measVis=vcTypeVis._meas!==false;
    var measLock=vcTypeLock._meas===true;
    var measOp=vcTypeOp._meas||100;
    vcHtml+='<div style="height:1px;background:var(--bd);margin:4px 0"></div>';
    vcHtml+='<div class="litem" style="cursor:default">'
      +'<div class="ldot" style="background:var(--pink)"></div>'
      +'<span class="lname" style="flex:1;font-size:11px">Mesures</span>'
      +'<span class="licons">'
        +'<span class="licn'+(measLock?' off':'')+'" id="vzt-k-_meas" onclick="vcTypeToggleLock(event,\'_meas\')" title="Verrouiller">'+(measLock?'🔒':'🔓')+'</span>'
        +'<span class="licn'+(!measVis?' off':'')+'" id="vzt-v-_meas" onclick="vcTypeToggleVis(event,\'_meas\')" title="Visibilité">'+(measVis?'👁':'🙈')+'</span>'
      +'</span></div>'
      +'<div class="lop">'
        +'<input type="range" id="vzt-op-_meas" min="5" max="100" value="'+measOp+'" oninput="vcTypeSetOp(\'_meas\',+this.value)">'
        +'<span id="vzt-op-_meas-lbl">'+measOp+'%</span>'
      +'</div>';
    vcEl.innerHTML=vcHtml;
  }
  vcHighlightRtype();
  initRtypesDnd();
}

// Mise à jour légère des compteurs de cellules dans la liste Types de Zones
// (sans reconstruire le DOM ni le drag-and-drop)
function updateRtypeCounts(){
  var counts={};
  for(var r=0;r<numRows();r++) for(var c=0;c<numCols();c++){
    var col=grid[r]&&grid[r][c]; if(col) counts[col.toLowerCase()]=(counts[col.toLowerCase()]||0)+1;
  }
  document.querySelectorAll('#rtypes .rtype').forEach(function(el){
    var color=(el.dataset.color||'').toLowerCase();
    var cnt=counts[color]||0;
    // Le span compteur est le dernier enfant (s'il existe)
    var existing=el.querySelector('[data-cnt]');
    if(cnt>0){
      if(existing){ existing.textContent=cnt; }
      else {
        var sp=document.createElement('span');
        sp.setAttribute('data-cnt','1');
        sp.style.cssText='font-size:9px;color:var(--ac);min-width:20px;text-align:right';
        sp.textContent=cnt;
        el.appendChild(sp);
      }
    } else {
      if(existing) existing.remove();
    }
  });
}

function initRtypesDnd(){
  var items=document.querySelectorAll('#rtypes .rtype');
  var dragIdx=null;
  items.forEach(function(el){
    el.addEventListener('dragstart',function(e){
      dragIdx=parseInt(el.dataset.idx);
      setTimeout(function(){el.classList.add('dragging');},0);
      e.dataTransfer.effectAllowed='move';
    });
    el.addEventListener('dragend',function(){
      el.classList.remove('dragging');
      document.querySelectorAll('#rtypes .rtype').forEach(function(x){x.classList.remove('drag-over');});
      dragIdx=null;
    });
    el.addEventListener('dragover',function(e){
      e.preventDefault();
      e.dataTransfer.dropEffect='move';
      document.querySelectorAll('#rtypes .rtype').forEach(function(x){x.classList.remove('drag-over');});
      el.classList.add('drag-over');
    });
    el.addEventListener('drop',function(e){
      e.preventDefault();
      var targetIdx=parseInt(el.dataset.idx);
      if(dragIdx===null||dragIdx===targetIdx) return;
      var moved=RTYPES.splice(dragIdx,1)[0];
      RTYPES.splice(targetIdx,0,moved);
      renderRtypes(); renderPxLegend();
    });
  });
}
// ═══════════════════════════════════════════════════════════════
// CALQUES MODÉRATEURS
// Chaque calque = {id, name, grid, sepH, sepV} indépendant
// ================================================================
// CALQUES MODERATEURS — Architecture "Principal + Forks"
//
// MOD_LAYERS[0]  = Principal (toujours present, non supprimable)
// MOD_LAYERS[1+] = versions fork pour chaque moderateur
//
// Les deux panels (px-mod-* et vc-mod-*) sont synchronises :
// toute modification met a jour les deux simultanement.
// ================================================================

var _modNameFormMode = null; // 'fork' | 'fork-from' | 'rename'

// --- Helpers DOM dual-panel ---

// Retourne les elements [px-XXX, vc-XXX] qui existent dans le DOM
function _modBoth(suffix){
  return ['px-','vc-'].map(function(p){ return document.getElementById(p+suffix); }).filter(Boolean);
}

// Retourne l'element du panel actif (pour lire une valeur saisie)
function _modActive(suffix){
  var p = (activeTab==='vc') ? 'vc-' : 'px-';
  return document.getElementById(p+suffix);
}

// Cache tous les formulaires dans les deux panels
function modHideForms(){
  _modBoth('mod-name-form').forEach(function(el){ el.style.display='none'; });
  _modBoth('mod-del-confirm').forEach(function(el){ el.style.display='none'; });
}

// Affiche le formulaire de saisie dans les deux panels, focus sur le panel actif
function modShowNameForm(title, value, doSelect){
  _modBoth('mod-name-form-title').forEach(function(el){ el.textContent=title; });
  _modBoth('mod-name-inp').forEach(function(el){ el.value=value; });
  _modBoth('mod-name-form').forEach(function(el){ el.style.display='flex'; el.style.flexDirection='column'; });
  var inp = _modActive('mod-name-inp');
  if(inp) setTimeout(function(){ doSelect ? inp.select() : inp.focus(); }, 50);
}

// Affiche la confirmation de suppression dans les deux panels
function modShowDelConfirm(){
  _modBoth('mod-del-confirm').forEach(function(el){ el.style.display='block'; });
}

// Lit la valeur saisie dans le panel actif
function modGetName(){
  var el = _modActive('mod-name-inp');
  return el ? el.value.trim() : '';
}

// --- Copie profonde de grilles ---
function modCloneGrid(g){ return g.map(function(r){ return r.slice(); }); }

// --- Persistence ---

// Sauvegarde l'etat courant (grid, sepH, sepV) dans le calque actif
function modLayerSaveCurrent(){
  if(MOD_LAYERS.length===0) return;
  // Skip saving during state loading to prevent overwriting MOD_LAYERS with empty/stale data
  if(_stateLoading) return;
  // Safety: ensure vcAssigns is always a plain object (never an array from bad JSON)
  if(Array.isArray(vcAssigns)) vcAssigns={};
  var lay = MOD_LAYERS[activeModLayer];
  // Sauvegarder l'état pixel
  lay.grid = modCloneGrid(grid);
  lay.sepH = modCloneGrid(sepH);
  lay.sepV  = modCloneGrid(sepV);
  modTypeStateSave(lay);
  // Sauvegarder l'état vectoriel (si le canvas existe)
  if(vc){
    lay.vcJSON = vc.toJSON(['_layer','_hall','_bg','sData','_measData','_groupOverlay']);
    lay.vcAssigns = JSON.parse(JSON.stringify(vcAssigns));
    lay.vcStandN = vcStandN;
    lay.vcGroups = JSON.parse(JSON.stringify(vcGroups));
    // Push vector undo snapshot — strip _bg image to avoid heavy re-deserialization
    // Deduplicate: only push if state actually changed (compare quick fingerprint)
    if(!_vcUndoing && activeTab==='vc'){
      var _nObjs=lay.vcJSON.objects?lay.vcJSON.objects.length:0;
      var _nAsgn=Object.keys(vcAssigns).length;
      var _nGrps=vcGroups.length;
      var _fp=_nObjs+','+vcStandN+','+_nAsgn+','+_nGrps;
      // Also include object positions for move detection
      if(lay.vcJSON.objects){
        for(var _oi=0;_oi<lay.vcJSON.objects.length;_oi++){
          var _ob=lay.vcJSON.objects[_oi];
          if(_ob.sData) _fp+=','+Math.round((_ob.left||0)*10)+':'+Math.round((_ob.top||0)*10);
        }
      }
      var _prevFp=vcHist.length>0?vcHist[vcHistIdx]._fp:'';
      if(_fp!==_prevFp){
        var _undoJSON=JSON.parse(JSON.stringify(lay.vcJSON));
        _undoJSON.objects=_undoJSON.objects.filter(function(o){ return !o._bg; });
        vcHist=vcHist.slice(0,vcHistIdx+1);
        vcHist.push({vcJSON:_undoJSON, vcAssigns:JSON.parse(JSON.stringify(vcAssigns)), vcStandN:vcStandN, vcGroups:JSON.parse(JSON.stringify(vcGroups)), _fp:_fp});
        if(vcHist.length>40) vcHist.shift();
        vcHistIdx=vcHist.length-1;
      }
    }
  }
}

// Charge le calque idx : sauvegarde l'actuel puis bascule
// skipSave=true lors de la suppression d'un fork (ne pas sauver l'état du fork supprimé)
function modLayerLoad(idx, skipSave){
  if(idx<0||idx>=MOD_LAYERS.length) return;
  if(!skipSave) modLayerSaveCurrent();
  activeModLayer = idx;
  // Reset vector undo history when switching layers
  vcHist=[]; vcHistIdx=-1;
  var lay = MOD_LAYERS[idx];
  modTypeStateLoad(lay);
  // Restaurer l'état pixel
  grid = modCloneGrid(lay.grid);
  sepH = modCloneGrid(lay.sepH);
  sepV  = modCloneGrid(lay.sepV);
  savePxH();
  drawPx(); drawPxPreview(); updatePxStats(); renderPxLegend(); updateRtypeCounts();
  // Restaurer l'état vectoriel si disponible
  if(vc && lay.vcJSON){
    _suppressDirty=true;
    // Disable per-object renders during loadFromJSON to avoid clearRect errors
    var _oldROAR3=vc.renderOnAddRemove;
    vc.renderOnAddRemove=false;
    vc.loadFromJSON(lay.vcJSON, function(){
      vc.renderOnAddRemove=_oldROAR3;
      _suppressDirty=false;
      // Reconstruire vcLayers depuis les objets chargés + restaurer vcBgObj
      vcLayers={stands:[],aisles:[],struct:[],annot:[],meas:[]};
      vcBgObj=null;
      vc.getObjects().forEach(function(o){
        if(o._layer && vcLayers[o._layer]) vcLayers[o._layer].push(o);
        if(o._bg){
          vcBgObj=o;
          bgVisible=o.visible!==false;
          bgOpacity=o.opacity||0.7;
          bgLocked=!o.selectable;
        }
      });
      // Restore pxPerM from loaded hall border to prevent rescaling distortion
      var _hallObj = vc.getObjects().find(function(o){ return o._hall; });
      if(_hallObj && hallW > 0) pxPerM = _hallObj.width / hallW;
      // Ensure all loaded objects have correct coords (prevents jump on first click)
      vc.getObjects().forEach(function(o){ o.setCoords(); });
      // Rebuild stand text/stroke scaling for current pxPerM
      vcLayers.stands.forEach(function(grp){
        var items=grp.getObjects();
        var r=items[0]; if(!r||r.type!=='rect') return;
        var w=r.width, h=r.height;
        var mp=Math.min(w,h);
        var sw=Math.max(0.3,Math.min(2,mp*.04));
        var showNum=mp>4, showDim=mp>18;
        var fs,fss;
        if(showDim){fs=Math.max(5,Math.min(16,mp*.18));fss=Math.max(4,Math.min(10,mp*.11));}
        else{fs=Math.max(4,Math.min(16,mp*.28));fss=4;}
        r.set({strokeWidth:sw, rx:0});
        var lb=items[1], dm=items[items.length-1], ex=items.length>=4?items[2]:null;
        if(_isText(lb)){
          lb.set({text:showNum?(grp.sData?grp.sData.num:''):'', fontSize:fs});
        }
        if(_isText(dm)){
          var wM=grp.sData?grp.sData.wm:'', hM=grp.sData?grp.sData.hm:'';
          dm.set({text:showDim?wM+'×'+hM+'m':'', fontSize:fss});
        }
        // Ensure expo name slot exists (upgrade old 3-item stands to 4-item)
        if(!ex){
          var _c2=grp.sData?getStandColor(grp.sData.type):{stroke:'#000'};
          var exFs=Math.max(3,Math.min(11,mp*.13));
          ex=new fabric.Textbox('',{left:w/2,top:h/2,originX:'center',originY:'center',fontSize:exFs,fill:_c2.stroke+'cc',fontFamily:'system-ui',fontWeight:'600',width:w*0.9,textAlign:'center',splitByGrapheme:false,editable:false});
          grp.insertAt(ex,2);
        }
        _layoutStandLabels(lb,ex,dm,w,h);
        if(!grp.clipPath){
          grp.set({width:w, height:h});
          grp.clipPath=new fabric.Rect({width:w, height:h, originX:'center', originY:'center'});
        }
        grp.setCoords();
      });
      var _rawA = lay.vcAssigns ? JSON.parse(JSON.stringify(lay.vcAssigns)) : {};
      vcAssigns = Array.isArray(_rawA) ? {} : _rawA;
      vcStandN = lay.vcStandN || 1;
      vcGroups = lay.vcGroups ? JSON.parse(JSON.stringify(lay.vcGroups)) : [];
      // Re-apply exhibitor name labels + lock state for assigned stands
      vcLayers.stands.forEach(function(grp){
        if(!grp.sData) return;
        var _a=vcAssigns[grp.sData.id];
        if(_a && _a.expo){
          var _items=grp.getObjects();
          var _lbl=grp.sData.num||'';
          if(grp.sData.hall) _lbl=grp.sData.hall+_lbl;
          if(_isText(_items[1])) _items[1].set('text', _lbl);
          var _exSlot=_items.length>=4?_items[2]:null;
          if(_isText(_exSlot)) _exSlot.set('text', _a.expo.name||'');
          var _r0=_items[0]; if(_r0) _layoutStandLabels(_items[1],_exSlot,_items[_items.length-1],_r0.width,_r0.height);
          if(_a.status==='locked') grp.set({lockMovementX:true, lockMovementY:true});
        }
      });
      // Strip stale group overlay objects from loaded JSON before rebuilding
      vcStripOverlays();
      // Réappliquer les couleurs de groupe sur les stands restaurés
      vcInitStandAbsPos(true);
      vcGroups.forEach(function(g){ vcApplyGroupColor(g); });
      // If there are converted PX groups, resync grid from current VC positions
      var _hasConvGrps = vcGroups.some(function(g){ return g.isPxGroup && g.standIds && g.standIds.length > 0; });
      if(_hasConvGrps){ _doVcToPxData(); }
      // Recompute pxCells from VC stand positions + apply colors to grid
      _recomputeConvertedGroupPxCells();
      _applyPxGroupColorsToGrid();
      drawPx(); renderGroupsList();
      rebuildGroupOverlays(); // appelle renderGroupsList en interne
      rebuildHallBorder();
      setVcTool(vcTool);
      vc.calcOffset(); // prevent viewport jump on first click
      vc.discardActiveObject();
      vc.requestRenderAll();
      updateVcStatus();
      vcDesel();
      renderExp();
      vcApplyTypeState(); renderRtypes();
    });
  } else {
    // Pas de vcJSON — restaurer au moins les assigns + rafraîchir la liste
    if(lay.vcAssigns){ var _rawA2=JSON.parse(JSON.stringify(lay.vcAssigns)); vcAssigns=Array.isArray(_rawA2)?{}:_rawA2; }
    if(lay.vcStandN) vcStandN = lay.vcStandN;
    if(lay.vcGroups) vcGroups = JSON.parse(JSON.stringify(lay.vcGroups));
    if(vc) { vc.discardActiveObject(); vc.requestRenderAll(); }
    vcDesel();
    renderExp();
    vcApplyTypeState(); renderRtypes();
  }
  modHideForms();
  renderModTabs();
}

// --- Actions boutons ---

// Bouton "Forker pour un moderateur" : fork depuis le Principal
function modLayerFork(){
  _modNameFormMode = 'fork';
  modShowNameForm('Nom du moderateur', '');
}

// Bouton "Dupliquer ce calque" : fork depuis le calque actif
function modLayerForkFrom(){
  _modNameFormMode = 'fork-from';
  var src = MOD_LAYERS[activeModLayer];
  modShowNameForm('Dupliquer "'+src.name+'"', src.name+' (copie)', true);
}

// Bouton "Renommer"
function modLayerRenameUI(){
  _modNameFormMode = 'rename';
  modShowNameForm('Nouveau nom', MOD_LAYERS[activeModLayer].name, true);
}

// Bouton "Annuler" dans le formulaire
function modNameFormCancel(){
  modHideForms();
  _modNameFormMode = null;
}

// Bouton "Confirmer" dans le formulaire
function modNameFormConfirm(){
  var name = modGetName();
  if(!name) return;
  modHideForms();

  if(_modNameFormMode==='fork' || _modNameFormMode==='fork-from'){
    // Capturer l'index source AVANT tout traitement
    var srcIdx = activeModLayer;
    // Forcer la sauvegarde de l'état courant (pixel + VC) dans le calque source
    var lay = MOD_LAYERS[srcIdx];
    lay.grid = modCloneGrid(grid);
    lay.sepH = modCloneGrid(sepH);
    lay.sepV  = modCloneGrid(sepV);
    if(vc){
      lay.vcJSON = vc.toJSON(['_layer','_hall','_bg','sData','_measData','_groupOverlay']);
      lay.vcAssigns = JSON.parse(JSON.stringify(vcAssigns));
      lay.vcStandN = vcStandN;
      lay.vcGroups = JSON.parse(JSON.stringify(vcGroups));
    }
    // Créer le nouveau calque comme copie exacte du calque source
    var src = MOD_LAYERS[srcIdx];
    MOD_LAYERS.push({
      id:'mod_'+Date.now(), name:name, isPrincipal:false,
      grid:modCloneGrid(src.grid),
      sepH:modCloneGrid(src.sepH),
      sepV: modCloneGrid(src.sepV),
      vcJSON: src.vcJSON ? JSON.parse(JSON.stringify(src.vcJSON)) : null,
      vcAssigns: src.vcAssigns ? JSON.parse(JSON.stringify(src.vcAssigns)) : {},
      vcStandN: src.vcStandN || 1,
      vcGroups: src.vcGroups ? JSON.parse(JSON.stringify(src.vcGroups)) : [],
      typeState: src.typeState ? JSON.parse(JSON.stringify(src.typeState)) : undefined
    });
    modLayerLoad(MOD_LAYERS.length-1);

  } else if(_modNameFormMode==='rename'){
    MOD_LAYERS[activeModLayer].name = name;
    renderModTabs();
  }
  _modNameFormMode = null;
}

// Bouton "Supprimer" : affiche confirmation inline
function modLayerAskDelete(){
  if(activeModLayer===0) return; // Principal indestructible
  modShowDelConfirm();
}

// Bouton "Confirmer suppression"
function modLayerDeleteConfirmed(){
  modHideForms();
  if(activeModLayer===0||MOD_LAYERS.length<=1) return;
  MOD_LAYERS.splice(activeModLayer,1);
  activeModLayer = Math.min(activeModLayer, MOD_LAYERS.length-1);
  modLayerLoad(activeModLayer, true); // skipSave: ne pas écraser la cible avec l'état du fork supprimé
}

// --- Rendu des tabs (mise a jour simultanee px + vc) ---

function renderModTabs(){
  _renderModTabsFor('px-');
  _renderModTabsFor('vc-');
  _renderModBar();
}

function _renderModBar(){
  var bar = document.getElementById('mod-bar'); if(!bar) return;
  bar.innerHTML = MOD_LAYERS.map(function(lay,i){
    var isActive = (i===activeModLayer);
    var isPrincipal = !!lay.isPrincipal;
    var cls = 'mtab' + (isActive ? ' on' : '') + (!isPrincipal ? ' fork' : '');
    var icon = isPrincipal ? '&#127968; ' : '&#128100; ';
    return '<button class="'+cls+'" data-idx="'+i+'">'+icon+lay.name+'</button>';
  }).join('');
  bar.querySelectorAll('[data-idx]').forEach(function(btn){
    btn.addEventListener('click', function(){ modLayerLoad(parseInt(btn.dataset.idx)); });
  });
}

function _renderModTabsFor(prefix){
  var el = document.getElementById(prefix+'mod-tabs'); if(!el) return;
  var actionsEl    = document.getElementById(prefix+'mod-actions');
  var activeNameEl = document.getElementById(prefix+'mod-active-name');

  el.innerHTML = MOD_LAYERS.map(function(lay,i){
    var isActive    = (i===activeModLayer);
    var isPrincipal = !!lay.isPrincipal;
    var bg = isActive
      ? (isPrincipal
          ? 'background:rgba(52,211,153,.15);border-color:rgba(52,211,153,.5);color:#34d399'
          : 'background:rgba(91,108,249,.15);border-color:rgba(91,108,249,.5);color:#8b9fff')
      : 'background:var(--bg3);border-color:var(--bd);color:var(--mu)';
    var icon = isPrincipal ? '&#127968; ' : '&#128100; ';
    return '<button data-idx="'+i+'" style="width:100%;padding:5px 8px;border-radius:5px;border:1.5px solid;cursor:pointer;font-size:10px;font-family:inherit;text-align:left;transition:all .1s;'+bg+'">'+icon+lay.name+'</button>';
  }).join('');

  el.querySelectorAll('[data-idx]').forEach(function(btn){
    btn.addEventListener('click', function(){ modLayerLoad(parseInt(btn.dataset.idx)); });
  });

  var isModActive = (activeModLayer>0);
  if(actionsEl)    actionsEl.style.display = isModActive ? 'flex' : 'none';
  if(activeNameEl) activeNameEl.textContent = isModActive ? 'Version : '+MOD_LAYERS[activeModLayer].name : '';
}

// Initialise le calque Principal au demarrage (appele depuis initPx)
function modInitPrincipal(){
  MOD_LAYERS = [{
    id:'principal', name:'Principal', isPrincipal:true,
    grid:modCloneGrid(grid),
    sepH:modCloneGrid(sepH),
    sepV: modCloneGrid(sepV),
    vcJSON: null, vcAssigns: {}, vcStandN: 1, vcGroups: []
  }];
  activeModLayer = 0;
  renderModTabs();
  renderGroupsList();
}
function clearPx(){
  savePxH();
  grid=makeEmptyGrid(); var s=makeEmptySep(); sepH=s.h; sepV=s.v;
  drawPx(); drawPxPreview(); updatePxStats(); renderPxLegend(); updateRtypeCounts();
  // Synchroniser le calque actif avec le plan efface
  modLayerSaveCurrent();
}
function savePxH(){
  hist=hist.slice(0,histIdx+1);
  hist.push({
    grid:grid.map(function(r){return r.slice();}),
    sepH:sepH.map(function(r){return r.slice();}),
    sepV:sepV.map(function(r){return r.slice();})
  });
  if(hist.length>80) hist.shift();
  histIdx=hist.length-1;
  if(!_suppressDirty&&_dirtyNotify) _dirtyNotify(true);
}
function undoPx(){
  if(histIdx<=0) return;
  histIdx--;
  var h=hist[histIdx];
  grid=h.grid.map(function(r){return r.slice();});
  sepH=h.sepH.map(function(r){return r.slice();});
  sepV=h.sepV.map(function(r){return r.slice();});
  drawPx(); drawPxPreview(); updatePxStats(); renderPxLegend(); updateRtypeCounts();
}

// ── Vector undo ── (history is captured inside modLayerSaveCurrent)
function undoVc(){
  if(!vc || vcHistIdx<=0 || _vcUndoing) return;
  vcHistIdx--;
  var h=vcHist[vcHistIdx];
  _vcUndoing=true;
  _suppressDirty=true;
  // Save reference to current bg image (stripped from undo JSON for performance)
  var _savedBg=vcBgObj;
  if(_savedBg) vc.remove(_savedBg);
  // Disable per-object renders during loadFromJSON to avoid clearRect errors
  // on partially-initialised objects (Groups with clipPaths, etc.)
  var _oldROAR=vc.renderOnAddRemove;
  vc.renderOnAddRemove=false;
  vc.loadFromJSON(h.vcJSON, function(){
    vc.renderOnAddRemove=_oldROAR;
    _suppressDirty=false;
    // Rebuild vcLayers from loaded objects
    vcLayers={stands:[],aisles:[],struct:[],annot:[],meas:[]};
    vc.getObjects().forEach(function(o){
      if(o._layer && vcLayers[o._layer]) vcLayers[o._layer].push(o);
    });
    // Re-add the background image (not in undo JSON)
    vcBgObj=null;
    if(_savedBg){
      vcBgObj=_savedBg;
      vc.add(_savedBg);
    }
    var _hallObj=vc.getObjects().find(function(o){ return o._hall; });
    if(_hallObj && hallW>0) pxPerM=_hallObj.width/hallW;
    // Rebuild stand text/stroke scaling for current pxPerM
    vcLayers.stands.forEach(function(grp){
      var items=grp.getObjects();
      var r=items[0]; if(!r||r.type!=='rect') return;
      var w=r.width, h=r.height;
      var mp=Math.min(w,h);
      var _sw=Math.max(0.3,Math.min(2,mp*.04));
      var _showNum=mp>4, _showDim=mp>18;
      var _fs,_fss;
      if(_showDim){_fs=Math.max(5,Math.min(16,mp*.18));_fss=Math.max(4,Math.min(10,mp*.11));}
      else{_fs=Math.max(4,Math.min(16,mp*.28));_fss=4;}
      r.set({strokeWidth:_sw, rx:0});
      var lb=items[1], dm=items[items.length-1], ex=items.length>=4?items[2]:null;
      if(_isText(lb)){
        lb.set({text:_showNum?(grp.sData?grp.sData.num:''):'', fontSize:_fs});
      }
      if(_isText(dm)){
        var _wM=grp.sData?grp.sData.wm:'', _hM=grp.sData?grp.sData.hm:'';
        dm.set({text:_showDim?_wM+'×'+_hM+'m':'', fontSize:_fss});
      }
      if(!ex){
        var _c3=grp.sData?getStandColor(grp.sData.type):{stroke:'#000'};
        var _exFs2=Math.max(3,Math.min(11,mp*.13));
        ex=new fabric.Textbox('',{left:w/2,top:h/2,originX:'center',originY:'center',fontSize:_exFs2,fill:_c3.stroke+'cc',fontFamily:'system-ui',fontWeight:'600',width:w*0.9,textAlign:'center',splitByGrapheme:false,editable:false});
        grp.insertAt(ex,2);
      }
      _layoutStandLabels(lb,ex,dm,w,h);
      if(!grp.clipPath){
        grp.set({width:w, height:h});
        grp.clipPath=new fabric.Rect({width:w, height:h, originX:'center', originY:'center'});
      }
      grp.setCoords();
    });
    var _rawAU=JSON.parse(JSON.stringify(h.vcAssigns)); vcAssigns=Array.isArray(_rawAU)?{}:_rawAU;
    vcStandN=h.vcStandN;
    vcGroups=JSON.parse(JSON.stringify(h.vcGroups));
    // Re-apply exhibitor name labels + lock state for assigned stands
    vcLayers.stands.forEach(function(grp){
      if(!grp.sData) return;
      var _aU=vcAssigns[grp.sData.id];
      if(_aU && _aU.expo){
        var _itU=grp.getObjects();
        var _lblU=grp.sData.num||'';
        if(grp.sData.hall) _lblU=grp.sData.hall+_lblU;
        if(_isText(_itU[1])) _itU[1].set('text', _lblU);
        var _exU=_itU.length>=4?_itU[2]:null;
        if(_isText(_exU)) _exU.set('text', _aU.expo.name||'');
        var _rU=_itU[0]; if(_rU) _layoutStandLabels(_itU[1],_exU,_itU[_itU.length-1],_rU.width,_rU.height);
        if(_aU.status==='locked') grp.set({lockMovementX:true, lockMovementY:true});
      }
    });
    vcStripOverlays();
    vcInitStandAbsPos(true);
    vcGroups.forEach(function(g){ vcApplyGroupColor(g); });
    rebuildGroupOverlays();
    rebuildHallBorder();
    setVcTool(vcTool);
    vc.discardActiveObject();
    vc.requestRenderAll();
    updateVcStatus();
    vcDesel();
    renderExp();
    _vcUndoing=false;
    modLayerSaveCurrent();
  });
}

function drawPxPreview(){
  var prev=document.getElementById('px-prev');
  if(!prev) return;
  var pw=prev.clientWidth||160, ph=prev.height||100;
  prev.width=pw;
  var ctx=prev.getContext('2d'), C=numCols(), R=numRows();
  var sc=Math.min(pw/C,ph/R);
  ctx.fillStyle='#ffffff'; ctx.fillRect(0,0,pw,ph);
  if(bgImg&&bgVisible){
    ctx.globalAlpha=bgOpacity;
    ctx.drawImage(bgImg,0,0,Math.round((bgRealW/hallW)*C*sc),Math.round((bgRealH/hallH)*R*sc));
    ctx.globalAlpha=1;
  }
  for(var r=0;r<R;r++) for(var c=0;c<C;c++){
    if(grid[r]&&grid[r][c]){ ctx.fillStyle=grid[r][c]; ctx.fillRect(Math.floor(c*sc),Math.floor(r*sc),Math.ceil(sc),Math.ceil(sc)); }
  }
}

// ── Appel centralisé après chaque modification grid
function afterGridChange(){
  drawPxPreview(); updatePxStats(); renderPxLegend(); renderRtypes(); renderLockList();
}

function renderPxLegend(){
  var counts={};
  for(var r=0;r<numRows();r++) for(var c=0;c<numCols();c++){
    var col=grid[r]&&grid[r][c]; if(col) counts[col.toLowerCase()]=(counts[col.toLowerCase()]||0)+1;
  }
  // Build color→name map with lowercase keys for robust matching
  var rMap={}; RTYPES.forEach(function(r){rMap[r.color.toLowerCase()]=r.name;});
  var ent=Object.keys(counts).map(function(k){return[k,counts[k]];}).sort(function(a,b){return b[1]-a[1];});
  document.getElementById('px-leg').innerHTML=ent.slice(0,8).map(function(e){
    return '<div class="legrow"><div class="legsq" style="background:'+e[0]+'"></div>'
      +(rMap[e[0].toLowerCase()]||e[0])+' <span style="margin-left:auto;color:var(--ac)">'+e[1]+'</span></div>';
  }).join('');
}

function updatePxStats(){
  var total=numCols()*numRows(), used=0;
  for(var r=0;r<numRows();r++) for(var c=0;c<numCols();c++) if(grid[r]&&grid[r][c]) used++;
  // Write stats to the status bar
  var stPx=document.getElementById('st-px-stats');
  if(stPx) stPx.innerHTML='Cellules : <b>'+used+'/'+total+'</b> · Couverture : <b>'+(used/total*100).toFixed(1)+'%</b> · Grille : <b>'+numCols()+'×'+numRows()+'</b>';
}

// Calque dessin pixel — opacité et visibilité
function pxSetOp(val){
  // Sync all sliders (hidden sidebar + modal)
  ['lpx-op','mbg-op-dessin'].forEach(function(id){
    var el=document.getElementById(id); if(el) el.value=val;
  });
  ['lpx-op-lbl','mbg-op-dessin-lbl'].forEach(function(id){
    var el=document.getElementById(id); if(el) el.textContent=val+'%';
  });
  document.getElementById('px-c').style.opacity=val/100;
}
function pxToggleVis(){
  var c=document.getElementById('px-c'), icn=document.getElementById('lpx-vis');
  var vis=c.style.display!=='none';
  c.style.display=vis?'none':'block';
  icn.classList.toggle('off',vis);
  icn.textContent=vis?'🙈':'👁';
}

function loadDemoToPx(){
  getDemoStands().forEach(function(d){
    var c1=Math.max(0,Math.round(d.x/cellM));
    var r1=Math.max(0,Math.round(d.y/cellM));
    var c2=Math.min(numCols()-1,Math.round((d.x+d.w)/cellM)-1);
    var r2=Math.min(numRows()-1,Math.round((d.y+d.h)/cellM)-1);
    var col=typeToColor(d.t);
    for(var r=r1;r<=r2;r++) for(var c=c1;c<=c2;c++) setCell(r,c,col);
  });
  drawPx(); drawPxPreview(); updatePxStats(); renderPxLegend(); updateRtypeCounts();
}

// ═══════════════════════════════════════
// VECTOR ENGINE
// ═══════════════════════════════════════
var vc=null, vcTool='select', vcLayer='stands', vcZ=1;
var _dirtyNotify=null, _suppressDirty=false, _vcLoadingJSON=false, _stateLoading=false;
var vcDrawing=false, vcSx=0, vcSy=0, vcDObj=null, vcClickX=0, vcClickY=0, vcStandN=1;
var vcLayers={stands:[],aisles:[],struct:[],annot:[],meas:[]};
var vcAssigns={}, vcSelStand=null, vcInited=false, _vcSingleStandSelect=false, _vcIsolatedStand=false;
var vcGroups=[]; // [{id,name,color,standIds:[]}]
var vcHist=[], vcHistIdx=-1, _vcUndoing=false;
// Statuts d'assignement exposant
var ASSIGN_STATUS={
  free:   {key:'free',   label:'Free',   cls:'s-pending'},
  locked: {key:'locked', label:'Locked', cls:'s-final'}
};

var STAND_C={
  standard:{fill:'rgba(91,108,249,.12)',  stroke:'#5b6cf9'},
  premium: {fill:'rgba(245,158,11,.12)',  stroke:'#f59e0b'},
  corner:  {fill:'rgba(52,211,153,.12)',  stroke:'#34d399'},
  island:  {fill:'rgba(244,114,182,.12)', stroke:'#f472b6'},
};

var _measEditBusy=false;
function vcEditMeasure(_mt){
  if(!_mt) return;
  var _a, _b;
  if(_mt._measData){
    var _md=_mt._measData, _mx=_mt.calcTransformMatrix();
    _a=fabric.util.transformPoint({x:_md.lx1,y:_md.ly1},_mx);
    _b=fabric.util.transformPoint({x:_md.lx2,y:_md.ly2},_mx);
  } else {
    // Older saved measures have no _measData: derive endpoints from the main line
    var _ln=(_mt.getObjects?_mt.getObjects():[]).filter(function(o){return o.type==='line';})[0];
    if(!_ln) return;
    var _lp=_ln.calcLinePoints(), _lm=_ln.calcTransformMatrix();
    _a=fabric.util.transformPoint({x:_lp.x1,y:_lp.y1},_lm);
    _b=fabric.util.transformPoint({x:_lp.x2,y:_lp.y2},_lm);
  }
  var _dx=_b.x-_a.x, _dy=_b.y-_a.y, _len=Math.sqrt(_dx*_dx+_dy*_dy);
  if(_len<0.001) return;
  var _cur=pxToM(_len);
  var _in=window.prompt('Longueur / Length (m)', (+_cur).toFixed(1));
  if(_in===null) return;
  var _nv=parseFloat(String(_in).replace(',','.'));
  if(!isFinite(_nv)||_nv<=0) return;
  var _nl=_nv*pxPerM;
  var _ex=_a.x+_dx/_len*_nl, _ey=_a.y+_dy/_len*_nl;
  vcLayers.meas=vcLayers.meas.filter(function(o){return o!==_mt;});
  vc.remove(_mt);
  var _nm=addMeasure(_a.x,_a.y,_ex,_ey);
  if(_nm){ vc.setActiveObject(_nm); }
  vc.requestRenderAll();
  if(!_suppressDirty&&_dirtyNotify) _dirtyNotify(true);
}

var _vcInitDone=false;
function initVc(){
  if(_vcInitDone) return;
  var _vcA=document.getElementById('vc-area');
  vc=new fabric.Canvas('vc-c',{width:_vcA.clientWidth||800,height:_vcA.clientHeight||600,backgroundColor:'#e8ecf0'});
  vc.on('mouse:down',vcDown); vc.on('mouse:move',vcMove); vc.on('mouse:up',vcUp);
  vc.on('selection:created',vcSel); vc.on('selection:updated',vcSel); vc.on('selection:cleared',vcDesel);
  vc.on('object:scaling',vcScaling); vc.on('object:modified',vcModified);
  vc.on('object:moving',vcClampToHall); vc.on('object:scaling',vcClampToHall);
  // Double-click: select individual stand even if it belongs to a group
  vc.on('mouse:dblclick', function(opt){
    // Double-click on a measure line: edit its length
    var _mt=opt.target;
    if(_mt && _mt._layer==='meas'){ if(!_measEditBusy){ _measEditBusy=true; try{ vcEditMeasure(_mt); } finally { setTimeout(function(){ _measEditBusy=false; },0); } } return; }
    // Find stand under pointer directly — subTargets is unreliable for ActiveSelection
    var pointer=vc.getPointer(opt.e);
    var target=null;
    for(var si=vcLayers.stands.length-1;si>=0;si--){
      var st=vcLayers.stands[si];
      if(!st.sData) continue;
      var m=st.calcTransformMatrix();
      var sw=(st.width||0)*(st.scaleX||1), sh=(st.height||0)*(st.scaleY||1);
      var sx=m[4]-sw/2, sy=m[5]-sh/2;
      if(pointer.x>=sx && pointer.x<=sx+sw && pointer.y>=sy && pointer.y<=sy+sh){
        target=st; break;
      }
    }
    if(!target) return;
    var grp=vcGetStandGroup(target.sData.id);
    if(!grp) return; // not in a group — normal click handling is fine
    // Select JUST this stand, bypassing group logic
    _vcSingleStandSelect=true;
    _vcIsolatedStand=true;
    _vcSelBusy=true;
    vc.discardActiveObject();
    vc.setActiveObject(target);
    _vcSelBusy=false;
    vcSelStand=target;
    renderDetail(target);

    renderProps(target);
    renderExp();
    vc.requestRenderAll();
    _vcSingleStandSelect=false;
  });
  // Fallback: native dblclick hit-test on measure lines/labels (independent of fabric target)
  vc.upperCanvasEl.addEventListener('dblclick',function(e){
    var pt=vc.getPointer(e,true), hit=null;
    for(var mi=vcLayers.meas.length-1;mi>=0;mi--){
      var mo=vcLayers.meas[mi];
      if(!mo||!mo.visible) continue;
      var br=mo.getBoundingRect(false,true), pad=6;
      if(pt.x>=br.left-pad&&pt.x<=br.left+br.width+pad&&pt.y>=br.top-pad&&pt.y<=br.top+br.height+pad){ hit=mo; break; }
    }
    if(hit && !_measEditBusy){ _measEditBusy=true; try{ vcEditMeasure(hit); } finally { setTimeout(function(){ _measEditBusy=false; },0); } }
  });
  // Dirty state notification hooks
  var _dn=function(){ if(!_suppressDirty&&_dirtyNotify) _dirtyNotify(true); };
  vc.on('object:modified',_dn); vc.on('object:added',_dn); vc.on('object:removed',_dn);
  vc.on('text:changed',function(e){
    _dn();
    var ta=document.getElementById('vc-tf-text');
    if(ta&&e.target&&e.target===vc.getActiveObject()&&ta.value!==e.target.text) ta.value=e.target.text;
  });
  document.getElementById('vc-area').addEventListener('wheel',function(e){
    e.preventDefault();
    var rect=vc.upperCanvasEl.getBoundingClientRect();
    setVcZoom(vcZ*(e.deltaY>0?1/1.15:1.15), e.clientX-rect.left, e.clientY-rect.top);
  },{passive:false});

  // Clic molette (button===1) → outil Main temporaire
  var _vcPrevTool=null;
  vc.upperCanvasEl.addEventListener('mousedown',function(e){
    if(e.button===1){ e.preventDefault(); _vcPrevTool=vcTool; setVcTool('hand'); _vcHandDown(e); }
  });
  window.addEventListener('mouseup',function(e){
    if(e.button===1 && _vcPrevTool!==null){ setVcTool(_vcPrevTool); _vcPrevTool=null; }
  });

  // Right-click context menu on fabric canvas
  vc.upperCanvasEl.addEventListener('contextmenu', function(e){
    e.preventDefault();
    e.stopPropagation();
    // Find object under cursor
    var target = vc.findTarget(e);
    if(target && !target._hall && !target._bg){
      vc.setActiveObject(target);
      if(target.sData){ vcSelStand=target; renderDetail(target); renderProps(target); }
      vc.renderAll();
      showCtxMenu(e.clientX, e.clientY, target);
    }
  });

  renderExp();
  // Auto-redraw rulers when vc-outer resizes (e.g. properties panel toggle)
  var _vcOuter=document.getElementById('vc-outer');
  if(_vcOuter && typeof ResizeObserver!=='undefined'){
    new ResizeObserver(function(){ drawVcRulers(); }).observe(_vcOuter);
  }
  _vcInitDone=true;
}
// Ensure vc is initialized (call when vector pane is visible)
function ensureVc(){
  if(vc) return true;
  try { initVc(); } catch(e){ console.error('[FloorMapEngine] initVc failed:', e); }
  return !!vc;
}

function recalcPxPerM(){
  if(!vc) return;
  // Skip rescaling while JSON is being loaded — pxPerM will be restored
  // from the loaded hall border in the loadVcJSON callback
  var _vchi=document.getElementById('vc-h-info'); if(_vchi) _vchi.innerHTML='Surface : <b>'+(hallW*hallH).toLocaleString('fr')+' m²</b>';
  if(_vcLoadingJSON){ pxPerM=Math.min(vc.width/hallW, vc.height/hallH); document.getElementById('vc-mpx').textContent=pxPerM.toFixed(2); return; }
  var oldPPM=pxPerM;
  pxPerM=Math.min(vc.width/hallW, vc.height/hallH);
  document.getElementById('vc-mpx').textContent=pxPerM.toFixed(2);

  // Si le ratio a changé, rescaler tous les objets existants
  if(oldPPM>0 && Math.abs(pxPerM-oldPPM)>0.001){
    var ratio=pxPerM/oldPPM;
    vc.getObjects().forEach(function(o){
      if(o._hall||o._bg) return; // ignorer le fond et la bordure
      // Rescaler position et dimensions
      o.set({
        left:  o.left  * ratio,
        top:   o.top   * ratio,
        scaleX:(o.scaleX||1) * ratio,
        scaleY:(o.scaleY||1) * ratio
      });
      o.setCoords();
    });
    // Mettre à jour wm/hm/sm dans sData des stands
    vcLayers.stands.forEach(function(o){
      if(!o.sData) return;
      o.sData.wm=fmtM(pxToM(o.getScaledWidth ? o.getScaledWidth() : o.width*(o.scaleX||1)));
      o.sData.hm=fmtM(pxToM(o.getScaledHeight ? o.getScaledHeight() : o.height*(o.scaleY||1)));
    });
    vc.requestRenderAll();
  }

  rebuildHallBorder(); drawVcRulers(); updateSBar();
}

function rebuildHallBorder(){
  if(!vc) return;
  vc.getObjects().filter(function(o){return o._hall;}).forEach(function(o){vc.remove(o);});
  vcLayers.struct=vcLayers.struct.filter(function(o){return !o._hall;});
  var b=new fabric.Rect({
    left:0,top:0,width:mToPx(hallW),height:mToPx(hallH),
    fill:'#f0f2f5',stroke:'#d0d5dd',strokeWidth:1.5,
    selectable:false,evented:false,_hall:true,_layer:'struct'
  });
  vcLayers.struct.push(b);
  vc.add(b);
  // Order: hall at very bottom (index 0), bg image just above it (index 1)
  // sendToBack moves to index 0, so send bg first, then hall pushes bg to index 1
  if(vcBgObj) vc.sendToBack(vcBgObj);
  vc.sendToBack(b);
  vc.requestRenderAll();
}

function fitVc(){
  if(!vc) return;
  var hW=mToPx(hallW), hH=mToPx(hallH);
  var fitZ=Math.min((vc.width*.9)/hW,(vc.height*.9)/hH);
  var ox=(vc.width-hW*fitZ)/2, oy=(vc.height-hH*fitZ)/2;
  vc.setViewportTransform([fitZ,0,0,fitZ,ox,oy]);
  vcZ=fitZ; updateZpct(); drawVcRulers(); updateSBar();
}

function setVcZoom(z,sx,sy){
  vcZ=Math.max(0.05,Math.min(20,z));
  if(sx!==undefined){
    var vt=vc.viewportTransform;
    var lx=(sx-vt[4])/vt[0], ly=(sy-vt[5])/vt[3];
    vc.setViewportTransform([vcZ,0,0,vcZ,sx-lx*vcZ,sy-ly*vcZ]);
  } else { vc.setZoom(vcZ); }
  updateZpct(); drawVcRulers(); updateSBar();
}

function updateZpct(){
  var p=Math.round(vcZ*100)+'%';
  var v=Math.round(vcZ*100);
  var el1=document.getElementById('vc-zpct'); if(el1) el1.textContent=p;
  var el2=document.getElementById('vc-zpct2'); if(el2) el2.textContent=p;
  var lbl=document.getElementById('vc-zpct-l');
  if(lbl) lbl.textContent=p;
  ['vc-zslider','vc-zslider-r'].forEach(function(id){
    var sl=document.getElementById(id); if(sl) sl.value=v;
  });
}
function vcZoomToSlider(pct){
  setVcZoom(pct/100);
}

function drawVcRulers(){
  if(!vc) return;
  var outer=document.getElementById('vc-outer');
  var W=outer.clientWidth-20, H=outer.clientHeight-20;
  var vt=vc.viewportTransform||[1,0,0,1,0,0];
  // ppm : pixels CSS par mètre dans la vue actuelle
  var ppm=pxPerM*vt[0];
  var step=niceStep(40/ppm);
  var ox=vt[4], oy=vt[5]; // position du point monde (0,0) dans vc-area en px CSS

  // ── Règle horizontale
  var hc=document.getElementById('vc-rh');
  hc.width=W; hc.style.width=W+'px'; hc.style.height='20px';
  var hx=hc.getContext('2d');
  hx.fillStyle='#ffffff'; hx.fillRect(0,0,W,20);
  hx.strokeStyle='#e0e0e0'; hx.lineWidth=1; hx.beginPath(); hx.moveTo(0,19.5); hx.lineTo(W,19.5); hx.stroke();
  hx.fillStyle='#666'; hx.font='8px system-ui,sans-serif'; hx.textBaseline='top';
  // première graduation visible (peut être négative)
  var firstM=Math.floor(-ox/ppm/step)*step;
  for(var m=firstM; ; m+=step){
    var x=Math.round(m*ppm+ox);
    if(x>W) break;
    if(x<-1) continue;
    hx.strokeStyle='#bbb'; hx.lineWidth=1;
    hx.beginPath(); hx.moveTo(x+0.5,13); hx.lineTo(x+0.5,20); hx.stroke();
    var lbl=Math.round(m*10)/10; // arrondi 0.1m
    hx.fillText(lbl+'m', Math.max(x+2, 0), 3);
  }

  // ── Règle verticale
  var rc=document.getElementById('vc-rv');
  rc.height=H; rc.style.height=H+'px'; rc.style.width='20px';
  var vx=rc.getContext('2d');
  vx.fillStyle='#ffffff'; vx.fillRect(0,0,20,H);
  vx.strokeStyle='#e0e0e0'; vx.lineWidth=1; vx.beginPath(); vx.moveTo(19.5,0); vx.lineTo(19.5,H); vx.stroke();
  vx.fillStyle='#666'; vx.font='8px system-ui,sans-serif';
  var firstMy=Math.floor(-oy/ppm/step)*step;
  for(var m=firstMy; ; m+=step){
    var y=Math.round(m*ppm+oy);
    if(y>H) break;
    if(y<-1) continue;
    vx.strokeStyle='#bbb'; vx.lineWidth=1;
    vx.beginPath(); vx.moveTo(13,y+0.5); vx.lineTo(20,y+0.5); vx.stroke();
    var lbl2=Math.round(m*10)/10;
    vx.save();
    vx.translate(9, Math.max(y+2, 6));
    vx.rotate(-Math.PI/2);
    vx.textBaseline='top';
    vx.fillText(lbl2+'m', 0, 0);
    vx.restore();
  }
}

function updateSBar(){ document.getElementById('vc-sbar').textContent=(48/(pxPerM*vcZ)).toFixed(1)+'m'; }

// ── Clamp objects within hall boundaries ──
function vcClampToHall(opt){
  var obj=opt.target;
  if(!obj || obj._hall || obj._bg) return;
  var hW=mToPx(hallW), hH=mToPx(hallH);
  var bound=obj.getBoundingRect(true, true); // absolute coords, no viewport
  var oLeft=obj.left, oTop=obj.top;
  // Clamp left
  if(bound.left < 0) oLeft = oLeft - bound.left;
  if(bound.left + bound.width > hW) oLeft = oLeft - (bound.left + bound.width - hW);
  // Clamp top
  if(bound.top < 0) oTop = oTop - bound.top;
  if(bound.top + bound.height > hH) oTop = oTop - (bound.top + bound.height - hH);
  obj.set({left: oLeft, top: oTop});
  obj.setCoords();
}

function vcScaling(opt){
  var obj=opt.target; if(!obj) return;
  // Single stand
  if(obj.sData){
    var wM=fmtM(pxToM(obj.width*obj.scaleX)), hM=fmtM(pxToM(obj.height*obj.scaleY));
    var items=obj.getObjects(); var _dmI=items[items.length-1]; if(_dmI) _dmI.set('text',wM+'×'+hM+'m');
    var tip=document.getElementById('vc-tip');
    var _sM2=(pxToM(obj.width*obj.scaleX)*pxToM(obj.height*obj.scaleY)).toFixed(1);
    tip.textContent=wM+'m × '+hM+'m = '+_sM2+' m²';
    tip.style.cssText='display:block;left:'+(opt.e?opt.e.offsetX+12:200)+'px;top:'+(opt.e?opt.e.offsetY-28:100)+'px';
  }
  // Multi-selection: update dimension labels on each child stand
  if(obj.type==='activeSelection'){
    var selScX=obj.scaleX||1, selScY=obj.scaleY||1;
    obj.getObjects().forEach(function(o){
      if(!o.sData) return;
      var oScX=(o.scaleX||1)*selScX, oScY=(o.scaleY||1)*selScY;
      var wM=fmtM(pxToM(o.width*oScX)), hM=fmtM(pxToM(o.height*oScY));
      var items=o.getObjects(); var _dI=items[items.length-1]; if(_dI) _dI.set('text',wM+'×'+hM+'m');
    });
  }
  vc.requestRenderAll();
}

function vcModified(opt){
  var obj=opt.target;
  document.getElementById('vc-tip').style.display='none';
  // Sauvegarder la position absolue dans sData._ax/_ay pour les overlays de groupe
  function saveAbsPos(o){
    if(!o.sData) return;
    // Si l'objet est dans une ActiveSelection, left/top sont relatifs au centre de la sélection
    // Il faut reconstruire la position absolue via la matrice de transformation
    var m=o.calcTransformMatrix();
    // Pour originX:'left', le coin haut-gauche = m[4], m[5]
    // Pour originX:'center', le centre = m[4], m[5] → coin = m[4]-w/2, m[5]-h/2
    var w=(o.width||0)*(o.scaleX||1);
    var h=(o.height||0)*(o.scaleY||1);
    if(o.originX==='center'){
      o.sData._ax=m[4]-w/2; o.sData._ay=m[5]-h/2;
    } else {
      // originX:'left' : vérifier si dans ActiveSelection
      if(o.group && o.group.type==='activeSelection'){
        // Dans ActiveSelection, left/top sont relatifs au centre du groupe
        // Le centre absolu du groupe est dans o.group's matrix
        var gm=o.group.calcTransformMatrix();
        o.sData._ax=gm[4]+o.left; o.sData._ay=gm[5]+o.top;
      } else {
        o.sData._ax=o.left; o.sData._ay=o.top;
      }
    }
  }
  if(obj&&obj.sData){
    saveAbsPos(obj);
    if(Math.abs(obj.scaleX-1)>0.001||Math.abs(obj.scaleY-1)>0.001) rebuildStand(obj);
    if(vcSelStand===obj||vc.getActiveObject()===obj){ renderDetail(obj); renderProps(obj); }
    // Update group overlay in-place (no vc.remove/add — safe for active selection)
    vcUpdateGroupOverlaysForStand(obj.sData.id);
    vc.requestRenderAll();
  } else if(obj&&obj._layer==='meas'&&obj._measData){
    // Recalculer les endpoints après déplacement/redimensionnement
    var md=obj._measData, matrix=obj.calcTransformMatrix();
    var p1=fabric.util.transformPoint({x:md.lx1,y:md.ly1},matrix);
    var p2=fabric.util.transformPoint({x:md.lx2,y:md.ly2},matrix);
    // Supprimer l'ancien et recréer proprement
    vcLayers.meas=vcLayers.meas.filter(function(o){return o!==obj;}); vc.remove(obj);
    var newM=addMeasure(p1.x,p1.y,p2.x,p2.y);
    if(newM){ vc.setActiveObject(newM); vc.renderAll(); }
  } else if(obj&&obj.type==='activeSelection'){
    var _selObjs=obj.getObjects().slice();
    _selObjs.forEach(function(o){ saveAbsPos(o); });
    // Check if the selection was scaled (not just moved)
    var _selScaled=Math.abs((obj.scaleX||1)-1)>0.001||Math.abs((obj.scaleY||1)-1)>0.001;
    if(_selScaled){
      // Compute each child's absolute transform BEFORE discarding the selection
      var _childInfos=[];
      _selObjs.forEach(function(o){
        if(!o.sData) { _childInfos.push({obj:o, stand:false}); return; }
        // Get absolute position via the selection's transform matrix
        var m=o.calcTransformMatrix();
        var effScX=(o.scaleX||1)*(obj.scaleX||1);
        var effScY=(o.scaleY||1)*(obj.scaleY||1);
        _childInfos.push({obj:o, stand:true, mx:m[4], my:m[5], scX:effScX, scY:effScY});
      });
      // Discard the active selection so we can safely remove/add objects
      vc.discardActiveObject();
      // Rebuild each stand with its new dimensions
      var _newObjs=[];
      _childInfos.forEach(function(info){
        if(!info.stand){ _newObjs.push(info.obj); return; }
        var o=info.obj;
        // Set absolute position and effective scale on the standalone object
        var realW=o.width*info.scX, realH=o.height*info.scY;
        o.set({left:info.mx-realW/2, top:info.my-realH/2, scaleX:info.scX, scaleY:info.scY});
        o.setCoords();
        var rebuilt=rebuildStand(o, true);
        if(rebuilt) _newObjs.push(rebuilt);
      });
      // Don't re-wrap in ActiveSelection after rebuild — Fabric's group/ungroup
      // math causes cumulative scale drift on children. User can re-select if needed.
      _newObjs.forEach(function(o){ if(o.sData) vcUpdateGroupOverlaysForStand(o.sData.id); });
    } else {
      // Just moved — update group overlays
      _selObjs.forEach(function(o){
        if(o.sData) vcUpdateGroupOverlaysForStand(o.sData.id);
      });
    }
    vc.requestRenderAll();
  }
  modLayerSaveCurrent();
}

function rebuildStand(obj, skipSelect){
  var sData=obj.sData, assign=vcAssigns[sData.id];
  var snap=cellM*pxPerM;
  var realW=Math.max(snap,Math.round(obj.width*obj.scaleX/snap)*snap);
  var realH=Math.max(snap,Math.round(obj.height*obj.scaleY/snap)*snap);
  var matrix=obj.calcTransformMatrix();
  var lx=Math.round((matrix[4]-realW/2)/snap)*snap;
  var ly=Math.round((matrix[5]-realH/2)/snap)*snap;
  vcLayers.stands=vcLayers.stands.filter(function(o){return o!==obj;}); vc.remove(obj);
  vcStandN--;
  var newGrp=mkStand(lx,ly,realW,realH,sData.num,sData.type);
  newGrp.sData.id=sData.id;
  newGrp.sData.hall=sData.hall;
  if(assign){
    vcAssigns[sData.id]=assign;
    // Restaurer le nom de l'exposant si ce stand est assigne
    var rLabel=sData.num;
    if(sData.hall) rLabel=sData.hall+(rLabel||'');
    vcUpdateStandLabel(newGrp, rLabel, assign.expo.name);
    // Apply lock state
    if(assign.status==='locked'){
      newGrp.set({lockMovementX:true, lockMovementY:true});
    }
  }
  // Re-apply group color if stand belongs to a group
  var _grp=vcGetStandGroup(sData.id);
  if(_grp){
    var _gclr=vcGroupColor(_grp);
    var _items=newGrp.getObjects();
    if(_items[0]) _items[0].set({stroke:_gclr, fill:hexToRgba(_gclr,0.13)});
    if(_items[1]) _items[1].set('fill',_gclr);
    if(_items[2]) _items[2].set('fill',_gclr+'cc');
    if(_items[3]) _items[3].set('fill',_gclr+'99');
    // Only rebuild overlay when not in batch mode (skipSelect=true means batch rebuild)
    if(!skipSelect) rebuildGroupOverlay(_grp);
  }
  if(!skipSelect){
    vc.setActiveObject(newGrp); vcSelStand=newGrp;
    renderDetail(newGrp); renderProps(newGrp);
  }
  vc.requestRenderAll();
  return newGrp;
}
function vcGetP(opt){ return vc.getPointer(opt.e); }
function vcSnap(v){ var s=cellM*pxPerM; return Math.round(v/s)*s; }

function vcDown(opt){
  if(opt.e.button===1){ opt.e.preventDefault(); return; }
  if(vcTool==='hand') return; // géré par listeners natifs
  if(vcTool==='select') return;
  // Ne pas démarrer un dessin si on clique sur un objet existant (déplacement)
  // Sauf si c'est le fond du hall (_hall/_bg) qui ne doit pas bloquer le dessin
  if(opt.target && !opt.target._hall && !opt.target._bg){ vcDrawing=false; return; }
  opt.e.preventDefault(); opt.e.stopPropagation();
  var p=vcGetP(opt); vcSx=vcSnap(p.x); vcSy=vcSnap(p.y);
  // Clamp start point to hall boundaries
  var _hW0=mToPx(hallW), _hH0=mToPx(hallH);
  vcSx=Math.max(0, Math.min(vcSx, _hW0));
  vcSy=Math.max(0, Math.min(vcSy, _hH0));
  vcClickX=vcSx; vcClickY=vcSy;
  if(vcTool==='text'){openM('m-text');return;}
  if(vcDObj){vc.remove(vcDObj);vcDObj=null;}
  vcDrawing=true;
  if(vcTool==='stand'||vcTool==='aisle'){
    var sc;
    if(vcTool==='stand'){
      // Use the color of the currently selected zone type (from pixel side)
      var _curType=colorToType(pxCol);
      sc=getStandColor(_curType);
    } else {
      sc={fill:'rgba(148,163,184,.06)',stroke:'#94a3b8'};
    }
    vcDObj=new fabric.Rect({left:vcSx,top:vcSy,width:1,height:1,fill:sc.fill,stroke:sc.stroke,strokeWidth:1.5,strokeDashArray:vcTool==='aisle'?[6,3]:null,selectable:false,evented:false});
    vc.add(vcDObj);
  } else if(vcTool==='wall'){
    vcDObj=new fabric.Line([vcSx,vcSy,vcSx+1,vcSy+1],{stroke:'#3d4a6b',strokeWidth:3,selectable:false,evented:false}); vc.add(vcDObj);
  } else if(vcTool==='meas'){
    vcDObj=new fabric.Line([vcSx,vcSy,vcSx+1,vcSy+1],{stroke:'#e11d48',strokeWidth:1.5,strokeDashArray:[4,2],selectable:false,evented:false}); vc.add(vcDObj);
  }
}

function vcMove(opt){
  if(vcTool==='hand') return; // géré par listeners natifs
  if(vcTool==='select') return;
  var p=vcGetP(opt), x=vcSnap(p.x), y=vcSnap(p.y);
  // Clamp cursor position to hall boundaries
  var _hW=mToPx(hallW), _hH=mToPx(hallH);
  x=Math.max(0, Math.min(x, _hW));
  y=Math.max(0, Math.min(y, _hH));
  document.getElementById('st-cur').textContent=fmtM(pxToM(x))+'m, '+fmtM(pxToM(y))+'m';
  if(!vcDrawing||!vcDObj) return;
  if(vcTool==='stand'||vcTool==='aisle'){
    var w=x-vcSx, h=y-vcSy;
    vcDObj.set({left:w>=0?vcSx:x,top:h>=0?vcSy:y,width:Math.max(1,Math.abs(w)),height:Math.max(1,Math.abs(h))});
    var tip=document.getElementById('vc-tip');
    var _twM=fmtM(Math.abs(pxToM(w))), _thM=fmtM(Math.abs(pxToM(h)));
    var _tsM=(Math.abs(pxToM(w))*Math.abs(pxToM(h))).toFixed(1);
    tip.textContent=_twM+'m × '+_thM+'m = '+_tsM+' m²';
    tip.style.cssText='display:block;left:'+(opt.e.offsetX+12)+'px;top:'+(opt.e.offsetY-28)+'px';
  }
  if(vcTool==='wall'||vcTool==='meas') vcDObj.set({x2:x,y2:y});
  if(vcTool==='meas'||vcTool==='wall'){
    // Live length shown next to the cursor while drawing a measure / wall line
    var _mTip=document.getElementById('vc-tip');
    var _mDist=Math.sqrt((x-vcSx)*(x-vcSx)+(y-vcSy)*(y-vcSy));
    _mTip.textContent=fmtM(pxToM(_mDist))+'m';
    _mTip.style.cssText='display:block;left:'+(opt.e.offsetX+12)+'px;top:'+(opt.e.offsetY-28)+'px';
  }
  vc.requestRenderAll();
}

function vcUp(opt){
  // Apply deferred group selection (was queued during selection:created)
  if(_vcPendingGroupSel){
    var _pg=_vcPendingGroupSel;
    var _clickedStand=vcSelStand;
    _vcPendingGroupSel=null;
    // Restore movement locks on the clicked stand
    if(_clickedStand){
      _clickedStand.set({
        lockMovementX:_clickedStand._origLockX||false,
        lockMovementY:_clickedStand._origLockY||false
      });
      delete _clickedStand._origLockX;
      delete _clickedStand._origLockY;
    }
    // Defer to next tick so fabric.js fully processes mouseup and clears _currentTransform
    setTimeout(function(){
      _vcSelBusy=true;
      vc.discardActiveObject();
      vcSelectGroup(_pg);
      _vcSelBusy=false;
      vc.requestRenderAll();
    },0);
  }
  if(vcTool==='hand') return; // géré par listeners natifs
  if(vcTool==='select'){ vcDrawing=false; return; }
  document.getElementById('vc-tip').style.display='none';
  if(!vcDrawing) return; vcDrawing=false;
  if(vcTool==='stand'){
    var fx=vcDObj.left,fy=vcDObj.top,fw=vcDObj.width,fh=vcDObj.height;
    vc.remove(vcDObj); vcDObj=null;
    if(fw<pxPerM*.4||fh<pxPerM*.4){vc.renderAll();return;}
    // Create stand directly with auto-number and current zone type (no popup)
    var _sNum='S-'+String(vcStandN).padStart(2,'0');
    var _sType=colorToType(pxCol);
    mkStand(fx,fy,fw,fh,_sNum,_sType);
    updateVcStatus();
  } else if(vcTool==='aisle'){
    if(vcDObj.width<3||vcDObj.height<3){vc.remove(vcDObj);vcDObj=null;vc.renderAll();return;}
    vcDObj.set({selectable:true,evented:true}); vcDObj._layer='aisles'; vcLayers.aisles.push(vcDObj); vcDObj=null;
  } else if(vcTool==='wall'){
    vcDObj.set({selectable:true,evented:true}); vcDObj._layer='struct'; vcLayers.struct.push(vcDObj); vcDObj=null;
  } else if(vcTool==='meas'){
    if(vcDObj){ vc.remove(vcDObj); vcDObj=null; }
    var p=vcGetP(opt);
    var x2=vcSnap(p.x), y2=vcSnap(p.y);
    var dist=Math.sqrt((x2-vcSx)*(x2-vcSx)+(y2-vcSy)*(y2-vcSy));
    // Enforce a 1m minimum: extend the endpoint along the drawn direction
    var minPx=pxPerM*1;
    if(dist < minPx){
      if(dist < 0.5){ vc.renderAll(); return; } // no direction → cancel
      var ex=(x2-vcSx)/dist, ey=(y2-vcSy)/dist;
      x2=vcSx+ex*minPx; y2=vcSy+ey*minPx;
    }
    addMeasure(vcSx,vcSy,x2,y2);
  }
  vc.renderAll(); updateVcStatus();
  modLayerSaveCurrent(); // snapshot VC apres creation d'objet
  // Re-enforce cursor for current tool after mouseup
  var _vcCur=TOOL_CURSORS['vc-'+vcTool]||TOOL_CURSORS[vcTool]||'crosshair';
  vc.defaultCursor=_vcCur;
  vc.upperCanvasEl.style.cursor=_vcCur;
}

function _isText(o){ return o && (o.type==='text' || o.type==='textbox'); }

function getStandColor(type){
  if(STAND_C[type]) return STAND_C[type];
  // Dynamically generate from RTYPES for custom types
  var rt=RTYPES.find(function(r){ return r.key===type; });
  if(rt && rt.color){
    // Convert hex color to rgba fill (12% opacity) + stroke
    var hex=rt.color;
    var r=parseInt(hex.slice(1,3),16), g=parseInt(hex.slice(3,5),16), b=parseInt(hex.slice(5,7),16);
    return {fill:'rgba('+r+','+g+','+b+',.12)', stroke:hex};
  }
  return STAND_C.standard;
}

// Layout stand labels vertically centered, avoiding overlap
// NOTE: inside a fabric.Group, top:0 = group center, top:-h/2 = top edge
function _layoutStandLabels(lb,ex,dm,w,h){
  var items=[];
  var gap=2;
  var maxH=h*0.9; // usable height (90% of block)
  if(lb && lb.text) items.push(lb);
  if(ex && ex.text) items.push(ex);
  if(dm && dm.text) items.push(dm);
  if(items.length===0){
    if(lb) lb.set({top:0});
    if(ex) ex.set({top:0});
    if(dm) dm.set({top:0});
    return;
  }
  // Shrink font sizes until everything fits within the block
  for(var _try=0;_try<8;_try++){
    var totalH=0;
    items.forEach(function(it){ totalH+=it.calcTextHeight(); });
    totalH+=(items.length-1)*gap;
    if(totalH<=maxH) break;
    // Reduce all font sizes by 20%
    items.forEach(function(it){
      var cur=it.fontSize||10;
      it.set({fontSize:Math.max(3,Math.round(cur*0.8))});
    });
  }
  // Compute final total and position
  var totalH=0;
  items.forEach(function(it){ totalH+=it.calcTextHeight(); });
  totalH+=(items.length-1)*gap;
  var startY= -totalH/2;
  items.forEach(function(it){
    var ih=it.calcTextHeight();
    it.set({top: startY + ih/2});
    startY+=ih+gap;
  });
  // Hidden labels at center
  if(lb && !lb.text) lb.set({top:0});
  if(ex && !ex.text) ex.set({top:0});
  if(dm && !dm.text) dm.set({top:0});
}

function mkStand(x,y,w,h,num,type){
  vcStandN++;
  var c=getStandColor(type);
  var wM=fmtM(pxToM(w)), hM=fmtM(pxToM(h));
  var mp=Math.min(w,h);
  var sw=Math.max(0.3,Math.min(2,mp*.04));
  // Determine what text to show based on stand size
  var showNum = mp > 4;
  var showDim = mp > 18;  // only show dimensions when stand is large enough for 2 lines
  var fs, fss;
  if(showDim){
    fs=Math.max(5,Math.min(16,mp*.18));
    fss=Math.max(4,Math.min(10,mp*.11));
  } else {
    // Single line (number only) — use bigger font centered
    fs=Math.max(4,Math.min(16,mp*.28));
    fss=4;
  }
  var rect=new fabric.Rect({left:0,top:0,width:w,height:h,fill:c.fill,stroke:c.stroke,strokeWidth:sw});
  var exFs=Math.max(3,Math.min(11,mp*.13));
  var tbW=w*0.9; // text box width for wrapping
  var lb=new fabric.Textbox(showNum?num:'',{left:w/2,top:h/2,originX:'center',originY:'center',fontSize:fs,fill:c.stroke,fontFamily:'system-ui',fontWeight:'700',width:tbW,textAlign:'center',splitByGrapheme:false,editable:false});
  var ex=new fabric.Textbox('',{left:w/2,top:h/2,originX:'center',originY:'center',fontSize:exFs,fill:c.stroke+'cc',fontFamily:'system-ui',fontWeight:'600',width:tbW,textAlign:'center',splitByGrapheme:false,editable:false});
  var dm=new fabric.Textbox(showDim?wM+'×'+hM+'m':'',{left:w/2,top:h/2,originX:'center',originY:'center',fontSize:fss,fill:c.stroke+'aa',fontFamily:'system-ui',width:tbW,textAlign:'center',splitByGrapheme:false,editable:false});
  var grp=new fabric.Group([rect,lb,ex,dm],{left:x,top:y,originX:'left',originY:'top',selectable:true,lockUniScaling:false});
  // Layout labels AFTER group creation (coordinates are now group-relative: 0=center)
  _layoutStandLabels(lb,ex,dm,w,h);
  // Constrain group bounds to match the rect — prevents text overflow from enlarging selection border
  grp.set({width:w, height:h});
  grp.clipPath=new fabric.Rect({width:w, height:h, originX:'center', originY:'center'});
  grp.setCoords();
  grp.sData={id:'v'+Date.now()+Math.random(),num:num,type:type,wm:wM,hm:hM,sm:(pxToM(w)*pxToM(h)).toFixed(1),_ax:x,_ay:y};
  grp._layer='stands'; vcLayers.stands.push(grp); vc.add(grp);
  // Apply per-type visibility/lock/opacity
  if(vcTypeVis[type]===false) grp.set('visible',false);
  if(vcTypeLock[type]) grp.set({selectable:false,evented:false});
  if(vcTypeOp[type]!==undefined && vcTypeOp[type]<100) grp.set('opacity',vcTypeOp[type]/100);
  return grp;
}

function addMeasure(x1,y1,x2,y2){
  var dx=x2-x1, dy=y2-y1;
  var d=Math.sqrt(dx*dx+dy*dy);
  if(d<2) return;

  var dm=fmtM(pxToM(d))+'m';
  var clr='#e11d48';           // rose-600 — bolder, more readable
  var clrBg='rgba(255,255,255,.95)';
  var as=10, aw=4.5;           // arrowhead size & half-width
  var serifH=7;                // perpendicular end-cap height (half)

  var ux=dx/d, uy=dy/d;          // unit vector along line
  var nx=-uy, ny=ux;              // perpendicular
  if(ny>0){ nx=-nx; ny=-ny; }    // always toward top

  // ── Label sizing
  var fs=9;
  var txtW=dm.length*fs*0.6+14, txtH=fs+8;

  // If the line is too short for the label to fit inline between the
  // arrowheads, offset the label perpendicular above the line so the
  // line + arrows remain fully visible.
  var labelOffset = d < (txtW + as*2 + 6);
  var offDist = labelOffset ? (txtH/2 + 4) : 0;

  // If the segment is too short to fit two arrowhead bases without
  // overlapping, drop the arrows entirely — line + serifs alone are
  // a clear length indicator that scales proportionally.
  var drawArrows = d >= (as*2 + 2);

  // Where the label sits (mid of segment, optionally offset)
  var midX=(x1+x2)/2, midY=(y1+y2)/2;
  var labelX = midX + nx*offDist;
  var labelY = midY + ny*offDist;

  // ── Bounding box (line endpoints, serifs, label box corners)
  var allX=[x1,x2, x1+nx*serifH,x1-nx*serifH, x2+nx*serifH,x2-nx*serifH,
            labelX-txtW/2, labelX+txtW/2];
  var allY=[y1,y2, y1+ny*serifH,y1-ny*serifH, y2+ny*serifH,y2-ny*serifH,
            labelY-txtH/2, labelY+txtH/2];
  var minX=Math.min.apply(null,allX), maxX=Math.max.apply(null,allX);
  var minY=Math.min.apply(null,allY), maxY=Math.max.apply(null,allY);
  var gcx=(minX+maxX)/2, gcy=(minY+maxY)/2;

  function loc(ax,ay){ return {x:ax-gcx, y:ay-gcy}; }

  var parts=[];

  // ── Main dimension line
  var l1=loc(x1,y1), l2=loc(x2,y2);
  var ln=new fabric.Line([l1.x,l1.y,l2.x,l2.y],{
    stroke:clr, strokeWidth:1.5, selectable:false, evented:false, objectCaching:false
  });

  // ── Perpendicular end-caps (serifs)
  var s1a=loc(x1+nx*serifH, y1+ny*serifH), s1b=loc(x1-nx*serifH, y1-ny*serifH);
  var serif1=new fabric.Line([s1a.x,s1a.y,s1b.x,s1b.y],{
    stroke:clr, strokeWidth:1.5, selectable:false, evented:false, objectCaching:false
  });
  var s2a=loc(x2+nx*serifH, y2+ny*serifH), s2b=loc(x2-nx*serifH, y2-ny*serifH);
  var serif2=new fabric.Line([s2a.x,s2a.y,s2b.x,s2b.y],{
    stroke:clr, strokeWidth:1.5, selectable:false, evented:false, objectCaching:false
  });

  parts.push(ln,serif1,serif2);

  if(drawArrows){
    // ── Arrowheads (filled, pointing outward at each endpoint)
    function makeArrow(tx,ty, inDirX,inDirY){
      var tip=loc(tx,ty);
      var bx=tx+inDirX*as, by=ty+inDirY*as;
      var w1=loc(bx+inDirY*aw, by-inDirX*aw);
      var w2=loc(bx-inDirY*aw, by+inDirX*aw);
      return new fabric.Polygon(
        [{x:tip.x,y:tip.y},{x:w1.x,y:w1.y},{x:w2.x,y:w2.y}],
        {fill:clr, stroke:clr, strokeWidth:0.5, strokeLineJoin:'round',
         selectable:false, evented:false, objectCaching:false}
      );
    }
    parts.push(makeArrow(x1,y1, ux, uy));
    parts.push(makeArrow(x2,y2,-ux,-uy));
  }

  // ── Label position (offset perpendicular when needed)
  var ll=loc(labelX,labelY);

  var angleDeg=Math.atan2(dy,dx)*180/Math.PI;
  if(angleDeg>90)  angleDeg-=180;
  if(angleDeg<-90) angleDeg+=180;

  var bg=new fabric.Rect({
    left:ll.x, top:ll.y,
    originX:'center', originY:'center',
    width:txtW, height:txtH,
    fill:clrBg, stroke:clr, strokeWidth:1, rx:4,
    angle:angleDeg,
    selectable:false, evented:false, objectCaching:false
  });

  var lb=new fabric.Text(dm,{
    left:ll.x, top:ll.y,
    originX:'center', originY:'center',
    fontSize:fs, fill:clr,
    fontFamily:'system-ui,sans-serif', fontWeight:'600',
    angle:angleDeg,
    selectable:false, evented:false, objectCaching:false
  });
  parts.push(bg,lb);

  var grp=new fabric.Group(parts,{
    left:gcx, top:gcy,
    originX:'center', originY:'center',
    selectable:true, evented:true,
    hasControls:true, hasBorders:true,
    borderColor:'#e11d48', borderDashArray:[4,3],
    cornerColor:'#e11d48', cornerSize:6, transparentCorners:false,
    objectCaching:false
  });
  grp._layer='meas';
  grp._measData={x1:x1,y1:y1,x2:x2,y2:y2,dm:dm,lx1:x1-gcx,ly1:y1-gcy,lx2:x2-gcx,ly2:y2-gcy};
  vcLayers.meas.push(grp);
  vc.add(grp);
  return grp;
}

function confirmStand(){
  var r=window._pr; if(!r){closeM('m-stand');return;}
  mkStand(r.x,r.y,r.w,r.h,document.getElementById('m-num').value||('S-'+vcStandN),document.getElementById('m-type').value);
  updateVcStatus(); closeM('m-stand'); vc.renderAll();
}

// ── Ouvre la modale d'édition du stand sélectionné
function openStandEdit(){
  if(!vcSelStand||!vcSelStand.sData) return;
  var s=vcSelStand.sData;
  var assign=vcAssigns[s.id];
  var hasExpo=!!(assign&&assign.expo);
  var numEl=document.getElementById('se-num');
  var hallEl=document.getElementById('se-hall');
  // When exhibitor is assigned, booth number and hall come from database → read-only
  numEl.value=s.num||'';
  numEl.disabled=hasExpo;
  numEl.style.opacity=hasExpo?'0.6':'1';
  hallEl.value=s.hall||'';
  hallEl.disabled=hasExpo;
  hallEl.style.opacity=hasExpo?'0.6':'1';
  // Populer le select des types (sans allée/mur)
  document.getElementById('se-type').innerHTML=RTYPES
    .filter(function(r){return r.key!=='aisle'&&r.key!=='wall';})
    .map(function(r){return '<option value="'+r.key+'"'+(r.key===s.type?' selected':'')+'>'+r.name+'</option>';})
    .join('');
  openM('m-stand-edit');
}

// ── Valide les modifications du stand
function confirmStandEdit(){
  if(!vcSelStand||!vcSelStand.sData){closeM('m-stand-edit');return;}
  var s=vcSelStand.sData;
  var assign=vcAssigns[s.id];
  var hasExpo=!!(assign&&assign.expo);
  // Booth number and hall come from database when exhibitor is assigned – don't overwrite
  if(!hasExpo){
    var newNum=document.getElementById('se-num').value.trim()||s.num;
    var newHall=document.getElementById('se-hall').value.trim();
    s.num=newNum; s.hall=newHall;
  }
  var newType=document.getElementById('se-type').value;
  s.type=newType;
  // Reconstruire le stand graphiquement avec le nouveau type/couleur
  rebuildStand(vcSelStand);
  renderDetail(vcSelStand); renderProps(vcSelStand);
  closeM('m-stand-edit');
  vc.renderAll();
}

// ── Change zone type of the currently selected stand via sidebar click ──
function vcSetStandType(key){
  // Always update pxCol so new stands use this type
  var rt=RTYPES.find(function(r){return r.key===key;});
  if(rt) setPxCol(rt.color);
  // If a stand is selected, change its type
  if(vcSelStand&&vcSelStand.sData){
    var _grpChk=vcGetStandGroup(vcSelStand.sData.id);
    if(_grpChk) return;
    var s=vcSelStand.sData;
    if(s.type!==key){
      s.type=key;
      rebuildStand(vcSelStand);
      renderDetail(vcSelStand); renderProps(vcSelStand);
      vc.renderAll();
      modLayerSaveCurrent();
    }
  }
  vcHighlightRtype();
}
// Highlight the active zone type in vc-rtypes
function vcHighlightRtype(){
  var activeKey=null;
  if(vcSelStand&&vcSelStand.sData){
    // If a stand is selected, highlight its type
    var _grpH=vcGetStandGroup(vcSelStand.sData.id);
    if(!_grpH) activeKey=vcSelStand.sData.type;
  } else {
    // No stand selected — highlight the current drawing type (from pxCol)
    activeKey=colorToType(pxCol);
  }
  document.querySelectorAll('.vc-rtype').forEach(function(el){
    var isOn=el.dataset.key===activeKey;
    el.style.background=isOn?'rgba(91,108,249,.15)':'';
    el.style.outline=isOn?'1.5px solid rgba(91,108,249,.5)':'';
  });
}

function confirmText(){
  var txt=document.getElementById('m-txt').value; if(!txt){closeM('m-text');return;}
  var t=new fabric.IText(txt,{left:vcClickX,top:vcClickY,fontSize:parseInt(document.getElementById('m-tsz').value),fill:'#e2e8f0',fontFamily:'system-ui'});
  t._layer='annot'; vcLayers.annot.push(t); vc.add(t); vc.renderAll();
  closeM('m-text'); document.getElementById('m-txt').value='';
}

// Etat pan VC (outil Main) — géré par listeners natifs sur le canvas DOM
var _vcPanActive=false, _vcPanLastX=0, _vcPanLastY=0;

function _vcHandDown(e){
  if(e.button!==0 && e.button!==1) return;
  e.preventDefault();
  _vcPanActive=true;
  _vcPanLastX=e.clientX; _vcPanLastY=e.clientY;
  vc.upperCanvasEl.style.cursor='grabbing';
}
function _vcHandMove(e){
  if(!_vcPanActive) return;
  var dx=e.clientX-_vcPanLastX;
  var dy=e.clientY-_vcPanLastY;
  _vcPanLastX=e.clientX; _vcPanLastY=e.clientY;
  var vpt=vc.viewportTransform.slice();
  vpt[4]+=dx; vpt[5]+=dy;
  vc.setViewportTransform(vpt);
  vc.requestRenderAll();
  drawVcRulers();
}
function _vcHandUp(e){
  if(!_vcPanActive) return;
  _vcPanActive=false;
  // Restore proper cursor for current tool (not always 'grab')
  var vcCur=TOOL_CURSORS['vc-'+vcTool]||TOOL_CURSORS[vcTool]||'grab';
  vc.upperCanvasEl.style.cursor=vcCur;
}
var _vcHandListeners=false;
function _vcEnableHand(){
  if(_vcHandListeners) return;
  vc.upperCanvasEl.addEventListener('mousedown',_vcHandDown);
  window.addEventListener('mousemove',_vcHandMove);
  window.addEventListener('mouseup',_vcHandUp);
  _vcHandListeners=true;
}
function _vcDisableHand(){
  vc.upperCanvasEl.removeEventListener('mousedown',_vcHandDown);
  window.removeEventListener('mousemove',_vcHandMove);
  window.removeEventListener('mouseup',_vcHandUp);
  _vcHandListeners=false;
  _vcPanActive=false;
}


// ── Curseurs SVG par outil
var TOOL_CURSORS = (function(){
  function svg2cur(svgStr, hx, hy){
    var b64 = btoa(unescape(encodeURIComponent(svgStr)));
    return "url(\"data:image/svg+xml;base64,"+b64+"\") "+hx+" "+hy+", auto";
  }
  // Crayon
  var pencil = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><line x1="3" y1="17" x2="15" y2="5" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/><line x1="3" y1="17" x2="15" y2="5" stroke="#5b6cf9" stroke-width="1.2" stroke-linecap="round"/><polygon points="1,19 3,17 5,19" fill="#f472b6"/><circle cx="15" cy="5" r="2" fill="#f59e0b"/></svg>', 2, 18);
  // Gomme
  var eraser = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><rect x="4" y="8" width="13" height="9" rx="2" fill="#f87171" opacity=".85"/><rect x="4" y="8" width="13" height="9" rx="2" fill="none" stroke="#fff" stroke-width="1"/><line x1="4" y1="17" x2="17" y2="17" stroke="#fff" stroke-width="1.5"/></svg>', 4, 16);
  // Pipette
  var eyedrop = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M13 3 L17 7 L8 16 L4 12 Z" fill="#8b9fff" stroke="#fff" stroke-width="1"/><path d="M3 17 L4 12 L8 16 Z" fill="#f472b6"/><circle cx="16" cy="4" r="2" fill="#f59e0b"/></svg>', 3, 17);
  // Seau
  var bucket = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M3 10 Q3 4 10 4 Q17 4 17 10 L17 15 Q17 18 10 18 Q3 18 3 15 Z" fill="#5b6cf9" opacity=".8" stroke="#fff" stroke-width="1"/><path d="M10 1 L13 5" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>', 3, 17);
  // Rectangle vide
  var rect = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><rect x="2" y="2" width="16" height="16" rx="2" fill="none" stroke="#8b9fff" stroke-width="2" stroke-dasharray="3,2"/><circle cx="2" cy="2" r="1.5" fill="#f472b6"/></svg>', 2, 2);
  // Rectangle plein
  var frect = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><rect x="2" y="2" width="16" height="16" rx="2" fill="#5b6cf9" opacity=".8" stroke="#fff" stroke-width="1"/><circle cx="2" cy="2" r="1.5" fill="#f472b6"/></svg>', 2, 2);
  // Séparateur
  var sep = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><line x1="10" y1="2" x2="10" y2="18" stroke="#f472b6" stroke-width="2" stroke-dasharray="3,2"/><path d="M7 5 L10 2 L13 5" fill="#f472b6"/></svg>', 10, 2);
  // Stand (outil de dessin stand)
  var stand = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><rect x="2" y="4" width="14" height="10" rx="1.5" fill="rgba(60,181,74,.25)" stroke="#3cb54a" stroke-width="1.5"/><line x1="17" y1="2" x2="17" y2="18" stroke="#8b9fff" stroke-width="1.5" stroke-linecap="round"/><line x1="14" y1="18" x2="20" y2="18" stroke="#8b9fff" stroke-width="1.5" stroke-linecap="round"/></svg>', 2, 4);
  // Allée
  var aisle = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><rect x="2" y="7" width="16" height="6" rx="1" fill="rgba(0,0,0,.08)" stroke="#888888" stroke-width="1.5" stroke-dasharray="3,2"/><line x1="18" y1="2" x2="18" y2="18" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/><line x1="15" y1="18" x2="20" y2="18" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/></svg>', 2, 7);
  // Mur
  var wall = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><line x1="2" y1="10" x2="16" y2="10" stroke="#3d4a6b" stroke-width="3" stroke-linecap="round"/><line x1="2" y1="10" x2="16" y2="10" stroke="#8b9fff" stroke-width="1" stroke-linecap="round"/><line x1="18" y1="2" x2="18" y2="18" stroke="#8b9fff" stroke-width="1.5" stroke-linecap="round"/><line x1="15" y1="18" x2="20" y2="18" stroke="#8b9fff" stroke-width="1.5" stroke-linecap="round"/></svg>', 2, 10);
  // Mesure
  var meas = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><line x1="3" y1="10" x2="17" y2="10" stroke="#e11d48" stroke-width="1.5"/><polygon points="3,7.5 3,12.5 6,10" fill="#e11d48"/><polygon points="17,7.5 17,12.5 14,10" fill="#e11d48"/><line x1="3" y1="5" x2="3" y2="15" stroke="#e11d48" stroke-width="1.5"/><line x1="17" y1="5" x2="17" y2="15" stroke="#e11d48" stroke-width="1.5"/></svg>', 10, 10);
  // Texte
  var text = svg2cur('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><text x="3" y="16" font-family="serif" font-size="15" fill="#fff" font-weight="bold">T</text><line x1="3" y1="17" x2="14" y2="17" stroke="#f472b6" stroke-width="1.5"/></svg>', 3, 17);
  return {
    // Pixel
    pencil:pencil, eraser:eraser, eyedrop:eyedrop,
    bucket:bucket, rect:rect, frect:frect, sep:sep,
    select:'default', hand:'grab',
    // Vectoriel
    'vc-select':'default', 'vc-hand':'grab',
    'vc-stand':stand, 'vc-aisle':aisle, 'vc-wall':wall,
    'vc-meas':meas, 'vc-text':text
  };
})();

// True when the zone type of a vector object is locked in the active fork
function vcObjTypeLocked(o){
  if(!o) return false;
  if(o._layer==='meas') return vcTypeLock._meas===true;
  if(o._layer==='aisles' && !(o.sData&&o.sData.type)) return vcTypeLock.aisle===true;
  if(o._layer==='struct' && !(o.sData&&o.sData.type)) return vcTypeLock.wall===true;
  return !!(o.sData && vcTypeLock[o.sData.type]===true);
}
function setVcTool(t){
  vcTool=t;
  var isHand=(t==='hand');
  // Activer/désactiver les listeners natifs du pan
  if(isHand) _vcEnableHand(); else _vcDisableHand();
  vc.selection=(t==='select');
  var vcCur=TOOL_CURSORS['vc-'+t]||TOOL_CURSORS[t]||'crosshair';
  vc.defaultCursor=vcCur;
  vc.upperCanvasEl.style.cursor=vcCur;
  vc.hoverCursor=(t==='select')?'move':vcCur;
  vc.getObjects().forEach(function(o){
    if(o._layer){
      // En mode meas, les mesures existantes ne sont pas sélectionnables (évite double-mesure)
      var isMeasObj = (o._layer==='meas');
      var _tLocked = vcObjTypeLocked(o);
      o.selectable = (t==='select') && !o._hall && !o._bg && !vcLayerLock[o._layer] && !_tLocked && !(t==='meas'&&isMeasObj);
      o.evented = o.selectable || (t!=='meas' && !_tLocked);
    }
  });
  document.querySelectorAll('.tbtn').forEach(function(el){el.classList.remove('on');});
  var el=document.getElementById('vt-'+t); if(el) el.classList.add('on');
  var names={select:'Sélection',stand:'Stand',aisle:'Allée',wall:'Mur',text:'Texte',meas:'Mesure',hand:'Main'};
  document.getElementById('st-tool').textContent=names[t]||t;
  if(t!=='select') vc.discardActiveObject();
  vc.renderAll();
}

function setVcLayer(l){
  vcLayer=l;
  document.querySelectorAll('#vc-layers-list .litem').forEach(function(el){el.classList.remove('on');});
  var el=document.getElementById('vl-'+l); if(el) el.classList.add('on');
}

// ── Gestion sélection Fabric (simple et multiple)

// ═══════════════════════════════════════
// GROUPEMENT DE STANDS
// ═══════════════════════════════════════
// GROUP_COLORS défini dans refreshColorSources (dérivé de RTYPES)

function vcGroupColor(grp){
  // Type-based color takes priority
  if(grp.type){
    var sc=getStandColor(grp.type);
    return sc.stroke;
  }
  if(grp.color) return grp.color;
  var idx=vcGroups.indexOf(grp); if(idx<0) idx=0;
  return GROUP_COLORS[idx % GROUP_COLORS.length];
}

// ── Sync couleur groupe → pixels (quand un groupe VC crée ou change de couleur)
function grpSyncColorToPx(grp){
  var clr = grp.color || vcGroupColor(grp);

  if(grp.isPxGroup && grp.pxCells){
    // Groupe PX : mettre à jour grid + pxCells.color
    grp.pxCells.forEach(function(px){
      if(!px.originalColor) px.originalColor = px.color;
      px.color = clr;
      setCell(px.r, px.c, clr);
    });
    savePxH(); drawPx();
    return;
  }

  if(!grp.isPxGroup && grp.standIds.length > 0){
    // Groupe VC : repeindre uniquement les cellules dans la bbox des stands membres
    // Ne PAS créer pxCells (évite que pxGetCellGroup confonde ces cellules avec un groupe PX)
    grp.standIds.forEach(function(sid){
      var stand = vcLayers.stands.find(function(o){ return o.sData && o.sData.id===sid; });
      if(!stand || !stand.sData) return;
      var ax = stand.sData._ax != null ? stand.sData._ax : stand.left;
      var ay = stand.sData._ay != null ? stand.sData._ay : stand.top;
      var w = (stand.width||0)*(stand.scaleX||1);
      var h = (stand.height||0)*(stand.scaleY||1);
      var gc1 = Math.max(0, Math.round(pxToM(ax)/cellM));
      var gr1 = Math.max(0, Math.round(pxToM(ay)/cellM));
      var gc2 = Math.min(numCols()-1, Math.round(pxToM(ax+w)/cellM)-1);
      var gr2 = Math.min(numRows()-1, Math.round(pxToM(ay+h)/cellM)-1);
      for(var row=gr1; row<=gr2; row++) for(var col=gc1; col<=gc2; col++){
        if(grid[row] && grid[row][col]) setCell(row, col, clr);
      }
    });
    savePxH(); drawPx();
  }
}

// ── Sync couleur groupe → stands VC (quand un groupe PX change de couleur)
function grpSyncColorToVc(grp){
  if(grp.standIds.length > 0){
    vcApplyGroupColor(grp);
    rebuildGroupOverlay(grp);
    vc.requestRenderAll();
  }
}

// ── Restaurer les couleurs originales en pixel pour un groupe (suppression/dégroupement)
// Fonctionne indépendamment de isPxGroup — si pxCells existe, on restaure
function grpRestorePxColors(grp){
  if(!grp.pxCells || grp.pxCells.length===0) return;
  // 1. Restore original stand colors
  grp.pxCells.forEach(function(px){
    setCell(px.r, px.c, px.originalColor || px.color);
  });
  // 2. Rebuild separators between differently-colored cells in the group area
  //    First, clear old group-internal seps, then rebuild per-cell color boundaries
  var cellSet={};
  grp.pxCells.forEach(function(px){ cellSet[px.r+','+px.c]=true; });
  grp.pxCells.forEach(function(px){
    var r=px.r, c=px.c;
    var col=(grid[r]&&grid[r][c])||null;
    if(!col) return;
    // Top edge
    var colUp=(grid[r-1]&&grid[r-1][c])||null;
    if(colUp!==col){ if(!sepH[r]) sepH[r]=[]; sepH[r][c]=true; }
    // Bottom edge
    var colDn=(grid[r+1]&&grid[r+1][c])||null;
    if(colDn!==col){ var br=r+1; if(!sepH[br]) sepH[br]=[]; sepH[br][c]=true; }
    // Left edge
    var colLt=(grid[r]&&grid[r][c-1])||null;
    if(colLt!==col){ if(!sepV[r]) sepV[r]=[]; sepV[r][c]=true; }
    // Right edge
    var colRt=(grid[r]&&grid[r][c+1])||null;
    if(colRt!==col){ var bc=c+1; if(!sepV[r]) sepV[r]=[]; sepV[r][bc]=true; }
  });
  savePxH(); drawPx();
}

// ── Restaurer les couleurs VC pour les stands d'un groupe (suppression/dégroupement)
// Fonctionne indépendamment de isPxGroup — si standIds existe, on restaure
function grpRestoreVcColors(grp){
  if(!grp.standIds || grp.standIds.length===0) return;
  vcLayers.stands.forEach(function(o){
    if(o.sData && grp.standIds.indexOf(o.sData.id)>=0) vcRestoreStandColor(o);
  });
  vc.requestRenderAll();
}

// ── Appliquer la couleur du groupe à tous ses stands membres (identifiés par standIds)
function vcApplyGroupColor(grp){
  var clr = grp.color || vcGroupColor(grp);
  vcLayers.stands.forEach(function(o){
    if(!o.sData || grp.standIds.indexOf(o.sData.id) < 0) return;
    var items = o.getObjects();
    if(items[0]) items[0].set({stroke: clr, fill: hexToRgba(clr, 0.13)});
    if(items[1]) items[1].set('fill', clr);
    if(items[2]) items[2].set('fill', clr+'cc');
    if(items[3]) items[3].set('fill', clr+'99');
  });
  vc.requestRenderAll();
}

// ── Restaurer la couleur d'origine d'un stand (hors groupe)
function vcRestoreStandColor(o){
  if(!o.sData) return;
  var c=getStandColor(o.sData.type);
  var items=o.getObjects();
  if(items[0]) items[0].set({stroke:c.stroke, fill:c.fill});
  if(items[1]) items[1].set('fill', c.stroke);
  if(items[2]) items[2].set('fill', c.stroke+'cc');
  if(items[3]) items[3].set('fill', c.stroke+'aa');
}

// ── Supprimer tous les overlays de groupe du canvas (après loadFromJSON)
function vcStripOverlays(){
  var toRemove=[];
  vc.getObjects().forEach(function(o){
    if(o._groupOverlay) toRemove.push(o);
  });
  toRemove.forEach(function(o){ vc.remove(o); });
  vcLayers.annot=vcLayers.annot.filter(function(o){ return !o._groupOverlay; });
}

// ── Construire/mettre à jour le contour englobant d'un groupe
function rebuildGroupOverlay(grp){
  // Find existing overlay objects for this group (avoid remove/add to preserve active selection)
  var existingBorder=null, existingLbl=null;
  vc.getObjects().forEach(function(o){
    if(o._groupOverlay===grp.id){
      if(o.type==='rect' && !existingBorder) existingBorder=o;
      else if(o.type==='text' && !existingLbl) existingLbl=o;
    }
  });

  var stands=vcLayers.stands.filter(function(o){
    return o.sData && grp.standIds.indexOf(o.sData.id)>=0;
  });
  if(stands.length===0){
    // No stands → remove overlays
    if(existingBorder){ vc.remove(existingBorder); vcLayers.annot=vcLayers.annot.filter(function(o){return o!==existingBorder;}); }
    if(existingLbl){ vc.remove(existingLbl); vcLayers.annot=vcLayers.annot.filter(function(o){return o!==existingLbl;}); }
    return;
  }

  var minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
  stands.forEach(function(o){
    var w=(o.width||0)*(o.scaleX||1);
    var h=(o.height||0)*(o.scaleY||1);
    var ox, oy;
    if(o.group && o.group.type==='activeSelection'){
      // Inside ActiveSelection: calcTransformMatrix always returns center coords
      var m=o.calcTransformMatrix();
      ox=m[4]-w/2; oy=m[5]-h/2;
    } else {
      ox=o.left; oy=o.top;
    }
    minX=Math.min(minX,ox); minY=Math.min(minY,oy);
    maxX=Math.max(maxX,ox+w); maxY=Math.max(maxY,oy+h);
  });
  var pad=10, clr=vcGroupColor(grp);

  if(existingBorder){
    // Reset ALL transform properties to avoid stale state from serialization/transforms
    existingBorder.set({
      left:minX-pad, top:minY-pad,
      width:(maxX-minX)+pad*2, height:(maxY-minY)+pad*2,
      scaleX:1, scaleY:1, angle:0, skewX:0, skewY:0,
      flipX:false, flipY:false,
      fill:hexToRgba(clr,0.04), stroke:clr,
      selectable:false, evented:false
    });
    existingBorder.setCoords(); existingBorder.dirty=true;
  } else {
    var border=new fabric.Rect({
      left:minX-pad, top:minY-pad,
      width:(maxX-minX)+pad*2, height:(maxY-minY)+pad*2,
      fill:hexToRgba(clr,0.04), stroke:clr, strokeWidth:1.5,
      strokeDashArray:[6,3], rx:8,
      selectable:false, evented:false
    });
    border._layer='annot'; border._groupOverlay=grp.id;
    vcLayers.annot.push(border); vc.add(border); vc.sendToBack(border);
  }

  if(existingLbl){
    existingLbl.set({
      left:minX-pad+7, top:minY-pad-15,
      scaleX:1, scaleY:1, angle:0, skewX:0, skewY:0,
      flipX:false, flipY:false,
      text:grp.name, fill:clr,
      selectable:false, evented:false
    });
    existingLbl.setCoords(); existingLbl.dirty=true;
  } else {
    var lbl=new fabric.Text(grp.name,{
      left:minX-pad+7, top:minY-pad-15,
      fontSize:9, fill:clr, fontFamily:'system-ui,sans-serif', fontWeight:'700',
      selectable:false, evented:false,
      backgroundColor:'rgba(10,8,20,.82)', padding:2
    });
    lbl._layer='annot'; lbl._groupOverlay=grp.id;
    vcLayers.annot.push(lbl); vc.add(lbl);
  }
}

// ── Rendre la liste des groupes dans les deux sidebars
// ── Système de groupes unifié px + vc ───────────────────────────────

function renderGroupsList(){
  function buildAndAttach(el){
    if(!el) return;
    if(vcGroups.length===0){
      el.innerHTML='<div style="font-size:9px;color:var(--mu2);font-style:italic">Aucun groupe</div>';
      return;
    }
    el.innerHTML=vcGroups.map(function(grp){
      var clr=vcGroupColor(grp);
      var count = grp.isPxGroup ? (grp.pxCells ? grp.pxCells.length : 0) : grp.standIds.length;
      var badge = grp.isPxGroup
        ? '<span style="font-size:8px;color:var(--mu2);background:var(--bg3);border-radius:3px;padding:1px 4px">PX</span>'
        : '<span style="font-size:8px;color:var(--mu2);background:var(--bg3);border-radius:3px;padding:1px 4px">VC</span>';
      return '<div data-gid="'+grp.id+'" class="grp-row" style="display:flex;align-items:center;gap:5px;padding:5px 7px;border-radius:6px;border:1px solid '+clr+'44;background:'+clr+'0f;cursor:pointer">'
        +'<div style="width:8px;height:8px;border-radius:50%;background:'+clr+';flex-shrink:0"></div>'
        +'<span style="flex:1;font-size:9px;color:'+clr+';overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+grp.name+'</span>'
        +badge
        +'</div>';
    }).join('');
    el.querySelectorAll('.grp-row').forEach(function(row){
      row.addEventListener('click', function(){ vcSelectGroupById(row.dataset.gid); });
    });
  }
  buildAndAttach(document.getElementById('groups-list'));   // PX right sidebar
}

function vcSelectGroupById(gid){
  var grp = vcGroups.find(function(g){ return g.id === gid; });
  if(!grp) return;

  var hasPx = grp.pxCells && grp.pxCells.length > 0;
  var hasVc = grp.standIds && grp.standIds.length > 0;

  // Stay on current tab whenever possible
  if(activeTab === 'px'){
    // VC-only group on pixel side → switch to vector tab
    if(!hasPx && hasVc){
      switchTab('vc');
      vcSelectGroup(grp);
      renderVcGroupPanel(grp);
  
      return;
    }
    // On pixel side — show group info here
    if(hasPx){
      setPxTool('select');
      var r1=Infinity,r2=-Infinity,c1=Infinity,c2=-Infinity;
      var cellSet={};
      grp.pxCells.forEach(function(px){
        if(px.r<r1)r1=px.r; if(px.r>r2)r2=px.r;
        if(px.c<c1)c1=px.c; if(px.c>c2)c2=px.c;
        cellSet[px.r+','+px.c]=true;
      });
      pxSel={r1:r1,r2:r2,c1:c1,c2:c2};
      pxSelCells=cellSet;
      drawPx(); drawSelOverlay();
      // Scroll canvas to center on group cells
      var area=document.getElementById('px-area');
      if(area){
        var cp2=cellPx();
        var padX=Math.round((area.clientWidth||600)/2);
        var padY=Math.round((area.clientHeight||400)/2);
        var cx=((c1+c2)/2+0.5)*cp2, cy=((r1+r2)/2+0.5)*cp2;
        area.scrollLeft=padX+cx-(area.clientWidth||600)/2;
        area.scrollTop =padY+cy-(area.clientHeight||400)/2;
      }
    }
    renderPxGroupPanel(grp);
    return;
  }

  // PX-only group on vector side → switch to pixel tab
  if(hasPx && !hasVc){
    switchTab('px');
    // Re-call self now that we're on PX tab
    vcSelectGroupById(gid);
    return;
  }

  // On vector side — select stands
  vcSelectGroup(grp);
  renderVcGroupPanel(grp);
}

// ── Création de groupe via popup modal (px + vc) ──
function grpAskCreate(){
  if(activeTab === 'px'){
    if(!pxSel){ alert("Sélectionnez d'abord des cellules avec l'outil Sélection."); return; }
    // Compute pixel-side dimensions
    var rCount = pxSel.r2 - pxSel.r1 + 1;
    var cCount = pxSel.c2 - pxSel.c1 + 1;
    var wm = (cCount * cellM).toFixed(1);
    var hm = (rCount * cellM).toFixed(1);
    var sm = (wm * hm).toFixed(1);
    document.getElementById('mg-dims').textContent = wm + 'm x ' + hm + 'm = ' + sm + ' m\u00B2';
  } else {
    var active = vc.getActiveObject();
    if(!active){ alert("Sélectionnez d'abord des stands."); return; }
    var objs = active.type === 'activeSelection' ? active.getObjects() : [active];
    var stands = objs.filter(function(o){ return !!o.sData; });
    if(stands.length < 2){ alert("Sélectionnez au moins 2 stands."); return; }
    // Compute combined bounding box in meters
    var minX=Infinity, minY=Infinity, maxX=-Infinity, maxY=-Infinity;
    stands.forEach(function(o){
      var s=o.sData;
      var w=(o.width||0)*(o.scaleX||1), h=(o.height||0)*(o.scaleY||1);
      var ox=o.left, oy=o.top;
      if(o.group && o.group.type==='activeSelection'){
        var m=o.calcTransformMatrix(); ox=m[4]-w/2; oy=m[5]-h/2;
      }
      minX=Math.min(minX,ox); minY=Math.min(minY,oy);
      maxX=Math.max(maxX,ox+w); maxY=Math.max(maxY,oy+h);
    });
    var wm=((maxX-minX)/pxPerM).toFixed(1);
    var hm=((maxY-minY)/pxPerM).toFixed(1);
    var sm=(wm*hm).toFixed(1);
    document.getElementById('mg-dims').textContent = wm + 'm x ' + hm + 'm = ' + sm + ' m\u00B2';
  }
  // Populate type dropdown
  var sel = document.getElementById('mg-type');
  sel.innerHTML = RTYPES.filter(function(r){ return r.key!=='aisle' && r.key!=='wall'; })
    .map(function(r){ return '<option value="'+r.key+'">'+r.name+'</option>'; }).join('');
  if(sel.options.length > 0) sel.selectedIndex = 0;
  // Auto-fill name
  var nameInp = document.getElementById('mg-name');
  nameInp.value = 'Groupe ' + (vcGroups.length + 1);
  openM('m-grp');
  setTimeout(function(){ nameInp.focus(); nameInp.select(); }, 50);
}

function confirmGroupCreate(){
  var name = document.getElementById('mg-name').value.trim();
  var type = document.getElementById('mg-type').value;
  if(!name) name = 'Groupe ' + (vcGroups.length + 1);
  closeM('m-grp');

  if(activeTab === 'px'){
    // ── Groupe pixel ──
    var cells = [];
    if(pxSel){
      for(var r=pxSel.r1; r<=pxSel.r2; r++){
        for(var c=pxSel.c1; c<=pxSel.c2; c++){
          if(pxSelCells && !pxSelCells[r+','+c]) continue; // respect irregular selection
          var col = grid[r] && grid[r][c];
          if(col) cells.push({r:r, c:c, originalColor:col, color:col});
        }
      }
    }
    if(cells.length === 0){ alert("Aucune cellule sélectionnée."); return; }
    var sc = getStandColor(type);
    var grpColor = sc.stroke;
    cells.forEach(function(px){
      px.color = grpColor;
      setCell(px.r, px.c, grpColor);
    });
    var newGrp = {id:'grp_'+Date.now(), name:name, standIds:[], isPxGroup:true, pxCells:cells, color:grpColor, type:type};
    vcGroups.push(newGrp);
    pxSel=null; pxSelCells=null;
    savePxH(); modLayerSaveCurrent();
    renderGroupsList(); drawPx();
    renderPxGroupPanel(newGrp);
  } else {
    // ── Groupe vectoriel ──
    vcCreateGroup(name, type);
  }
}


// ── Trouver le groupe pixel d'une cellule
// ── Recalculer les pxCells de tous les groupes convertis (VC→PX) à partir des positions VC actuelles
// Utilisé après loadVcJSON, modLayerLoad, et syncVcToPx pour corriger les coords périmées
// IMPORTANT: must use calcTransformMatrix() for position (same as _doVcToPxData)
// because stand.left/top are CENTER coordinates for fabric.js groups
function _recomputeConvertedGroupPxCells(){
  if(!vcLayers || !vcLayers.stands) return;
  vcGroups.forEach(function(g){
    if(!g.isPxGroup || !g.standIds || g.standIds.length===0) return;
    var cells=[];
    var clr=g.color || vcGroupColor(g);
    if(!clr) return;
    g.standIds.forEach(function(sid){
      var stand=vcLayers.stands.find(function(o){ return o.sData && o.sData.id===sid; });
      if(!stand || !stand.sData) return;
      var w=(stand.width||0)*(stand.scaleX||1);
      var h=(stand.height||0)*(stand.scaleY||1);
      // Use calcTransformMatrix for absolute top-left position (matches _doVcToPxData)
      var m=stand.calcTransformMatrix();
      var ax=m[4]-w/2, ay=m[5]-h/2;
      var gc1=Math.max(0, Math.round(pxToM(ax)/cellM));
      var gr1=Math.max(0, Math.round(pxToM(ay)/cellM));
      var gc2=Math.min(numCols()-1, Math.round(pxToM(ax+w)/cellM)-1);
      var gr2=Math.min(numRows()-1, Math.round(pxToM(ay+h)/cellM)-1);
      var origColor=typeToColor(stand.sData.type);
      for(var row=gr1;row<=gr2;row++){
        for(var col=gc1;col<=gc2;col++){
          if(grid[row] && grid[row][col]){
            cells.push({r:row, c:col, color:clr, originalColor:origColor});
          }
        }
      }
    });
    if(cells.length>0){ g.pxCells=cells; }
  });
}

// ── Appliquer les couleurs des groupes PX sur le grid (après chargement ou switch de calque)
function _applyPxGroupColorsToGrid(){
  vcGroups.forEach(function(g){
    if(g.isPxGroup && g.pxCells){
      g.pxCells.forEach(function(px){
        if(grid[px.r] && grid[px.r][px.c]) setCell(px.r, px.c, px.color);
      });
    }
  });
}

function pxGetCellGroup(r, c){
  return vcGroups.find(function(g){
    if(!g.isPxGroup || !g.pxCells) return false;
    return g.pxCells.some(function(px){ return px.r===r && px.c===c; });
  }) || null;
}

// ── Afficher le panneau d'un groupe pixel dans la sidebar droite PX
function renderPxGroupPanel(grp){
  var sec = document.getElementById('px-sel-sec');
  var det = document.getElementById('px-sel-detail');
  if(!sec || !det) return;
  sec.style.display = 'block';
  var clr = grp.color || vcGroupColor(grp);
  var count = grp.pxCells ? grp.pxCells.length : 0;
  var rtype = grp.type ? (RTYPES.find(function(r){return r.key===grp.type;})||{name:grp.type}) : null;
  det.innerHTML =
    '<div style="border:1.5px solid '+clr+';border-radius:7px;padding:9px">'
    +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px">'
      +'<div style="font-size:9px;color:'+clr+';font-weight:700">&#128230; '+grp.name+'</div>'
      +'<button id="px-grp-edit-btn" style="background:var(--white);border:1px solid var(--bd);border-radius:4px;color:var(--mu);padding:2px 6px;cursor:pointer;font-size:9px;font-family:inherit">&#9999; Editer</button>'
    +'</div>'
    +(rtype ? '<div class="prow"><span class="plbl">Type</span><span class="pval" style="color:'+clr+'">'+rtype.name+'</span></div>' : '')
    +'<div class="prow"><span class="plbl">Cellules</span><span class="pval">'+count+'</span></div>'
    +'<button id="px-grp-sel-btn" style="width:100%;margin-top:6px;margin-bottom:3px;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">&#9654; S&eacute;lectionner</button>'
    +'<button id="px-grp-del-btn" style="width:100%;padding:4px;border-radius:4px;background:rgba(248,113,113,.07);border:1px solid rgba(248,113,113,.2);color:#f87171;cursor:pointer;font-size:9px;font-family:inherit">&#128465; Supprimer le groupe</button>'
    +'</div>';

  var gid = grp.id;
  document.getElementById('px-grp-edit-btn').onclick = function(){ openGroupEdit(gid); };
  document.getElementById('px-grp-sel-btn').onclick = function(){
    vcSelectGroupById(gid);
  };
  document.getElementById('px-grp-del-btn').onclick = function(){
    var g=vcGroups.find(function(x){return x.id===gid;});
    if(g){
      grpRestorePxColors(g);
      grpRestoreVcColors(g);
      if(typeof vc!=='undefined' && vc){
        vc.getObjects().filter(function(o){ return o._groupOverlay===gid; })
          .forEach(function(o){ vc.remove(o); });
        vcLayers.annot=vcLayers.annot.filter(function(o){ return o._groupOverlay!==gid; });
        vc.requestRenderAll();
      }
    }
    vcGroups = vcGroups.filter(function(x){return x.id!==gid;});
    modLayerSaveCurrent(); renderGroupsList();
    var sec2=document.getElementById('px-sel-sec'); if(sec2) sec2.style.display='none';
  };
}

// ── Initialiser _ax/_ay sur tous les stands qui ne l'ont pas encore
function vcInitStandAbsPos(force){
  vcLayers.stands.forEach(function(o){
    if(!o.sData) return;
    if(force || o.sData._ax==null){
      o.sData._ax = o.left;
      o.sData._ay = o.top;
    }
  });
}

function rebuildGroupOverlays(){
  vcInitStandAbsPos(); // s'assurer que _ax/_ay sont à jour avant de dessiner
  vcGroups.forEach(function(g){ rebuildGroupOverlay(g); });
  vc.requestRenderAll();
  renderGroupsList();
}

// ── Créer un groupe depuis la sélection active
function vcCreateGroup(name, type){
  var active=vc.getActiveObject();
  if(!active) return;
  var objs=active.type==='activeSelection' ? active.getObjects() : [active];
  var stands=objs.filter(function(o){ return !!o.sData; });
  if(stands.length<2){ return; }

  var ids=stands.map(function(o){ return o.sData.id; });

  // Retirer ces stands de tout groupe existant (+ restaurer leur couleur)
  var oldGroups=[];
  vcGroups.forEach(function(g){
    var before=g.standIds.length;
    g.standIds=g.standIds.filter(function(id){ return ids.indexOf(id)<0; });
    if(g.standIds.length!==before) oldGroups.push(g);
  });
  vcGroups=vcGroups.filter(function(g){ return g.standIds.length>0; });
  // Supprimer overlays des groupes vidés
  oldGroups.forEach(function(g){
    if(vcGroups.indexOf(g)<0){
      vc.getObjects().filter(function(o){ return o._groupOverlay===g.id; })
        .forEach(function(o){ vc.remove(o); });
      vcLayers.annot=vcLayers.annot.filter(function(o){ return o._groupOverlay!==g.id; });
    } else { rebuildGroupOverlay(g); }
  });
  // Restaurer couleur de ceux qui ont quitté leur groupe
  stands.forEach(function(o){ vcRestoreStandColor(o); });

  var newGrp={id:'grp_'+Date.now(), name:name||'Groupe', standIds:ids};
  if(type) newGrp.type = type;
  // Assigner la couleur du groupe
  newGrp.color = vcGroupColor(newGrp);
  vcGroups.push(newGrp);
  vcApplyGroupColor(newGrp);
  grpSyncColorToPx(newGrp); // sync vers pixel
  vc.discardActiveObject(); // must discard BEFORE rebuilding overlay so stands have absolute coords
  rebuildGroupOverlay(newGrp);
  vc.requestRenderAll();
  modLayerSaveCurrent();
  renderGroupsList();
  renderVcGroupPanel(newGrp);
}

// ── Sélectionner tous les stands d'un groupe (ActiveSelection Fabric)
function vcSelectGroup(grp){
  var stands=vcLayers.stands.filter(function(o){
    return o.sData && grp.standIds.indexOf(o.sData.id)>=0;
  });
  if(stands.length===0) return;
  // Preserve viewport transform to prevent screen jump
  var savedVT=vc.viewportTransform.slice();
  if(stands.length===1){
    vc.setActiveObject(stands[0]);
  } else {
    var sel=new fabric.ActiveSelection(stands, {canvas:vc});
    vc.setActiveObject(sel);
  }
  // Restore viewport transform
  vc.setViewportTransform(savedVT);
  vc.requestRenderAll();
}

// ── Dégrouper un groupe par son id
function vcUngroupById(gid){
  var grp=vcGroups.find(function(g){ return g.id===gid; });
  if(grp){
    // Restaurer couleurs dans les deux modes (fonctionne indépendamment de isPxGroup)
    grpRestorePxColors(grp); // pixels → couleurs originales (si pxCells existe)
    grpRestoreVcColors(grp); // stands VC → couleurs par type (si standIds existe)
    // Supprimer overlay
    vc.getObjects().filter(function(o){ return o._groupOverlay===gid; })
      .forEach(function(o){ vc.remove(o); });
    vcLayers.annot=vcLayers.annot.filter(function(o){ return o._groupOverlay!==gid; });
    vcGroups=vcGroups.filter(function(g){ return g.id!==gid; });
  }
  vc.discardActiveObject();
  vc.requestRenderAll();
  modLayerSaveCurrent();
  renderGroupsList();
  vcDesel();
}

// ── Supprimer le groupe (garde les stands, retire seulement le groupement)
function vcDeleteGroup(gid){
  vcUngroupById(gid);
}

// ── Trouver le groupe d'un stand
function vcGetStandGroup(standId){
  return vcGroups.find(function(g){ return g.standIds.indexOf(standId)>=0; })||null;
}

// ── Mettre à jour les overlays quand un stand bouge
function vcUpdateGroupOverlaysForStand(standId){
  var grp=vcGetStandGroup(standId);
  if(grp) rebuildGroupOverlay(grp);
}

// ── Panneau groupe dans la colonne droite
function renderVcGroupPanel(grp){
  var clr=vcGroupColor(grp);
  var nStands=grp.standIds.length;
  var rtype=grp.type ? (RTYPES.find(function(r){return r.key===grp.type;})||{name:grp.type}) : null;
  // Compute combined dimensions
  var groupStands=vcLayers.stands.filter(function(o){ return o.sData && grp.standIds.indexOf(o.sData.id)>=0; });
  var dimsHtml='';
  if(groupStands.length>0){
    var minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
    groupStands.forEach(function(o){
      var w=(o.width||0)*(o.scaleX||1), h=(o.height||0)*(o.scaleY||1);
      minX=Math.min(minX,o.left); minY=Math.min(minY,o.top);
      maxX=Math.max(maxX,o.left+w); maxY=Math.max(maxY,o.top+h);
    });
    var wm=((maxX-minX)/pxPerM).toFixed(1), hm=((maxY-minY)/pxPerM).toFixed(1);
    var sm=(wm*hm).toFixed(1);
    dimsHtml='<div class="prow"><span class="plbl">Surface</span><span class="pval">'+sm+' m&sup2;</span></div>'
      +'<div class="prow"><span class="plbl">Dim.</span><span class="pval">'+wm+'x'+hm+'m</span></div>';
  }
  var el=document.getElementById('vc-detail');
  el.innerHTML=
    '<div id="grp-panel" style="border:1.5px solid '+clr+';border-radius:7px;padding:9px">'
    +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px">'
      +'<div style="font-size:9px;color:'+clr+';font-weight:700">&#128230; '+grp.name+'</div>'
      +'<button id="grp-edit-btn" style="background:var(--white);border:1px solid var(--bd);border-radius:4px;color:var(--mu);padding:2px 6px;cursor:pointer;font-size:9px;font-family:inherit">&#9999; Editer</button>'
    +'</div>'
    +(rtype ? '<div class="prow"><span class="plbl">Type</span><span class="pval" style="color:'+clr+'">'+rtype.name+'</span></div>' : '')
    +'<div class="prow"><span class="plbl">Stands</span><span class="pval">'+nStands+'</span></div>'
    +dimsHtml
    +'<div style="font-size:9px;color:var(--mu2);margin:6px 0 4px">Cliquer un exposant pour assigner au groupe</div>'
    +'<button id="grp-sel-btn" style="width:100%;margin-bottom:3px;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">&#9654; S&eacute;lectionner tout le groupe</button>'
    +'<button id="grp-ungrp-btn" style="width:100%;margin-bottom:3px;padding:4px;border-radius:4px;background:var(--bg3);border:1px solid var(--bd);color:var(--mu);cursor:pointer;font-size:9px;font-family:inherit">&#10005; D&eacute;grouper</button>'
    +'<button id="grp-del-btn" style="width:100%;padding:4px;border-radius:4px;background:rgba(248,113,113,.07);border:1px solid rgba(248,113,113,.2);color:#f87171;cursor:pointer;font-size:9px;font-family:inherit">&#128465; Supprimer le groupe</button>'
    +'</div>';
  var gid=grp.id;
  document.getElementById('grp-edit-btn').onclick=function(){ openGroupEdit(gid); };
  document.getElementById('grp-sel-btn').onclick=function(){
    var g=vcGroups.find(function(x){ return x.id===gid; }); if(g) vcSelectGroup(g);
  };
  document.getElementById('grp-ungrp-btn').onclick=function(){ vcUngroupById(gid); };
  document.getElementById('grp-del-btn').onclick=function(){ vcDeleteGroup(gid); };
}

// ── Ouvre la modale d'édition du groupe ──
function openGroupEdit(gid){
  var grp=vcGroups.find(function(g){ return g.id===gid; }); if(!grp) return;
  window._editGrpId=gid;
  document.getElementById('ge-name').value=grp.name;
  var sel=document.getElementById('ge-type');
  sel.innerHTML=RTYPES.filter(function(r){return r.key!=='aisle'&&r.key!=='wall';})
    .map(function(r){return '<option value="'+r.key+'"'+(r.key===grp.type?' selected':'')+'>'+r.name+'</option>';}).join('');
  if(sel.selectedIndex<0 && sel.options.length>0) sel.selectedIndex=0;
  openM('m-grp-edit');
}

// ── Valide les modifications du groupe ──
function confirmGroupEdit(){
  var gid=window._editGrpId;
  var grp=vcGroups.find(function(g){ return g.id===gid; });
  if(!grp){ closeM('m-grp-edit'); return; }
  var newName=document.getElementById('ge-name').value.trim();
  var newType=document.getElementById('ge-type').value;
  if(newName) grp.name=newName;
  grp.type=newType;
  grp.color=vcGroupColor(grp); // re-derive from type
  // Apply to VC stands
  vcApplyGroupColor(grp); rebuildGroupOverlay(grp); vc.requestRenderAll();
  // Sync to pixel (grpSyncColorToPx handles both PX and VC groups, including drawPx for PX)
  grpSyncColorToPx(grp);
  modLayerSaveCurrent(); renderGroupsList();
  // Re-render the appropriate panel
  if(grp.isPxGroup){ renderPxGroupPanel(grp); drawPx(); }
  else { renderVcGroupPanel(grp); }
  closeM('m-grp-edit');
}

// ── Création/édition de groupe via popup modal (remplace ancien formulaire inline)


var _vcSelBusy=false;
var _vcPendingGroupSel=null; // deferred group selection (applied on mouse:up)
function vcSel(opt){
  if(_vcSelBusy) return;
  _vcIsolatedStand=false; // reset on any new selection
  var active=vc.getActiveObject();
  console.log('[vcSel-debug]', active && {type:active.type, layer:active._layer, sData:!!active.sData, groupOverlay:active._groupOverlay, text:active.text, objects:active.getObjects?active.getObjects().map(function(o){return o.type;}):null});

  // Sélection simple d'un stand
  if(active&&active.sData){
    var grp=vcGetStandGroup(active.sData.id);
    if(grp && !_vcSingleStandSelect){
      // Stand appartenant à un groupe → defer group selection
      // Lock movement to prevent accidental drag during transition
      active._origLockX=active.lockMovementX;
      active._origLockY=active.lockMovementY;
      active.set({lockMovementX:true, lockMovementY:true});
      vcSelStand=active;
      renderVcGroupPanel(grp);
      _vcPendingGroupSel=grp;
    } else {
      vcSelStand=active;
      renderDetail(active);
  
      renderProps(active);
    }
    renderExp();
    vcHighlightRtype();

  // Sélection d'une mesure
  } else if(active&&active._layer==='meas'){
    vcSelStand=null;

    renderProps(active);
    var md=active._measData;
    document.getElementById('vc-detail').innerHTML=
      '<div class="sinfo">'
        +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px">'
          +'<div class="snum">📏 Mesure</div>'
        +'</div>'
        +'<div class="prow"><span class="plbl">Distance</span><span class="pval" style="color:#e11d48;font-weight:700">'+(md?md.dm:'—')+'</span></div>'
      +'</div>'
      +'<button id="btn-del-meas" style="width:100%;margin-top:8px;padding:6px;border-radius:5px;background:rgba(239,68,68,.1);border:1.5px solid rgba(239,68,68,.3);color:#ef4444;cursor:pointer;font-size:10px;font-family:inherit;font-weight:600">🗑️ Supprimer la mesure</button>';
    document.getElementById('btn-del-meas').addEventListener('click',function(){
      vcLayers.meas=vcLayers.meas.filter(function(o){return o!==active;});
      vc.remove(active); vc.discardActiveObject(); vc.renderAll(); updateVcStatus(); vcDesel();
    });

  // Sélection d'un texte (mise en forme)
  } else if(_isFormattableText(active)){
    vcSelStand=null;
    renderTextFormatPanel(active);

  // Sélection d'une allée ou mur
  } else if(active&&(active._layer==='aisles'||active._layer==='struct')){
    vcSelStand=null;

    renderProps(active);
    var layerName=active._layer==='aisles'?'Allée':'Structure';
    document.getElementById('vc-detail').innerHTML=
      '<div class="sinfo"><div class="snum">'+(active._layer==='aisles'?'🔲':'🧱')+' '+layerName+'</div></div>'
      +'<button id="btn-del-obj" style="width:100%;margin-top:8px;padding:6px;border-radius:5px;background:rgba(239,68,68,.1);border:1.5px solid rgba(239,68,68,.3);color:#ef4444;cursor:pointer;font-size:10px;font-family:inherit;font-weight:600">🗑️ Supprimer</button>';
    document.getElementById('btn-del-obj').addEventListener('click',function(){
      if(vcLayers[active._layer]) vcLayers[active._layer]=vcLayers[active._layer].filter(function(o){return o!==active;});
      vc.remove(active); vc.discardActiveObject(); vc.renderAll(); updateVcStatus(); vcDesel();
    });

  // Sélection multiple
  } else if(active&&active.type==='activeSelection'){
    var objs=active.getObjects();
    var stands=objs.filter(function(o){ return !!o.sData; });
    var firstStand=stands[0];
    if(!firstStand) return;
    vcSelStand=firstStand;

    renderProps(firstStand);
    renderExp();

    // Tous dans le même groupe ?
    var grps=stands.map(function(o){ return vcGetStandGroup(o.sData.id); });
    var allGrp=grps[0] && grps.every(function(g){ return g&&g.id===grps[0].id; });
    if(allGrp){
      renderVcGroupPanel(grps[0]);
    } else {
      document.getElementById('vc-detail').innerHTML=
        '<div style="font-size:9px;color:var(--mu2);margin-bottom:6px">'+stands.length+' stand(s) s&eacute;lectionn&eacute;(s)</div>'
        +'<button onclick="grpAskCreate()" style="width:100%;padding:5px;border-radius:5px;background:rgba(91,108,249,.12);border:1.5px solid rgba(91,108,249,.3);color:#8b9fff;cursor:pointer;font-size:9px;font-family:inherit;font-weight:600">&#128230; Grouper la s&eacute;lection</button>';
    }
  }
}
// ── Mise en forme du texte sélectionné (contenu, taille, police, couleur)
var TEXT_FONTS=['system-ui','Arial','Helvetica','Verdana','Trebuchet MS','Georgia','Times New Roman','Courier New','Marianne'];
var _textFmtSaveTimer=null;
function _isFormattableText(o){
  return !!o && (o.type==='text'||o.type==='i-text'||o.type==='textbox') && !o._groupOverlay && !o.sData;
}
function _textFillHex(o){
  var f=o.fill;
  if(typeof f==='string'){
    if(/^#[0-9a-f]{6}$/i.test(f)) return f.toLowerCase();
    if(/^#[0-9a-f]{3}$/i.test(f)) return '#'+f.slice(1).split('').map(function(c){return c+c;}).join('').toLowerCase();
    var m=f.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if(m) return '#'+[m[1],m[2],m[3]].map(function(n){return ('0'+Math.min(255,parseInt(n,10)).toString(16)).slice(-2);}).join('');
  }
  return '#000000';
}
function _textFmtChanged(){
  vc.requestRenderAll();
  if(_dirtyNotify&&!_suppressDirty) _dirtyNotify(true);
  clearTimeout(_textFmtSaveTimer);
  _textFmtSaveTimer=setTimeout(function(){ modLayerSaveCurrent(); },300);
}
function renderTextFormatPanel(obj){
  var fam=(obj.fontFamily||'system-ui');
  var fonts=TEXT_FONTS.slice();
  if(fonts.indexOf(fam)<0) fonts.unshift(fam);
  var esc=function(v){ return String(v).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); };
  var inp='width:100%;box-sizing:border-box;padding:5px 6px;border-radius:5px;border:1px solid var(--bd);background:var(--white);color:var(--tx);font-size:11px;font-family:inherit';
  var btn='width:26px;height:26px;border-radius:5px;border:1px solid var(--bd);background:var(--white);color:var(--tx);cursor:pointer;font-size:14px;font-family:inherit;line-height:1';
  document.getElementById('vc-detail').innerHTML=
    '<div class="sinfo">'
      +'<div class="snum" style="margin-bottom:6px">&#128288; Texte</div>'
      +'<div class="plbl" style="margin-bottom:2px">Contenu</div>'
      +'<textarea id="vc-tf-text" rows="2" style="'+inp+';resize:vertical;margin-bottom:6px">'+esc(obj.text||'')+'</textarea>'
      +'<div class="plbl" style="margin-bottom:2px">Taille</div>'
      +'<div style="display:flex;gap:4px;align-items:center;margin-bottom:6px">'
        +'<button id="vc-tf-dec" type="button" style="'+btn+'">&minus;</button>'
        +'<input id="vc-tf-size" type="number" min="4" max="400" value="'+Math.round(obj.fontSize||14)+'" style="'+inp+';text-align:center">'
        +'<button id="vc-tf-inc" type="button" style="'+btn+'">+</button>'
      +'</div>'
      +'<div class="plbl" style="margin-bottom:2px">Police</div>'
      +'<select id="vc-tf-font" style="'+inp+';cursor:pointer;margin-bottom:6px">'
        +fonts.map(function(f){ return '<option value="'+esc(f)+'"'+(f===fam?' selected':'')+' style="font-family:'+esc(f)+'">'+esc(f)+'</option>'; }).join('')
      +'</select>'
      +'<div class="plbl" style="margin-bottom:2px">Couleur</div>'
      +'<input id="vc-tf-color" type="color" value="'+_textFillHex(obj)+'" style="width:100%;height:28px;padding:0;border:1px solid var(--bd);border-radius:5px;background:var(--white);cursor:pointer;margin-bottom:8px">'
      +'<button id="vc-tf-del" type="button" style="width:100%;padding:6px;border-radius:5px;background:rgba(239,68,68,.1);border:1.5px solid rgba(239,68,68,.3);color:#ef4444;cursor:pointer;font-size:10px;font-family:inherit;font-weight:600">&#128465;&#65039; Supprimer</button>'
    +'</div>';
  var $=function(id){ return document.getElementById(id); };
  function apply(props){ obj.set(props); obj.dirty=true; obj.setCoords(); _textFmtChanged(); }
  function setSize(v){
    v=Math.max(4,Math.min(400,Math.round(v)));
    if(isNaN(v)) return;
    $('vc-tf-size').value=v; apply({fontSize:v});
  }
  $('vc-tf-text').addEventListener('input',function(){ apply({text:this.value}); });
  $('vc-tf-dec').addEventListener('click',function(){ setSize((obj.fontSize||14)-1); });
  $('vc-tf-inc').addEventListener('click',function(){ setSize((obj.fontSize||14)+1); });
  $('vc-tf-size').addEventListener('input',function(){ var v=parseFloat(this.value); if(v>=4) setSize(v); });
  $('vc-tf-font').addEventListener('change',function(){ apply({fontFamily:this.value}); });
  $('vc-tf-color').addEventListener('input',function(){ apply({fill:this.value}); });
  $('vc-tf-del').addEventListener('click',function(){
    if(vcLayers[obj._layer]) vcLayers[obj._layer]=vcLayers[obj._layer].filter(function(o){return o!==obj;});
    vc.remove(obj); vc.discardActiveObject(); vc.renderAll(); updateVcStatus(); vcDesel();
  });
}
function vcDesel(){
  if(_vcSelBusy) return;
  vcSelStand=null;
  _vcIsolatedStand=false;
  document.getElementById('vc-detail').innerHTML='<div class="hint">🖱 Cliquez un stand</div>';
  renderExp();
  vcHighlightRtype();
}

// ── Panneau détail du stand sélectionné avec statuts d'assignement
function renderDetail(obj){
  var s=obj.sData;
  var assign=vcAssigns[s.id]; // {expo, status} ou undefined
  var expo=assign?assign.expo:null;
  var status=assign?assign.status:'free';
  var st=ASSIGN_STATUS[status]||ASSIGN_STATUS.free;
  var rtype=RTYPES.find(function(r){return r.key===s.type;})||{name:s.type,color:'#5b6cf9'};
  var c=getStandColor(s.type);

  // ── Infos du stand (éditables)
  var displayNum=s.num; if(s.hall) displayNum=s.hall+(displayNum||'');
  var html='<div class="sinfo">'
    +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px">'
      +'<div class="snum">&#128205; '+displayNum+'</div>'
      +'<button onclick="openStandEdit()" style="background:var(--white);border:1px solid var(--bd);border-radius:4px;color:var(--mu);padding:2px 6px;cursor:pointer;font-size:9px;font-family:inherit">&#9999; Editer</button>'
    +'</div>'
    +'<div class="prow"><span class="plbl">Collectif</span><span class="pval" style="color:'+c.stroke+'">'+rtype.name+'</span></div>'
    +'<div class="prow"><span class="plbl">Hall</span><span class="pval">'+(s.hall||'&mdash;')+'</span></div>'
    +'<div class="prow"><span class="plbl">Surface</span><span class="pval">'+s.sm+' m&sup2;</span></div>'
    +'<div class="prow"><span class="plbl">Dim.</span><span class="pval">'+s.wm+'x'+s.hm+'m</span></div>'
    +'</div>';

    // Exposant assigne avec statut
  if(expo){
    var opts=Object.keys(ASSIGN_STATUS).map(function(k){
      var st2=ASSIGN_STATUS[k];
      return '<option value="'+k+'"'+(k===status?' selected':'')+'>'+st2.label+'</option>';
    }).join('');
    html+='<div style="font-size:10px;color:var(--mu);margin-bottom:5px">Exposant</div>'
      +'<div class="ecard asgn" style="cursor:default"><div class="ename">'+expo.name+'</div><div class="emeta">'+displayNum+'</div>'
        +getExpoTagHtml(expo)
        +'<select id="stand-status-sel" class="status-select" style="margin-top:6px">'+opts+'</select>'
        +'<button id="btn-unassign" class="ubtn">Desassigner</button>'
      +'</div>';
  } else {
    html+='<div style="font-size:10px;color:var(--mu2);margin-bottom:4px">Non assigne</div>'
      +'<div style="font-size:10px;color:var(--mu2)">Selectionnez un exposant ci-dessous</div>';
  }
  document.getElementById('vc-detail').innerHTML=html;
  // Listeners post-rendu pour eviter inline onchange avec quotes imbriquees
  var editBtn=document.getElementById('btn-stand-edit');
  if(editBtn) editBtn.addEventListener('click', openStandEdit);
  var statusSel=document.getElementById('stand-status-sel');
  if(statusSel){ var _sid=s.id; statusSel.addEventListener('change', function(){ vcSetStatus(_sid, this.value); }); }
  var unassignBtn=document.getElementById('btn-unassign');
  if(unassignBtn){ var _sid2=s.id; unassignBtn.addEventListener('click', function(){ vcUnassign(_sid2); }); }
}
function renderProps(obj){
  // Propriétés panel was removed — this function is now a no-op
}

// ── Liste des exposants avec statut d'assignement
function renderExp(){
  var q=(document.getElementById('vc-search').value||'').toLowerCase();
  // Construire un map rapide expoId → liste d'assignements (un expo peut être sur plusieurs stands)
  // Ne montrer "assigné" que si le stand existe réellement sur le canvas
  var assignMap={};
  Object.keys(vcAssigns).forEach(function(k){
    var a=vcAssigns[k];
    if(a&&a.expo){
      var so=vcLayers.stands.find(function(o){return o.sData&&o.sData.id===k;});
      if(!so) return;
      if(!assignMap[a.expo.id]) assignMap[a.expo.id]=[];
      var sl=so.sData.num||so.sData.id; if(so.sData.hall) sl=so.sData.hall+(sl||'');
      assignMap[a.expo.id].push({entry:a, standLabel: sl});
    }
  });
  var el=document.getElementById('vc-explist');
  el.innerHTML=EXPOS.filter(function(e){
    return e.name.toLowerCase().indexOf(q)>=0;
  }).map(function(e){
    var infos=assignMap[e.id]||null;
    var isA=!!infos;
    var badge='';
    if(isA){
      // Afficher les badges pour chaque assignement
      badge=infos.map(function(info){
        var st=ASSIGN_STATUS[info.entry.status]||ASSIGN_STATUS.free;
        return '<span class="stbadge '+st.cls+'" style="margin-top:3px">'+info.standLabel+'</span>';
      }).join(' ');
    }
    var meta = (e.hall||'') + (e.stand||'') || e.country;
    if(isA){
      var labels=infos.map(function(i){return i.standLabel;});
      meta=( labels.length>1?'s':'' )+' '+labels.join(', ');
    }
    return '<div class="ecard '+(isA?'asgn':'')+'" onclick="clickExp('+e.id+')">'
      +'<div class="ename">'+e.name+'</div>'
      +'<div class="emeta">'+meta+'</div>'
      +getExpoTagHtml(e)
      +'</div>';
  }).join('');
}

function clickExp(id){
  var expo=null; for(var i=0;i<EXPOS.length;i++){if(EXPOS[i].id===id){expo=EXPOS[i];break;}}
  if(!expo) return;

  // Si un stand est sélectionné → assigner l'exposant (même s'il est déjà assigné ailleurs)
  // Un exposant peut être assigné à plusieurs stands
  if(vcSelStand){
    // Vérifier que cet exposant n'est pas déjà assigné à CE stand précis
    var alreadyOnThis=vcAssigns[vcSelStand.sData.id]&&vcAssigns[vcSelStand.sData.id].expo&&vcAssigns[vcSelStand.sData.id].expo.id===id;
    if(!alreadyOnThis){
      var grp=vcGetStandGroup(vcSelStand.sData.id);
      if(grp && !_vcIsolatedStand){
        vcLayers.stands.forEach(function(o){
          if(o.sData && grp.standIds.indexOf(o.sData.id)>=0) vcAssign(o,expo);
        });
      } else {
        vcAssign(vcSelStand,expo);
      }
    }
    return;
  }

  // Pas de stand sélectionné → naviguer vers un stand assigné à cet exposant
  var assignedStands=[];
  for(var k in vcAssigns){
    if(vcAssigns[k]&&vcAssigns[k].expo&&vcAssigns[k].expo.id===id){
      for(var j=0;j<vcLayers.stands.length;j++){
        if(vcLayers.stands[j].sData&&vcLayers.stands[j].sData.id===k){
          assignedStands.push(vcLayers.stands[j]);
        }
      }
    }
  }
  if(assignedStands.length>0){
    // Sélectionner le premier stand assigné et show exhibitor info
    var target=assignedStands[0];
    // Preserve viewport transform to prevent screen jump
    var savedVT=vc.viewportTransform.slice();
    vc.setActiveObject(target);
    vc.setViewportTransform(savedVT);
    vcSelStand=target;
    renderDetail(target);

    renderProps(target);
    // Show exhibitor info in detail panel
    var exInfo='<div style="margin-top:8px;padding:8px;background:rgba(31,78,156,.05);border:1px solid rgba(31,78,156,.15);border-radius:5px">'
      +'<div style="font-size:10px;color:var(--mu);margin-bottom:4px">Informations exposant</div>'
      +'<div class="prow"><span class="plbl">Société</span><span class="pval">'+expo.name+'</span></div>'
      +(expo.country?'<div class="prow"><span class="plbl">Pays</span><span class="pval">'+expo.country+'</span></div>':'')
      +(expo.hall?'<div class="prow"><span class="plbl">Hall</span><span class="pval">'+expo.hall+'</span></div>':'')
      +(expo.stand?'<div class="prow"><span class="plbl">Stand</span><span class="pval">'+expo.stand+'</span></div>':'')
      +'<div class="prow"><span class="plbl">Type</span><span class="pval">'+getExpoTagHtml(expo)+'</span></div>'
      +'</div>';
    document.getElementById('vc-detail').insertAdjacentHTML('beforeend', exInfo);
    vc.requestRenderAll();
    return;
  }

  // Chercher un stand dont le label correspond au nom de l'exposant
  var exName=expo.name.toLowerCase();
  for(var j=0;j<vcLayers.stands.length;j++){
    var so=vcLayers.stands[j];
    if(!so.sData) continue;
    var items=so.getObjects ? so.getObjects() : [];
    var label1=(items[1]&&items[1].text||'').toLowerCase();
    var label2=(items[2]&&items[2].text||'').toLowerCase();
    var sNum=(so.sData.num||'').toLowerCase();
    if(label1===exName || label2===exName || sNum===exName){
      vc.setActiveObject(so);
      vcSelStand=so;
      renderDetail(so);
  
      renderProps(so);
      renderExp();
      vc.requestRenderAll();
      return;
    }
  }
}
// ── Assigne un exposant à un stand avec statut initial "En attente"
// ── Met à jour le label principal affiché sur le stand (ligne du haut du groupe)
function vcUpdateStandLabel(obj, mainLabel, expoName){
  var items=obj.getObjects();
  // items[0]=rect, items[1]=num label, items[2]=expo name, items[3]=dimensions
  if(items[1]) items[1].set('text', mainLabel);
  if(items[2]) items[2].set('text', expoName || '');
  // Reposition labels to avoid overlap
  var r=items[0];
  if(r) _layoutStandLabels(items[1],items.length>=4?items[2]:null,items[items.length-1],r.width,r.height);
  obj.dirty=true;
  vc.requestRenderAll();
}

function vcAssign(o,e){
  var prev=vcAssigns[o.sData.id];
  var s=o.sData;
  // Sauvegarder le numéro original avant la première assignation
  if(!s._origNum) s._origNum = s.num;
  vcAssigns[s.id]={expo:e, status: prev?prev.status:'free'};
  // Mettre à jour le numéro de stand et le hall depuis les données de l'exposant (séparément)
  if(e.stand) s.num = e.stand;
  if(e.hall) s.hall = e.hall;
  // Label affiché sur le canvas : hall + numéro combinés (ex: "2H10")
  var canvasLabel = s.num;
  if(s.hall) canvasLabel = s.hall + (canvasLabel || '');
  vcUpdateStandLabel(o, canvasLabel, e.name);
  renderDetail(o); renderExp(); updateVcStatus();
  if(_dirtyNotify) _dirtyNotify(true);
}

// ── Change le statut d'assignement d'un stand (Free / Locked)
function vcSetStatus(sid, status){
  if(vcAssigns[sid]) vcAssigns[sid].status=status;
  // Lock/unlock stand movement on canvas
  var obj=vcLayers.stands.find(function(o){return o.sData&&o.sData.id===sid;});
  if(obj){
    var isLocked=status==='locked';
    obj.set({lockMovementX:isLocked, lockMovementY:isLocked});
    obj.setCoords();
  }
  if(vcSelStand&&vcSelStand.sData.id===sid) renderDetail(vcSelStand);
  renderExp();
  if(_dirtyNotify) _dirtyNotify(true);
}

function vcUnassign(sid){
  // Retrouver le stand pour restaurer son numéro original
  var obj=vcLayers.stands.find(function(o){return o.sData&&o.sData.id===sid;});
  delete vcAssigns[sid];
  if(obj){
    var s=obj.sData;
    if(s._origNum){ s.num=s._origNum; s.hall=''; }
    vcUpdateStandLabel(obj, s.num, s.wm+'×'+s.hm+'m');
  }
  if(vcSelStand&&vcSelStand.sData.id===sid) renderDetail(vcSelStand);
  renderExp(); updateVcStatus();
  if(_dirtyNotify) _dirtyNotify(true);
}
function updateVcStatus(){
  document.getElementById('st-stands').textContent=vcLayers.stands.filter(function(o){return !!o.sData;}).length;
  document.getElementById('st-asgn').textContent=Object.keys(vcAssigns).length;
}

function loadDemoToVc(){
  var tt=new fabric.Text('HALL 11 — ProWein',{
    left:mToPx(hallW/2),top:mToPx(1),originX:'center',originY:'top',
    fontSize:Math.max(9,mToPx(1.8)),fill:'#1a1a1a',
    fontFamily:'system-ui',fontWeight:'bold',selectable:false,evented:false,_layer:'annot'
  });
  vcLayers.annot.push(tt); vc.add(tt);
  var al=new fabric.Rect({left:0,top:mToPx(hallH*.45),width:mToPx(hallW),height:mToPx(hallH*.1),
    fill:'rgba(0,0,0,.04)',stroke:'#aaaaaa',strokeWidth:1,strokeDashArray:[6,3],
    selectable:true,evented:true,_layer:'aisles'});
  vcLayers.aisles.push(al); vc.add(al);
  getDemoStands().forEach(function(d){ mkStand(mToPx(d.x),mToPx(d.y),mToPx(d.w),mToPx(d.h),d.n,d.t); });
  setTimeout(function(){
    var ss=vcLayers.stands.filter(function(o){return !!o.sData;});
    if(ss[0]) vcAssign(ss[0],EXPOS[0]);
    if(ss[2]) vcAssign(ss[2],EXPOS[2]);
    if(ss[4]) vcAssign(ss[4],EXPOS[3]);
    updateVcStatus();
  },80);
}

// ═══════════════════════════════════════
// SYNC BIDIRECTIONNEL
// ═══════════════════════════════════════
function syncPxToVc(){
  // Save zoom and viewport center (in meters) before conversion
  var _savedZoomPct = pxZoomPct();
  var _pxArea=document.getElementById('px-area');
  var _cp=cellPx(), _pxPadX=Math.round((_pxArea.clientWidth||600)/2), _pxPadY=Math.round((_pxArea.clientHeight||400)/2);
  var _savedCenterM = {
    x: (_pxArea.scrollLeft - _pxPadX + (_pxArea.clientWidth||600)/2) / _cp * cellM,
    y: (_pxArea.scrollTop  - _pxPadY + (_pxArea.clientHeight||400)/2) / _cp * cellM
  };
  // 1. Afficher le pane vectoriel
  document.getElementById('pane-px').style.display='none';
  document.getElementById('pane-vc').style.display='flex';
  document.getElementById('tab-px').classList.remove('on');
  document.getElementById('tab-vc').classList.add('on');
  document.getElementById('st-mode').textContent='Vectoriel';
  activeTab='vc';

  // 2. Forcer le reflow navigateur pour que clientWidth soit à jour
  void document.getElementById('vc-area').offsetHeight; // force reflow

  // 2b. Lazy-init vector canvas (needs visible pane for correct dimensions)
  if(!ensureVc()) return;

  try {
  // 3. Calibrer le canvas Fabric avec les vraies dimensions
  var area=document.getElementById('vc-area');
  var W=Math.max(600, area.clientWidth-20);
  var H=Math.max(400, area.clientHeight-20);
  vc.setWidth(W); vc.setHeight(H); vc.calcOffset();
  pxPerM=Math.min(W/hallW, H/hallH);
  document.getElementById('vc-mpx').textContent=pxPerM.toFixed(2);
  rebuildHallBorder();
  vcInited=true;

  // 4. Sauvegarder les assignements et métadonnées avant de reconstruire
  var _assignBackup=[];
  vcLayers.stands.forEach(function(obj){
    if(!obj.sData) return;
    var assign=vcAssigns[obj.sData.id];
    _assignBackup.push({
      x:Math.round(obj.left), y:Math.round(obj.top),
      w:Math.round(obj.width*(obj.scaleX||1)), h:Math.round(obj.height*(obj.scaleY||1)),
      type:obj.sData.type,
      num:obj.sData.num, hall:obj.sData.hall, _origNum:obj.sData._origNum,
      assign:assign?JSON.parse(JSON.stringify(assign)):null,
      oldId:obj.sData.id
    });
  });

  // 4b. Supprimer anciens stands/allées
  vcLayers.stands.concat(vcLayers.aisles).forEach(function(o){vc.remove(o);});
  vcLayers.stands=[]; vcLayers.aisles=[]; vcStandN=0;

  // 5. Créer les nouveaux objets — pxPerM est maintenant correct
  // Inclure TOUTES les couleurs de la palette + RTYPES
  var standCols={};
  RTYPES.forEach(function(r){ standCols[r.color]=1; });
  PALETTE.forEach(function(c){ standCols[c]=1; });
  // Include group colors so detectRegions finds those regions
  vcGroups.forEach(function(g){
    if(g.color) standCols[g.color]=1;
  });
  // Aussi inclure toutes les couleurs effectivement présentes dans la grille
  for(var _r=0;_r<numRows();_r++) for(var _c=0;_c<numCols();_c++){
    var _cl=grid[_r]&&grid[_r][_c];
    if(_cl && !standCols[_cl]) standCols[_cl]=1;
  }
  var allCols=Object.assign({}, standCols, {'#94a3b8':1});
  // Reset standIds for groups that have pxCells (will be rebuilt from detectRegions)
  // VC-only groups keep their standIds for position-based remapping later
  vcGroups.forEach(function(g){ if(g.pxCells) g.standIds=[]; });
  var sc=0;
  detectRegions(allCols, false).forEach(function(rg){
    var rx=mToPx(rg.c1*cellM), ry=mToPx(rg.r1*cellM);
    var rw=mToPx((rg.c2-rg.c1+1)*cellM), rh=mToPx((rg.r2-rg.r1+1)*cellM);
    if(rg.color!=='#94a3b8'){
      // Check if this region belongs to a group (by pxCells position overlap)
      var regionGrp=null, regionOrigColor=null;
      for(var gi=0;gi<vcGroups.length;gi++){
        var g=vcGroups[gi];
        if(!g.pxCells) continue;
        var match=g.pxCells.find(function(px){
          return px.r>=rg.r1 && px.r<=rg.r2 && px.c>=rg.c1 && px.c<=rg.c2;
        });
        if(match){
          regionGrp=g;
          regionOrigColor=match.originalColor;
          break;
        }
      }
      var type = colorToType(regionOrigColor || rg.color);

      // Vérifier si la région est rectangulaire
      var _bboxCells=(rg.r2-rg.r1+1)*(rg.c2-rg.c1+1);
      var _isRect=(rg.cells.length>=_bboxCells);

      if(_isRect){
        // Forme rectangulaire → un seul stand
        sc++;
        var stand = mkStand(rx,ry,rw,rh,'P-'+String(sc).padStart(2,'0'), type);
        if(regionGrp && stand && stand.sData){
          if(regionGrp.standIds.indexOf(stand.sData.id)===-1) regionGrp.standIds.push(stand.sData.id);
        }
      } else {
        // Forme non-rectangulaire → décomposer en sous-rectangles
        var _subRects=_decomposeRegionToRects(rg);
        var _subIds=[];
        _subRects.forEach(function(sr){
          sc++;
          var _sx=mToPx(sr.c1*cellM), _sy=mToPx(sr.r1*cellM);
          var _sw=mToPx((sr.c2-sr.c1+1)*cellM), _sh=mToPx((sr.r2-sr.r1+1)*cellM);
          var stand=mkStand(_sx,_sy,_sw,_sh,'P-'+String(sc).padStart(2,'0'), type);
          if(stand && stand.sData) _subIds.push(stand.sData.id);
          if(regionGrp && stand && stand.sData){
            if(regionGrp.standIds.indexOf(stand.sData.id)===-1) regionGrp.standIds.push(stand.sData.id);
          }
        });
        // Grouper les sous-rectangles automatiquement si pas déjà dans un groupe
        if(!regionGrp && _subIds.length>1){
          var _autoGrp={id:'grp_'+Date.now()+'_'+sc, name:'Auto P-'+sc, standIds:_subIds,
            isPxGroup:false, pxCells:null, color:null};
          vcGroups.push(_autoGrp);
        }
      }
    } else {
      var al=new fabric.Rect({left:rx,top:ry,width:rw,height:rh,
        fill:'rgba(0,0,0,.04)',stroke:'#aaaaaa',strokeWidth:1,
        strokeDashArray:[6,3],selectable:true,evented:true,_layer:'aisles'});
      vcLayers.aisles.push(al); vc.add(al);
    }
  });

  // 6. Restaurer les assignements — matching multi-critères
  var _newAssigns={};
  var _usedNewIds={};
  function _applyMatch(old, best){
    _usedNewIds[best.sData.id]=true;
    if(old.num) best.sData.num=old.num;
    if(old.hall) best.sData.hall=old.hall;
    if(old._origNum) best.sData._origNum=old._origNum;
    if(old.assign){
      _newAssigns[best.sData.id]=old.assign;
      var lbl=best.sData.num;
      if(best.sData.hall) lbl=best.sData.hall+(lbl||'');
      vcUpdateStandLabel(best, lbl, old.assign.expo.name);
    } else {
      var items=best.getObjects();
      if(items[1]&&old.num) items[1].set('text',old.num);
    }
  }
  // Pass 1 : correspondance exacte par position (stand non déplacé)
  _assignBackup.forEach(function(old){
    if(old._matched||(!old.assign&&!old.num&&!old.hall)) return;
    var best=null, bestDist=Infinity;
    vcLayers.stands.forEach(function(s){
      if(!s.sData||_usedNewIds[s.sData.id]) return;
      var dist=Math.abs(s.left-old.x)+Math.abs(s.top-old.y);
      if(dist<bestDist){ bestDist=dist; best=s; }
    });
    if(best&&bestDist<5*pxPerM){ old._matched=true; _applyMatch(old,best); }
  });
  // Pass 2 : correspondance par type + taille similaire (stand déplacé)
  _assignBackup.forEach(function(old){
    if(old._matched||(!old.assign&&!old.num&&!old.hall)) return;
    var best=null, bestScore=Infinity;
    vcLayers.stands.forEach(function(s){
      if(!s.sData||_usedNewIds[s.sData.id]) return;
      if(s.sData.type!==old.type) return; // même type obligatoire
      var sw=Math.round(s.width*(s.scaleX||1)), sh=Math.round(s.height*(s.scaleY||1));
      var dw=Math.abs(sw-old.w), dh=Math.abs(sh-old.h);
      var score=dw+dh; // différence de taille
      if(score<bestScore){ bestScore=score; best=s; }
    });
    if(best&&bestScore<20*pxPerM){ old._matched=true; _applyMatch(old,best); }
  });
  // Pass 3 : correspondance par type seul (dernier recours — forme changée)
  _assignBackup.forEach(function(old){
    if(old._matched||!old.assign) return;
    var best=null;
    vcLayers.stands.forEach(function(s){
      if(!s.sData||_usedNewIds[s.sData.id]) return;
      if(s.sData.type===old.type){ best=s; }
    });
    if(best){ old._matched=true; _applyMatch(old,best); }
  });
  vcAssigns=_newAssigns;

  // 6b. Convert groups for vector mode
  // Build old standId → position map from _assignBackup
  var _oldStandPos={};
  _assignBackup.forEach(function(b){ _oldStandPos[b.oldId]={x:b.x,y:b.y,w:b.w,h:b.h}; });
  vcGroups.forEach(function(g){
    if(!g.isPxGroup && g.standIds.length>0){
      // Remap old VC group standIds → new stand IDs by position matching
      var newIds=[];
      g.standIds.forEach(function(oldId){
        var oldPos=_oldStandPos[oldId];
        if(!oldPos) return;
        var best=null, bestDist=Infinity;
        vcLayers.stands.forEach(function(s){
          if(!s.sData || newIds.indexOf(s.sData.id)>=0) return;
          var dist=Math.abs(s.left-oldPos.x)+Math.abs(s.top-oldPos.y);
          if(dist<bestDist){ bestDist=dist; best=s; }
        });
        if(best && bestDist<5*pxPerM) newIds.push(best.sData.id);
      });
      g.standIds=newIds;
    }
    // All groups become VC groups in vector mode
    g.isPxGroup=false;
  });
  // Remove groups that lost all stands during conversion
  vcGroups=vcGroups.filter(function(g){ return g.standIds.length>0; });

  // 7. Restore zoom and viewport position from before conversion
  var _pzEl=document.getElementById('px-zpct'); if(_pzEl) _pzEl.textContent=pxZoomPct()+'%';
  vcZ=Math.max(0.05,Math.min(20,_savedZoomPct/100));
  var _areaEl=document.getElementById('vc-area');
  var _aw=_areaEl.clientWidth||600, _ah=_areaEl.clientHeight||400;
  // Center on the same point (in meters) that was visible on pixel side
  var _worldX=_savedCenterM.x*pxPerM, _worldY=_savedCenterM.y*pxPerM;
  vc.setViewportTransform([vcZ,0,0,vcZ, _aw/2-_worldX*vcZ, _ah/2-_worldY*vcZ]);
  updateZpct(); drawVcRulers(); updateSBar();
  setVcTool(vcTool);
  vcStripOverlays(); // remove stale group borders/labels before rebuild
  vcGroups.forEach(function(g){ vcApplyGroupColor(g); });
  rebuildGroupOverlays();
  vc.renderAll(); updateVcStatus(); flash();
  } catch(e){ console.error('[FloorMapEngine] syncPxToVc error:', e); }
}

// ── Silent Vec→Pixel data sync (for autosave) ─────────────────────────
// Recomputes grid, sepH, sepV from vector objects WITHOUT switching tabs
// or touching the UI.  Uses calcTransformMatrix() so it works even when
// objects are inside an ActiveSelection (no need to discard selection).
function _doVcToPxData(){
  if(!vc) return;

  // Reset pixel grid and separators
  grid=makeEmptyGrid(); var _s=makeEmptySep(); sepH=_s.h; sepV=_s.v;

  // Position helper — calcTransformMatrix is reliable in all cases
  function _absPos(o){
    var m=o.calcTransformMatrix();
    var w=(o.width||0)*(o.scaleX||1), h=(o.height||0)*(o.scaleY||1);
    return {x:m[4]-w/2, y:m[5]-h/2};
  }
  function _objToM(o){
    var w=(o.width||0)*(o.scaleX||1), h=(o.height||0)*(o.scaleY||1);
    var pos=_absPos(o);
    return {xM:pxToM(pos.x), yM:pxToM(pos.y), wM:pxToM(w), hM:pxToM(h)};
  }

  // Allées : peindre uniquement le bord (périmètre)
  vcLayers.aisles.forEach(function(o){
    var rm=_objToM(o);
    var c1=Math.max(0,Math.round(rm.xM/cellM)), r1=Math.max(0,Math.round(rm.yM/cellM));
    var c2=Math.min(numCols()-1,Math.round((rm.xM+rm.wM)/cellM)-1);
    var r2=Math.min(numRows()-1,Math.round((rm.yM+rm.hM)/cellM)-1);
    for(var c=c1;c<=c2;c++){ setCell(r1,c,'#94a3b8'); setCell(r2,c,'#94a3b8'); }
    for(var r=r1;r<=r2;r++){ setCell(r,c1,'#94a3b8'); setCell(r,c2,'#94a3b8'); }
  });

  // Map standId → couleur de groupe
  var standGroupColor={};
  vcGroups.forEach(function(g){
    if(!g.isPxGroup && g.color){
      g.standIds.forEach(function(sid){ standGroupColor[sid]=g.color; });
    }
  });

  // Stands — paint and record full rectangles for overlap-aware pickup
  pxStandRects=[];
  vcLayers.stands.forEach(function(o){
    if(!o.sData) return;
    var r=_objToM(o);
    var clr = standGroupColor[o.sData.id] || typeToColor(o.sData.type);
    paintM(r.xM, r.yM, r.wM, r.hM, clr);
    // Store full rect for overlap-aware pickup
    var sc1=Math.max(0,Math.round(r.xM/cellM)), sr1=Math.max(0,Math.round(r.yM/cellM));
    var sc2=Math.min(numCols()-1,Math.round((r.xM+r.wM)/cellM)-1);
    var sr2=Math.min(numRows()-1,Math.round((r.yM+r.hM)/cellM)-1);
    pxStandRects.push({id:o.sData.id, r1:sr1, c1:sc1, r2:sr2, c2:sc2, color:clr});
  });

  // Sync group px cells
  vcGroups.forEach(function(g){
    if(!g.isPxGroup && g.color) grpSyncColorToPx(g);
  });

  // ── Séparateurs : périmètre de chaque stand ──
  pxStandRects.forEach(function(sr){
    for(var c=sr.c1;c<=sr.c2;c++){
      if(!sepH[sr.r1]) sepH[sr.r1]=[]; sepH[sr.r1][c]=true;
      var br=sr.r2+1;
      if(br<=numRows()){ if(!sepH[br]) sepH[br]=[]; sepH[br][c]=true; }
    }
    for(var r=sr.r1;r<=sr.r2;r++){
      if(!sepV[r]) sepV[r]=[]; sepV[r][sr.c1]=true;
      var bc=sr.c2+1;
      if(bc<=numCols()){ if(!sepV[r]) sepV[r]=[]; sepV[r][bc]=true; }
    }
  });
  // Séparateurs sur le périmètre extérieur de chaque allée
  vcLayers.aisles.forEach(function(o){
    var r=_objToM(o);
    var ac1=Math.max(0,Math.round(r.xM/cellM)), ar1=Math.max(0,Math.round(r.yM/cellM));
    var ac2=Math.min(numCols()-1,Math.round((r.xM+r.wM)/cellM)-1);
    var ar2=Math.min(numRows()-1,Math.round((r.yM+r.hM)/cellM)-1);
    for(var c=ac1;c<=ac2;c++){ if(!sepH[ar1]) sepH[ar1]=[]; sepH[ar1][c]=true; }
    if(ar2+1<=numRows()){ for(var c=ac1;c<=ac2;c++){ if(!sepH[ar2+1]) sepH[ar2+1]=[]; sepH[ar2+1][c]=true; } }
    for(var rr=ar1;rr<=ar2;rr++){ if(!sepV[rr]) sepV[rr]=[]; sepV[rr][ac1]=true; }
    for(var rr=ar1;rr<=ar2;rr++){ if(!sepV[rr]) sepV[rr]=[]; sepV[rr][ac2+1]=true; }
  });
}

function syncVcToPx(){
  if(!vc){ console.error('[FloorMapEngine] syncVcToPx: vector canvas not initialized'); return; }
  // Save vector zoom and viewport center (in meters) before conversion
  var _savedVcZoomPct = Math.round(vcZ*100);
  var _vcArea=document.getElementById('vc-area');
  var _vt=vc.viewportTransform;
  var _savedCenterM = {
    x: ((_vcArea.clientWidth||600)/2 - _vt[4]) / _vt[0] / pxPerM,
    y: ((_vcArea.clientHeight||400)/2 - _vt[5]) / _vt[3] / pxPerM
  };
  document.getElementById('pane-vc').style.display='none';
  document.getElementById('pane-px').style.display='flex';
  document.getElementById('tab-vc').classList.remove('on');
  document.getElementById('tab-px').classList.add('on');
  document.getElementById('st-mode').textContent='Pixel Art';
  activeTab='px';

  // Désélectionner pour coordonnées absolues propres
  vc.discardActiveObject();
  vc.requestRenderAll();

  // Core data computation (shared with autosave)
  _doVcToPxData();

  // Convert VC groups to PX groups — build pxCells from stand bboxes on the grid
  // Also recompute pxCells for already-converted groups (positions may be stale)
  vcGroups.forEach(function(g){
    if(!g.standIds || g.standIds.length===0) return; // pure PX group without standIds — skip
    g.isPxGroup=true; // mark for conversion (needed for fresh VC groups)
  });
  _recomputeConvertedGroupPxCells();
  vcGroups=vcGroups.filter(function(g){
    if(g.isPxGroup) return g.pxCells && g.pxCells.length>0;
    return g.standIds.length>0;
  });

  // Restore zoom and position from vector side
  setPxZoomPct(_savedVcZoomPct);
  // Center on the same point (in meters) that was visible on vector side
  var _pxAreaR=document.getElementById('px-area');
  var _cpR=cellPx();
  var _pxPadXR=Math.round((_pxAreaR.clientWidth||600)/2), _pxPadYR=Math.round((_pxAreaR.clientHeight||400)/2);
  _pxAreaR.scrollLeft = _pxPadXR + (_savedCenterM.x/cellM)*_cpR - (_pxAreaR.clientWidth||600)/2;
  _pxAreaR.scrollTop  = _pxPadYR + (_savedCenterM.y/cellM)*_cpR - (_pxAreaR.clientHeight||400)/2;
  // UI refresh + pixel history
  drawPx(); savePxH(); drawPxPreview(); updatePxStats(); renderPxLegend(); updateRtypeCounts();
  drawPxRulers();
  renderGroupsList();
  modLayerSaveCurrent();
  flash();
}

function paintM(xM,yM,wM,hM,color){
  var c1=Math.max(0,Math.round(xM/cellM)), r1=Math.max(0,Math.round(yM/cellM));
  var c2=Math.min(numCols()-1,Math.round((xM+wM)/cellM)-1);
  var r2=Math.min(numRows()-1,Math.round((yM+hM)/cellM)-1);
  for(var r=r1;r<=r2;r++) for(var c=c1;c<=c2;c++) setCell(r,c,color);
}

// Décompose une région non-rectangulaire en sous-rectangles maximaux.
// Algorithme : scan par ligne → runs horizontaux → fusion verticale.
function _decomposeRegionToRects(rg){
  // Construire un set de cellules occupées
  var occ={};
  rg.cells.forEach(function(cell){ occ[cell[0]+','+cell[1]]=true; });
  // Phase 1 : pour chaque ligne, trouver les runs horizontaux contigus
  var runs=[]; // {r1, c1, c2, r2} (r2 sera étendu en phase 2)
  for(var r=rg.r1; r<=rg.r2; r++){
    var c=rg.c1;
    while(c<=rg.c2){
      if(!occ[r+','+c]){ c++; continue; }
      var cStart=c;
      while(c<=rg.c2 && occ[r+','+c]) c++;
      runs.push({r1:r, r2:r, c1:cStart, c2:c-1});
    }
  }
  // Phase 2 : fusionner verticalement les runs adjacents identiques (même c1, c2)
  var merged=[];
  for(var i=0; i<runs.length; i++){
    var cur=runs[i];
    // Chercher dans merged un rect qui se termine à r2=cur.r1-1 avec même c1,c2
    var found=false;
    for(var j=merged.length-1; j>=0; j--){
      if(merged[j].c1===cur.c1 && merged[j].c2===cur.c2 && merged[j].r2===cur.r1-1){
        merged[j].r2=cur.r1; // étendre d'une ligne
        found=true; break;
      }
    }
    if(!found) merged.push({r1:cur.r1, r2:cur.r2, c1:cur.c1, c2:cur.c2});
  }
  return merged;
}

function detectRegions(colorSet, ignoreSeps){
  // Flood-fill identique à floodFill(), bloqué par sepH/sepV.
  // Chaque zone connexe séparée par un séparateur = 1 région indépendante.
  // ignoreSeps=true : ignorer les séparateurs entre cellules de même couleur
  //   (utilisé par syncPxToVc pour fusionner les régions adjacentes de même couleur
  //    et supporter les formes non-rectangulaires L/T/U)
  var R=numRows(), C=numCols();
  var vis=[];
  for(var r=0;r<R;r++){vis.push([]); for(var c=0;c<C;c++) vis[r].push(false);}
  var res=[];
  for(var sr=0;sr<R;sr++) for(var sc=0;sc<C;sc++){
    if(vis[sr][sc]) continue;
    var col=(grid[sr]&&grid[sr][sc])||null;
    if(!col||!colorSet[col]) continue;
    // BFS depuis (sr,sc)
    var queue=[[sr,sc]], r1=sr,r2=sr,c1=sc,c2=sc;
    vis[sr][sc]=true;
    var qi=0;
    while(qi<queue.length){
      var cur=queue[qi++], r=cur[0], c=cur[1];
      if(r<r1)r1=r; if(r>r2)r2=r; if(c<c1)c1=c; if(c>c2)c2=c;
      // Droite : bloqué par sepV[r][c+1] (sauf si ignoreSeps et même couleur)
      if(c+1<C && !vis[r][c+1] && (grid[r][c+1]||null)===col && (ignoreSeps || !(sepV[r]&&sepV[r][c+1]))){
        vis[r][c+1]=true; queue.push([r,c+1]);
      }
      // Gauche : bloqué par sepV[r][c]
      if(c-1>=0 && !vis[r][c-1] && (grid[r][c-1]||null)===col && (ignoreSeps || !(sepV[r]&&sepV[r][c]))){
        vis[r][c-1]=true; queue.push([r,c-1]);
      }
      // Bas : bloqué par sepH[r+1][c]
      if(r+1<R && !vis[r+1][c] && (grid[r+1][c]||null)===col && (ignoreSeps || !(sepH[r+1]&&sepH[r+1][c]))){
        vis[r+1][c]=true; queue.push([r+1,c]);
      }
      // Haut : bloqué par sepH[r][c]
      if(r-1>=0 && !vis[r-1][c] && (grid[r-1][c]||null)===col && (ignoreSeps || !(sepH[r]&&sepH[r][c]))){
        vis[r-1][c]=true; queue.push([r-1,c]);
      }
    }
    if(queue.length>=2) res.push({color:col,r1:r1,r2:r2,c1:c1,c2:c2,cells:queue});
  }
  return res;
}

// ═══════════════════════════════════════
// GLOBAL
// ═══════════════════════════════════════
var activeTab='px';

function switchTab(t){
  if(activeTab===t) return;
  // ── Capture current view as {centerM:{x,y}, spmm: screen-px-per-meter} ──
  var _syncView=null;
  if(activeTab==='px' && t==='vc'){
    // Pixel → Vector: read scroll center in meters
    var _pa=document.getElementById('px-area');
    if(_pa){
      var _cp=cellPx(), _vw=_pa.clientWidth||1, _vh=_pa.clientHeight||1;
      var _cx=(_pa.scrollLeft-pxPadX+_vw/2)/_cp*cellM;
      var _cy=(_pa.scrollTop -pxPadY+_vh/2)/_cp*cellM;
      _syncView={centerM:{x:_cx,y:_cy}, spmm:_cp/cellM};
    }
  } else if(activeTab==='vc' && t==='px' && vc && vcInited){
    // Vector → Pixel: read viewport center in meters
    var _va=document.getElementById('vc-area');
    if(_va){
      var _vt=vc.viewportTransform, _vw2=_va.clientWidth||1, _vh2=_va.clientHeight||1;
      var _fcx=(_vw2/2-_vt[4])/_vt[0], _fcy=(_vh2/2-_vt[5])/_vt[3];
      _syncView={centerM:{x:_fcx/pxPerM, y:_fcy/pxPerM}, spmm:_vt[0]*pxPerM};
    }
  }
  activeTab=t;
  document.getElementById('pane-px').style.display=(t==='px')?'flex':'none';
  document.getElementById('pane-vc').style.display=(t==='vc')?'flex':'none';
  document.getElementById('tab-px').classList.toggle('on',t==='px');
  document.getElementById('tab-vc').classList.toggle('on',t==='vc');
  // Toggle status bar sections based on active tab
  var stPxStats=document.getElementById('st-px-stats');
  var stVcInfo=document.getElementById('st-vc-info');
  var stVcAsgn=document.getElementById('st-vc-asgn');
  if(stPxStats) stPxStats.style.display=(t==='px')?'':'none';
  if(stVcInfo)  stVcInfo.style.display=(t==='vc')?'':'none';
  if(stVcAsgn)  stVcAsgn.style.display=(t==='vc')?'':'none';
  document.getElementById('st-mode').textContent=(t==='px')?'Pixel Art':'Vectoriel';
  if(t==='vc'){
    setTimeout(function(){
      if(!ensureVc()) return;
      var area=document.getElementById('vc-area');
      var W=Math.max(400,area.clientWidth-20), H=Math.max(300,area.clientHeight-20);
      if(Math.abs(vc.width-W)>10||Math.abs(vc.height-H)>10||!vcInited){
        vc.setWidth(W); vc.setHeight(H); vc.calcOffset(); recalcPxPerM();
        if(bgImg) bgRedrawVc();
        if(!vcInited){ vcInited=true; fitVc(); } else { vcInited=true; }
      }
      // Apply synced view from pixel side (center + zoom in meters)
      if(_syncView){
        vcZ=_syncView.spmm/pxPerM;
        vcZ=Math.max(0.05,Math.min(20,vcZ));
        var _fcx2=_syncView.centerM.x*pxPerM, _fcy2=_syncView.centerM.y*pxPerM;
        var _vw3=area.clientWidth||1, _vh3=area.clientHeight||1;
        var _tx2=_vw3/2-_fcx2*vcZ, _ty2=_vh3/2-_fcy2*vcZ;
        vc.setViewportTransform([vcZ,0,0,vcZ,_tx2,_ty2]);
        updateZpct();
      }
      vc.calcOffset();
      vc.getObjects().forEach(function(o){ o.setCoords(); });
      vc.requestRenderAll();
      drawVcRulers(); updateSBar();
      renderExp(); updateVcStatus();
      // Seed vector undo history with initial state if empty
      if(vcHistIdx<0) modLayerSaveCurrent();
    },30);
  }
  if(t==='px'){
    // Apply synced view from vector side (center + zoom in meters)
    if(_syncView){
      var _newCp=_syncView.spmm*cellM;
      pxZ=Math.max(0.05,Math.min(10,_newCp/16));
      var _pzEl=document.getElementById('px-zpct'); if(_pzEl) _pzEl.textContent=pxZoomPct()+'%';
    }
    renderPxCanvas();
    if(_syncView){
      var _pa2=document.getElementById('px-area');
      if(_pa2){
        var _cp2=cellPx();
        var _vw4=_pa2.clientWidth||1, _vh4=_pa2.clientHeight||1;
        _pa2.scrollLeft=_syncView.centerM.x/cellM*_cp2+pxPadX-_vw4/2;
        _pa2.scrollTop =_syncView.centerM.y/cellM*_cp2+pxPadY-_vh4/2;
      }
    }
    drawPxPreview(); updatePxStats(); drawPxRulers(); updateRtypeCounts();
  }
}

function doUndo(){ if(activeTab==='px') undoPx(); else if(activeTab==='vc') undoVc(); }

function toggleExportMenu(e){
  if(e) e.stopPropagation();
  var m=document.getElementById('exp-menu');
  m.style.display=m.style.display==='none'?'block':'none';
}
// Fermer le menu si clic en dehors — avec délai pour laisser doExport s'exécuter d'abord
document.addEventListener('click',function(e){
  var w=document.getElementById('exp-wrap');
  if(w&&!w.contains(e.target)){
    setTimeout(function(){ document.getElementById('exp-menu').style.display='none'; },50);
  }
});

function doExport(mode, fmt){
  document.getElementById('exp-menu').style.display='none';
  if(mode==='px'){
    // PNG pixel art uniquement
    var exp=document.createElement('canvas');
    var cp=cellPx(); exp.width=numCols()*cp; exp.height=numRows()*cp;
    var ctx=exp.getContext('2d');
    ctx.fillStyle='#ffffff'; ctx.fillRect(0,0,exp.width,exp.height);
    if(bgImg&&bgVisible){
      ctx.globalAlpha=bgOpacity;
      ctx.drawImage(bgImg,0,0,Math.round((bgRealW/hallW)*exp.width),Math.round((bgRealH/hallH)*exp.height));
      ctx.globalAlpha=1;
    }
    ctx.drawImage(document.getElementById('px-c'),0,0);
    var a=document.createElement('a'); a.href=exp.toDataURL('image/png'); a.download='floormap-pixel.png'; a.click();
    return;
  }
  // Mode vectoriel — exporter uniquement la zone du hall
  var _expW=mToPx(hallW), _expH=mToPx(hallH);
  if(fmt==='png'){
    var a=document.createElement('a');
    a.href=vc.toDataURL({format:'png',multiplier:2,left:0,top:0,width:_expW,height:_expH}); a.download='floormap-vector.png'; a.click();
  } else if(fmt==='svg'){
    var svg=vc.toSVG({viewBox:{x:0,y:0,width:_expW,height:_expH},width:_expW,height:_expH});
    var b64=btoa(unescape(encodeURIComponent(svg)));
    var a=document.createElement('a');
    a.href='data:image/svg+xml;base64,'+b64;
    a.download='floormap-vector.svg';
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
  } else if(fmt==='pdf'){
    var dataUrl=vc.toDataURL({format:'png',multiplier:2,left:0,top:0,width:_expW,height:_expH});
    var w=window.open('','_blank');
    if(!w){ alert('Autorisez les popups pour exporter en PDF.'); return; }
    w.document.write(
      '<html><head><title>FloorMap — Export PDF</title>'
      +'<style>*{margin:0;padding:0;box-sizing:border-box}'
      +'body{background:#000;display:flex;align-items:center;justify-content:center;min-height:100vh}'
      +'img{max-width:100%;max-height:100vh;display:block}'
      +'@media print{body{background:#fff}}'
      +'</style></head>'
      +'<body><img src="'+dataUrl+'">'
      +'<script>window.onload=function(){window.print();}<\/script>'
      +'</body></html>'
    );
    w.document.close();
  }
}

function openM(id){ document.getElementById(id).classList.add('show'); }
function closeM(id){ document.getElementById(id).classList.remove('show'); }

function flash(){
  var p=document.querySelector('.pill');
  p.style.background='rgba(52,211,153,.22)';
  setTimeout(function(){p.style.background='rgba(52,211,153,.06)';},900);
}

document.addEventListener('keydown',function(e){
  // Ignorer les raccourcis quand le focus est sur un champ texte
  var inInput=e.target.matches('input,select,textarea');

  // Ctrl+Z / Cmd+Z : Annuler
  if((e.ctrlKey||e.metaKey)&&e.key==='z'&&!inInput){
    e.preventDefault(); doUndo(); return;
  }

  // Ctrl+A / Cmd+A : Tout selectionner
  if((e.ctrlKey||e.metaKey)&&e.key==='a'&&!inInput){
    e.preventDefault();
    if(activeTab==='px'){
      // Selectionner le bounding box de tous les pixels colores
      var r1=numRows(),r2=-1,c1=numCols(),c2=-1;
      for(var r=0;r<numRows();r++) for(var c=0;c<numCols();c++){
        if(grid[r]&&grid[r][c]){
          if(r<r1)r1=r; if(r>r2)r2=r;
          if(c<c1)c1=c; if(c>c2)c2=c;
        }
      }
      if(r2>=0){
        setPxTool('select');
        pxSel={r1:r1,r2:r2,c1:c1,c2:c2};
        pxSelBuf=null; pxSelDrag=false;
        drawPx(); drawSelOverlay();
      }
    } else if(activeTab==='vc'){
      // Selectionner tous les objets selectionables (stands, allees, murs...)
      setVcTool('select');
      var selectables=vc.getObjects().filter(function(o){
        return o.selectable && !o._hall && !o._bg;
      });
      if(selectables.length===1){
        vc.setActiveObject(selectables[0]);
      } else if(selectables.length>1){
        var sel=new fabric.ActiveSelection(selectables,{canvas:vc});
        vc.setActiveObject(sel);
      }
      vc.requestRenderAll();
      var firstStand=selectables.find(function(o){return !!o.sData;});
      if(firstStand){
        vcSelStand=firstStand; renderDetail(firstStand); renderProps(firstStand);
    
      }
    }
    return;
  }

  // Pixel — Escape et Supprimer
  if(activeTab==='px'&&pxTool==='select'){
    if(e.key==='Escape'){ pxSel=null; pxSelBuf=null; drawPx(); }
    if((e.key==='Delete'||e.key==='Backspace')&&pxSel&&!inInput){
      e.preventDefault(); savePxH();
      for(var r=pxSel.r1;r<=pxSel.r2;r++) for(var c=pxSel.c1;c<=pxSel.c2;c++) setCell(r,c,null);
      pxSel=null; drawPx(); drawPxPreview(); updatePxStats(); renderPxLegend(); updateRtypeCounts();
    }
  }

  // Vectoriel — Supprimer
  if(activeTab==='vc'&&(e.key==='Delete'||e.key==='Backspace')&&!inInput){
    var objs=vc.getActiveObjects();
    if(objs.length){
      e.preventDefault();
      objs.forEach(function(o){
        if(o._hall||o._bg) return;
        if(o.sData){
          delete vcAssigns[o.sData.id];
          vcLayers.stands=vcLayers.stands.filter(function(s){return s!==o;});
          // Retirer du groupe si nécessaire
          var sid=o.sData.id;
          vcGroups.forEach(function(g){ g.standIds=g.standIds.filter(function(id){return id!==sid;}); });
          vcGroups=vcGroups.filter(function(g){return g.standIds.length>0;});
        }
        // Retirer des vcLayers correspondant
        if(o._layer&&vcLayers[o._layer]){
          vcLayers[o._layer]=vcLayers[o._layer].filter(function(x){return x!==o;});
        }
        vc.remove(o);
      });
      rebuildGroupOverlays();
      vc.discardActiveObject(); vc.renderAll(); updateVcStatus(); vcDesel();
      modLayerSaveCurrent();
    }
  }

  // Escape : fermer modals
  if(e.key==='Escape'){
    closeM('m-stand'); closeM('m-text'); closeM('m-bg'); closeM('m-stand-edit');
    if(activeTab==='vc'){ vc.discardActiveObject(); vc.renderAll(); vcDesel(); }
  }
  // Raccourci H = outil Main (les deux modes)
  if(e.key.toLowerCase()==='h'&&!inInput){
    if(activeTab==='px') setPxTool('hand');
    else if(activeTab==='vc') setVcTool('hand');
  }

  // Space = outil Main temporaire (hold)
  if(e.code==='Space'&&!inInput&&!_spaceHandActive){
    e.preventDefault();
    _spaceHandActive=true;
    if(activeTab==='px'){ _spacePrevPxTool=pxTool; setPxTool('hand'); }
    else if(activeTab==='vc'){ _spacePrevVcTool=vcTool; setVcTool('hand'); }
  }

  // Raccourcis outils pixel (P B E I R F S)
  if(activeTab==='px'&&!inInput){
    var k={h:'hand',p:'pencil',b:'bucket',e:'eraser',i:'eyedrop',r:'rect',f:'frect',s:'select'};
    if(k[e.key.toLowerCase()]) setPxTool(k[e.key.toLowerCase()]);
  }
});
var _spaceHandActive=false, _spacePrevPxTool=null, _spacePrevVcTool=null;
document.addEventListener('keyup',function(e){
  if(e.code==='Space'&&_spaceHandActive){
    _spaceHandActive=false;
    if(activeTab==='px'&&_spacePrevPxTool!==null){ setPxTool(_spacePrevPxTool); _spacePrevPxTool=null; }
    if(activeTab==='vc'&&_spacePrevVcTool!==null){ setVcTool(_spacePrevVcTool); _spacePrevVcTool=null; }
  }
});;

  // ── Zoom wrapper functions (access closure vars pxZ/vcZ) ──
  function pxZoomIn(){ setPxZoom(pxZ*1.25); }
  function pxZoomOut(){ setPxZoom(pxZ/1.25); }
  function vcZoomIn(){ setVcZoom(vcZ*1.25); }
  function vcZoomOut(){ setVcZoom(vcZ/1.25); }
  function vcZoomHalf(){ setVcZoom(vcZ*0.5); }
  function vcZoomDouble(){ setVcZoom(vcZ*2); }
  function vcZoomQuad(){ setVcZoom(vcZ*4); }

  // ── Exhibitor picker (opened from the stand context menu) ──
  function openExpoPicker(stand){
    var old=document.getElementById('expo-picker'); if(old) old.remove();
    var esc=function(t){ return String(t==null?'':t).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); };
    var ov=document.createElement('div');
    ov.id='expo-picker';
    ov.style.cssText='position:fixed;inset:0;z-index:3000;background:rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;font-family:\'Marianne\',system-ui,sans-serif;font-size:12px';
    ov.innerHTML='<div style="background:#fff;border-radius:8px;width:360px;max-width:92vw;max-height:70vh;display:flex;flex-direction:column;box-shadow:0 8px 32px rgba(0,0,0,.25)">'
      +'<div style="padding:12px 14px;border-bottom:1px solid #e0e0e0;font-weight:700">Ajouter un exposant au stand '+esc(stand.sData.num||stand.sData.id)+'</div>'
      +'<input id="expo-picker-q" placeholder="Rechercher…" style="margin:10px 14px;padding:6px 8px;border:1px solid #d0d0d0;border-radius:4px;font-size:12px">'
      +'<div id="expo-picker-list" style="overflow:auto;padding:0 6px 10px"></div></div>';
    document.body.appendChild(ov);
    var list=ov.querySelector('#expo-picker-list'), q=ov.querySelector('#expo-picker-q');
    function draw(){
      var term=(q.value||'').toLowerCase();
      list.innerHTML=EXPOS.filter(function(e){return String(e.name||'').toLowerCase().indexOf(term)>=0;}).map(function(e){
        var meta=(e.hall||'')+(e.stand||'')||e.country||'';
        return '<div class="expo-pick" data-id="'+esc(e.id)+'" style="padding:6px 8px;cursor:pointer;border-radius:4px" onmouseover="this.style.background=\'#f2f2f2\'" onmouseout="this.style.background=\'transparent\'">'
          +'<b>'+esc(e.name)+'</b><div style="font-size:10px;color:#888">'+esc(meta)+'</div></div>';
      }).join('')||'<div style="padding:10px;color:#888">Aucun exposant</div>';
    }
    draw();
    q.addEventListener('input',draw);
    ov.addEventListener('click',function(ev){
      if(ev.target===ov){ ov.remove(); return; }
      var it=ev.target.closest('.expo-pick'); if(!it) return;
      var expo=EXPOS.filter(function(e){return String(e.id)===it.dataset.id;})[0];
      ov.remove();
      if(!expo) return;
      var grp=vcGetStandGroup(stand.sData.id);
      if(grp && !_vcIsolatedStand){
        vcLayers.stands.forEach(function(o){
          if(o.sData && grp.standIds.indexOf(o.sData.id)>=0) vcAssign(o,expo);
        });
      } else {
        vcAssign(stand,expo);
      }
    });
    q.focus();
  }

  // ── Context Menu (right-click) ──
  var _ctxTarget = null;
  function getCtxMenu(){ return document.getElementById('ctx-menu'); }

  function ctxItem(label, icon, action){
    return '<div class="ctx-item" data-action="'+action+'" style="padding:6px 14px;cursor:pointer;display:flex;align-items:center;gap:8px;color:#333;transition:background .1s"'
      +' onmouseover="this.style.background=\'#f2f2f2\'" onmouseout="this.style.background=\'transparent\'">'
      +'<span style="width:16px;text-align:center;font-size:13px">'+icon+'</span>'+label+'</div>';
  }
  function ctxSep(){
    return '<div style="height:1px;background:#e0e0e0;margin:3px 0"></div>';
  }

  function showCtxMenu(x, y, obj){
    _ctxTarget = obj;
    var html = '';
    var isStand = obj && obj.sData;
    var sid = isStand ? obj.sData.id : null;
    var isAssigned = sid && vcAssigns[sid];

    if(isStand){
      html += ctxItem('Éditer le stand', '✏️', 'edit');
      html += ctxItem('Ajouter un exposant', '👤', 'addexpo');
      if(isAssigned){
        html += ctxItem('Désassigner', '🔓', 'unassign');
      }
      html += ctxSep();
    }
    html += ctxItem('Dupliquer', '📋', 'duplicate');
    html += ctxItem('Amener devant', '⬆', 'bringfront');
    html += ctxItem('Envoyer derrière', '⬇', 'sendback');
    html += ctxSep();
    html += ctxItem('Supprimer', '🗑️', 'delete');

    var cm = getCtxMenu();
    cm.innerHTML = html;
    cm.style.display = 'block';

    // Position: keep inside viewport
    var mw = cm.offsetWidth, mh = cm.offsetHeight;
    var wx = window.innerWidth, wh = window.innerHeight;
    if(x + mw > wx) x = wx - mw - 4;
    if(y + mh > wh) y = wh - mh - 4;
    cm.style.left = x + 'px';
    cm.style.top = y + 'px';
  }

  function hideCtxMenu(){
    var cm = getCtxMenu();
    if(cm) cm.style.display = 'none';
    _ctxTarget = null;
  }

  // Handle context menu item clicks
  getCtxMenu().addEventListener('click', function(e){
    var item = e.target.closest('[data-action]');
    if(!item) return;
    var action = item.dataset.action;
    var obj = _ctxTarget;
    hideCtxMenu();
    if(!obj) return;

    switch(action){
      case 'edit':
        if(obj.sData){ vc.setActiveObject(obj); vcSelStand=obj; renderDetail(obj); openStandEdit(); }
        break;
      case 'addexpo':
        if(obj.sData) openExpoPicker(obj);
        break;
      case 'unassign':
        if(obj.sData) vcUnassign(obj.sData.id);
        break;
      case 'duplicate':
        // Handle multi-selection (ActiveSelection) by duplicating each child
        var _dupObjs = (obj.type === 'activeSelection') ? obj.getObjects().slice() : [obj];
        var _dupNewObjs = [];
        var _dupDone = 0;
        _dupObjs.forEach(function(src){
          // Get absolute position (inside ActiveSelection, left/top are relative)
          var absLeft = src.left, absTop = src.top;
          if(obj.type === 'activeSelection'){
            var m = src.calcTransformMatrix();
            var w = (src.width||0)*(src.scaleX||1), h = (src.height||0)*(src.scaleY||1);
            absLeft = m[4] - w/2; absTop = m[5] - h/2;
          }
          src.clone(function(cloned){
            cloned.set({left: absLeft + 20, top: absTop + 20});
            if(src.sData){
              vcStandN++;
              var newId='S-'+vcStandN;
              cloned.sData = Object.assign({}, src.sData, {id:newId, num:newId});
              var items=cloned.getObjects?cloned.getObjects():[];
              if(items[1]) items[1].set('text', newId);
            }
            if(src._layer){
              cloned._layer = src._layer;
              if(vcLayers[src._layer]) vcLayers[src._layer].push(cloned);
            }
            vc.add(cloned);
            _dupNewObjs.push(cloned);
            _dupDone++;
            if(_dupDone === _dupObjs.length){
              // Select all duplicated objects
              if(_dupNewObjs.length === 1){
                vc.setActiveObject(_dupNewObjs[0]);
              } else {
                vc.discardActiveObject();
                var sel = new fabric.ActiveSelection(_dupNewObjs, {canvas: vc});
                vc.setActiveObject(sel);
              }
              vc.renderAll();
              updateVcStatus();
            }
          }, ['_layer','_hall','_bg','sData','_aisle','_wall','_meas','_measData']);
        });
        break;
      case 'bringfront':
        vc.bringToFront(obj); vc.renderAll();
        break;
      case 'sendback':
        // Send back but keep hall border behind
        vc.sendToBack(obj);
        vc.getObjects().filter(function(o){return o._hall;}).forEach(function(o){vc.sendToBack(o);});
        vc.renderAll();
        break;
      case 'delete':
        if(obj._hall||obj._bg) break;
        if(obj.sData){
          delete vcAssigns[obj.sData.id];
          vcLayers.stands=vcLayers.stands.filter(function(s){return s!==obj;});
          var delSid=obj.sData.id;
          vcGroups.forEach(function(g){ g.standIds=g.standIds.filter(function(id){return id!==delSid;}); });
          vcGroups=vcGroups.filter(function(g){return g.standIds.length>0;});
        }
        if(obj._layer && vcLayers[obj._layer]){
          vcLayers[obj._layer]=vcLayers[obj._layer].filter(function(o){return o!==obj;});
        }
        vc.remove(obj);
        rebuildGroupOverlays();
        vc.discardActiveObject(); vc.renderAll(); updateVcStatus(); vcDesel();
        break;
    }
  });

  // Close on click elsewhere
  document.addEventListener('click', function(){ hideCtxMenu(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') hideCtxMenu(); });

  // ── Expose functions to window for inline onclick handlers ──
  var _exposedFns = [
    'switchTab','doUndo','openBgModal','syncPxToVc','syncVcToPx','openRtypesAdmin',
    'toggleExportMenu','doExport','setCellM','setPxTool','setPxCol','setPxZoom','setPxZoomPct',
    'setVcTool','setVcLayer','setVcZoom','fitVc','clearPx','pxToggleVis','pxSetOp',
    'bgShowImport','bgApply','bgApplyResize','bgRemove','bgModalClose','bgToggleVis',
    'bgToggleLock','bgSetOp','bgFileChosen','bgPreviewResize','bgHandleDrop',
    'hallChanged','syncColorHex','renderExp','clickExp',
    'closeM','confirmStand','openStandEdit','confirmStandEdit','confirmText',
    'grpAskCreate','confirmGroupCreate','confirmGroupEdit','openGroupEdit',
    'modHideForms','modLayerAskDelete','modLayerDeleteConfirmed',
    'modLayerFork','modLayerForkFrom','modLayerRenameUI',
    'modNameFormCancel','modNameFormConfirm',
    'rtypeSave','rtypeCancelEdit',
    'vcLayerToggleVis','vcLayerToggleLock','vcLayerSetOp',
    'pxZoomIn','pxZoomOut','fitPx','fitPxContent','vcZoomIn','vcZoomOut','vcZoomHalf','vcZoomDouble','vcZoomQuad',
    'vcSetStandType','vcHighlightRtype',
    'vcTypeToggleVis','vcTypeToggleLock','vcTypeSetOp'
  ];
  var _fnRefs = {
    switchTab:switchTab, doUndo:doUndo, openBgModal:openBgModal,
    syncPxToVc:syncPxToVc, syncVcToPx:syncVcToPx, openRtypesAdmin:openRtypesAdmin,
    toggleExportMenu:toggleExportMenu, doExport:doExport, setCellM:setCellM,
    setPxTool:setPxTool, setPxCol:setPxCol, setPxZoom:setPxZoom, setPxZoomPct:setPxZoomPct,
    setVcTool:setVcTool, setVcLayer:setVcLayer, setVcZoom:setVcZoom,
    fitVc:fitVc, clearPx:clearPx, pxToggleVis:pxToggleVis, pxSetOp:pxSetOp,
    bgShowImport:bgShowImport, bgApply:bgApply, bgApplyResize:bgApplyResize,
    bgRemove:bgRemove, bgModalClose:bgModalClose, bgToggleVis:bgToggleVis,
    bgToggleLock:bgToggleLock, bgSetOp:bgSetOp, bgFileChosen:bgFileChosen,
    bgPreviewResize:bgPreviewResize, bgHandleDrop:bgHandleDrop,
    hallChanged:hallChanged, syncColorHex:syncColorHex, renderExp:renderExp,
    clickExp:clickExp,
    closeM:closeM, confirmStand:confirmStand, openStandEdit:openStandEdit,
    confirmStandEdit:confirmStandEdit, confirmText:confirmText,
    grpAskCreate:grpAskCreate, confirmGroupCreate:confirmGroupCreate,
    confirmGroupEdit:confirmGroupEdit, openGroupEdit:openGroupEdit,
    modHideForms:modHideForms, modLayerAskDelete:modLayerAskDelete,
    modLayerDeleteConfirmed:modLayerDeleteConfirmed,
    modLayerFork:modLayerFork, modLayerForkFrom:modLayerForkFrom,
    modLayerRenameUI:modLayerRenameUI,
    modNameFormCancel:modNameFormCancel, modNameFormConfirm:modNameFormConfirm,
    rtypeSave:rtypeSave, rtypeCancelEdit:rtypeCancelEdit,
    vcLayerToggleVis:vcLayerToggleVis, vcLayerToggleLock:vcLayerToggleLock,
    vcLayerSetOp:vcLayerSetOp,
    pxZoomIn:pxZoomIn, pxZoomOut:pxZoomOut, fitPx:fitPx, fitPxContent:fitPxContent,
    vcZoomIn:vcZoomIn, vcZoomOut:vcZoomOut, vcZoomToSlider:vcZoomToSlider,
    vcZoomHalf:vcZoomHalf, vcZoomDouble:vcZoomDouble, vcZoomQuad:vcZoomQuad,
    vcSetStandType:vcSetStandType, vcHighlightRtype:vcHighlightRtype,
    vcTypeToggleVis:vcTypeToggleVis, vcTypeToggleLock:vcTypeToggleLock, vcTypeSetOp:vcTypeSetOp
  };
  _exposedFns.forEach(function(name){ window[name] = _fnRefs[name]; });

  // ── Init calls (replacing window.onload) ──
  buildVcLayersList();
  initPx();
  try { initVc(); } catch(e){ console.error('[FloorMapEngine] initVc failed:', e); }

  var pxArea = document.getElementById('px-area');
  if(pxArea) pxArea.addEventListener("scroll", drawPxRulers);

  // Zoom sliders — use addEventListener instead of inline oninput (inline handlers
  // don't resolve closure-scoped functions reliably inside innerHTML containers)
  var _pxZSlider = document.getElementById('px-zslider');
  if(_pxZSlider) _pxZSlider.addEventListener('input', function(){ setPxZoomPct(+this.value); });
  var _vcZSliderR = document.getElementById('vc-zslider-r');
  if(_vcZSliderR) _vcZSliderR.addEventListener('input', function(){ vcZoomToSlider(+this.value); });

  var _ret = {
    getState: function() {
      // Sync current live state into MOD_LAYERS before returning
      modLayerSaveCurrent();
      return { hallW, hallH, cellM, grid, sepH, sepV, RTYPES, vcAssigns, vcGroups, MOD_LAYERS, activeModLayer, activeTab, vc: typeof vc !== 'undefined' ? vc : null };
    },
    setState: function(data) {
      _stateLoading=true;
      if(data.hallW!=null) hallW=data.hallW;
      if(data.hallH!=null) hallH=data.hallH;
      if(data.cellM!=null) cellM=data.cellM;
      if(data.grid) grid=data.grid;
      if(data.sepH) sepH=data.sepH;
      if(data.sepV) sepV=data.sepV;
      if(data.RTYPES&&data.RTYPES.length){
        RTYPES=data.RTYPES;
        // Ensure default types are present (add missing ones)
        DEFAULT_RTYPES.forEach(function(def){
          if(!RTYPES.find(function(r){return r.key===def.key;})){
            RTYPES.push({key:def.key,color:def.color,name:def.name});
          }
        });
        // Re-inject exhibitor-derived region types that may be missing from saved data
        var _regPal2=['#5b6cf9','#f59e0b','#34d399','#f472b6','#8b5cf6','#06b6d4','#ef4444','#84cc16','#a855f7','#14b8a6','#e11d48','#0ea5e9','#d946ef','#22c55e','#eab308'];
        var _pi2=RTYPES.filter(function(r){return r.key!=='aisle'&&r.key!=='wall';}).length;
        var _seen2={};
        RTYPES.forEach(function(r){ _seen2[r.name.toLowerCase()]=true; });
        EXPOS.forEach(function(ex){
          if(!ex.tagL) return;
          var lname=ex.tagL.toLowerCase();
          if(_seen2[lname]) return;
          _seen2[lname]=true;
          var key=lname.replace(/\s+/g,'-').replace(/[^a-z0-9\u00C0-\u017F\-]/g,'');
          if(!key) key='region-'+_pi2;
          var bk=key,sf=0;
          while(RTYPES.find(function(r){return r.key===key;})){ sf++; key=bk+'-'+sf; }
          var color=_regPal2[_pi2%_regPal2.length]; _pi2++;
          // RTYPES.push({key:key,color:color,name:ex.tagL});
        });
        // Re-sync expo tags with updated RTYPES
        EXPOS.forEach(function(ex){
          if(!ex.tagL) return;
          var lname=ex.tagL.toLowerCase();
          var rt=RTYPES.find(function(r){return r.name.toLowerCase()===lname&&r.key!=='aisle'&&r.key!=='wall';});
          if(rt) ex.tag=rt.key;
        });
      }
      // Sync STAND_C with loaded RTYPES colours
      RTYPES.forEach(function(r){ if(r.key!=='aisle'&&r.key!=='wall') STAND_C[r.key]={fill:hexToRgba(r.color,0.12),stroke:r.color}; });
      if(data.vcAssigns) vcAssigns=(Array.isArray(data.vcAssigns)?{}:data.vcAssigns);
      if(data.vcGroups) vcGroups=data.vcGroups;
      if(data.activeModLayer!=null) activeModLayer=data.activeModLayer;
      if(data.MOD_LAYERS){ MOD_LAYERS=data.MOD_LAYERS; if(activeModLayer>=MOD_LAYERS.length) activeModLayer=0; renderModTabs(); modTypeStateLoad(MOD_LAYERS[activeModLayer]); }
      // Sync hall dimension fields with loaded values
      var _hw=document.getElementById('hw'); if(_hw) _hw.value=hallW;
      var _hh=document.getElementById('hh'); if(_hh) _hh.value=hallH;
      var _hcm=document.getElementById('hcm'); if(_hcm) _hcm.value=cellM;
      var _hi=document.getElementById('h-info');
      if(_hi) _hi.innerHTML='Surface : <b>'+(hallW*hallH).toLocaleString('fr')+'m\u00b2</b>';
      var _vhw=document.getElementById('vc-hw'); if(_vhw) _vhw.textContent=hallW;
      var _vhh=document.getElementById('vc-hh'); if(_vhh) _vhh.textContent=hallH;
      if(typeof renderPxCanvas==='function') renderPxCanvas();
      if(typeof renderRtypesList==='function') renderRtypesList();
      if(typeof renderRtypes==='function') renderRtypes();
      if(typeof renderPxLegend==='function') renderPxLegend();
      if(typeof updateStandTypeSelect==='function') updateStandTypeSelect();
      if(typeof syncCellMButtons==='function') syncCellMButtons();
      if(typeof vc!=='undefined'&&vc){
        recalcPxPerM(); rebuildHallBorder(); fitVc();
        vc.renderAll();
      }
      // Apply PX group colors to the grid (pxCells will be recomputed after loadVcJSON)
      _applyPxGroupColorsToGrid();
      if(typeof renderGroupsList==='function') renderGroupsList();
      // Auto-select first zone type color after loading data
      if(RTYPES.length>0 && typeof setPxCol==='function') setPxCol(RTYPES[0].color);
      // Sync live vcAssigns into the active MOD_LAYER to fix legacy saves
      // where MOD_LAYERS[x].vcAssigns was stale/empty
      if(MOD_LAYERS.length>0 && MOD_LAYERS[activeModLayer]){
        MOD_LAYERS[activeModLayer].vcAssigns = JSON.parse(JSON.stringify(vcAssigns));
        MOD_LAYERS[activeModLayer].vcGroups = vcGroups ? JSON.parse(JSON.stringify(vcGroups)) : MOD_LAYERS[activeModLayer].vcGroups || [];
        MOD_LAYERS[activeModLayer].vcStandN = vcStandN || MOD_LAYERS[activeModLayer].vcStandN || 1;
      }
      _stateLoading=false;
    },
    loadVcJSON: function(json, cb) {
      if(typeof vc!=='undefined'&&vc&&json) {
        vcHist=[]; vcHistIdx=-1; // Reset vector undo for fresh load
        _suppressDirty=true;
        _vcLoadingJSON=true;
        _stateLoading=true;
        // Disable per-object renders during loadFromJSON to avoid clearRect errors
        var _oldROAR2=vc.renderOnAddRemove;
        vc.renderOnAddRemove=false;
        vc.loadFromJSON(json, function(){
          vc.renderOnAddRemove=_oldROAR2;
          vcLayers={stands:[],aisles:[],struct:[],annot:[],meas:[]};
          vcBgObj=null;
          vc.getObjects().forEach(function(o){
            if(o._layer&&vcLayers[o._layer]) vcLayers[o._layer].push(o);
            if(o._bg){ vcBgObj=o; bgVisible=o.visible!==false; bgOpacity=o.opacity||0.7; bgLocked=!o.selectable; }
          });
          vcApplyTypeState();
          // Restore pxPerM from the saved hall border so that the next
          // recalcPxPerM computes the correct old→new ratio and does not
          // distort the loaded objects.
          var hallObj = vc.getObjects().find(function(o){ return o._hall; });
          if(hallObj && hallW > 0){
            pxPerM = hallObj.width / hallW;
          }
          // Restore bgImg/bgDataUrl from loaded fabric.Image so Background modal works on reload
          if(vcBgObj){
            var _bgEl=vcBgObj._element||(vcBgObj.getElement?vcBgObj.getElement():null);
            if(_bgEl){
              bgImg=_bgEl;
              try{ bgDataUrl=_bgEl.src||vcBgObj.toDataURL(); }catch(e){ bgDataUrl=null; }
              // Restore real-world dimensions from the image's pixel size on canvas
              bgRealW=Math.round(pxToM(vcBgObj.width*(vcBgObj.scaleX||1))*10)/10 || hallW;
              bgRealH=Math.round(pxToM(vcBgObj.height*(vcBgObj.scaleY||1))*10)/10 || hallH;
            }
            bgSyncUI();
            bgRedrawPx();
          }
          // Rebuild stand text/stroke scaling for current pxPerM
          vcLayers.stands.forEach(function(grp){
            var items=grp.getObjects();
            var r=items[0]; if(!r||r.type!=='rect') return;
            var w=r.width, h=r.height;
            var mp=Math.min(w,h);
            var _sw2=Math.max(0.3,Math.min(2,mp*.04));
            var _showNum2=mp>4, _showDim2=mp>18;
            var _fs2,_fss2;
            if(_showDim2){_fs2=Math.max(5,Math.min(16,mp*.18));_fss2=Math.max(4,Math.min(10,mp*.11));}
            else{_fs2=Math.max(4,Math.min(16,mp*.28));_fss2=4;}
            r.set({strokeWidth:_sw2, rx:0});
            var lb=items[1], dm=items[items.length-1], ex=items.length>=4?items[2]:null;
            if(_isText(lb)){
              lb.set({text:_showNum2?(grp.sData?grp.sData.num:''):'', fontSize:_fs2});
            }
            if(_isText(dm)){
              var _wM2=grp.sData?grp.sData.wm:'', _hM2=grp.sData?grp.sData.hm:'';
              dm.set({text:_showDim2?_wM2+'×'+_hM2+'m':'', fontSize:_fss2});
            }
            if(!ex){
              var _c4=grp.sData?getStandColor(grp.sData.type):{stroke:'#000'};
              var _exFs3=Math.max(3,Math.min(11,mp*.13));
              ex=new fabric.Textbox('',{left:w/2,top:h/2,originX:'center',originY:'center',fontSize:_exFs3,fill:_c4.stroke+'cc',fontFamily:'system-ui',fontWeight:'600',width:w*0.9,textAlign:'center',splitByGrapheme:false,editable:false});
              grp.insertAt(ex,2);
            }
            _layoutStandLabels(lb,ex,dm,w,h);
            if(!grp.clipPath){
              grp.set({width:w, height:h});
              grp.clipPath=new fabric.Rect({width:w, height:h, originX:'center', originY:'center'});
            }
            grp.setCoords();
          });
          // Re-apply exhibitor name labels + lock state for assigned stands
          vcLayers.stands.forEach(function(grp){
            if(!grp.sData) return;
            var _a=vcAssigns[grp.sData.id];
            if(_a && _a.expo){
              var _items=grp.getObjects();
              var _lbl=grp.sData.num||'';
              if(grp.sData.hall) _lbl=grp.sData.hall+_lbl;
              if(_isText(_items[1])) _items[1].set('text', _lbl);
              var _exSlot2=_items.length>=4?_items[2]:null;
              if(_isText(_exSlot2)) _exSlot2.set('text', _a.expo.name||'');
              var _r3=_items[0]; if(_r3) _layoutStandLabels(_items[1],_exSlot2,_items[_items.length-1],_r3.width,_r3.height);
              if(_a.status==='locked') grp.set({lockMovementX:true, lockMovementY:true});
            }
          });
          _vcLoadingJSON=false;
          _stateLoading=false;
          // Strip stale group overlay objects from loaded JSON, then rebuild fresh
          vcStripOverlays();
          vcInitStandAbsPos(true); // force refresh _ax/_ay from actual positions
          vcGroups.forEach(function(g){ vcApplyGroupColor(g); });
          rebuildGroupOverlays();
          // If there are converted PX groups, silently resync grid from current VC positions
          var _hasConvertedGroups = vcGroups.some(function(g){ return g.isPxGroup && g.standIds && g.standIds.length > 0; });
          if(_hasConvertedGroups){
            _doVcToPxData();
          }
          // Recompute pxCells for converted groups using current VC stand positions
          _recomputeConvertedGroupPxCells();
          _applyPxGroupColorsToGrid();
          if(activeTab==='px'){ drawPx(); renderGroupsList(); }
          if(vcBgObj) bgSyncUI();
          vc.renderAll();
          renderExp(); updateVcStatus();
          _suppressDirty=false;
          if(cb)cb();
        });
      }
    },
    getVcJSON: function() {
      if(typeof vc!=='undefined'&&vc) return vc.toJSON(['_layer','_hall','_bg','sData','_aisle','_wall','_meas','_measData','_groupOverlay']);
      return null;
    },
    // Called before serialize — persist current moderator layer state
    prepareForSave: function(){
      modLayerSaveCurrent();
    },
    resize: function() {
      if(activeTab==='px') {
        drawPxRulers();
        drawPxPreview();
      } else if(activeTab==='vc' && typeof vc!=='undefined' && vc) {
        var area=document.getElementById('vc-area');
        if(area) {
          var W=Math.max(400,area.clientWidth), H=Math.max(300,area.clientHeight);
          vc.setWidth(W); vc.setHeight(H); vc.calcOffset();
          recalcPxPerM(); drawVcRulers(); updateSBar();
          vc.renderAll();
        }
      }
    },
    switchTab: switchTab,
    updateExpos: updateExpos,
    destroy: function() {
      _exposedFns.forEach(function(name){ delete window[name]; });
      document.getElementById = _origGetById;
      if(typeof vc!=='undefined'&&vc) try{vc.dispose();}catch(e){}
    },
    get onDirtyChange(){ return _dirtyNotify; },
    set onDirtyChange(fn){ _dirtyNotify=fn; }
  };

  return _ret;
}
